import React from "react"

export type IconType =
    | "LOCATION"
    | "PIE"
    | "CLOSE_ARROW"
    | "PENCIL"
    | "OUTLINE"
    | "TIMER"
    | "REPEAT"
    | "SORT_SOLID"
    | "SORT_UP_SOLID"
    | "SORT_DOWN_SOLID"
    | "SENT"
    | "VIEWED"
    | "DONE"
    | "OPTIONS"
    | "FILE"
    | "FILE_CREATE"
    | "DOLLAR_SIGN"
    | "DOLLAR_SIGN_FILL"
    | "CALENDAR"
    | "CALENDAR_INPUT"
    | "PROFILE"
    | "PROFILE_LINE"
    | "SEND"
    | "COPY"
    | "ADD"
    | "ADD_CIRCLE"
    | "EDIT"
    | "EDIT_LINE"
    | "CERTIFICATE"
    | "WARNING"
    | "WARNING_SOLID"
    | "SMALL_PROFILE"
    | "MORE_HORZ"
    | "ARROW_RIGHT"
    | "ARROW_DOWN"
    | "ARROW_LEFT"
    | "CHECKED"
    | "LIBRARY"
    | "PACKAGE"
    | "PAPER_PLANE"
    | "WARNING_TRIANGLE"
    | "WARNING_TRIANGLE_FILL"
    | "PEOPLE"
    | "BAR_CHART"
    | "PERSON"
    | "SETTINGS"
    | "CLOSE"
    | "PLUS"
    | "PLUS_CIRCLE"
    | "DELETE"
    | "UNORDER_LIST"
    | "SCAN_TASK"
    | "DIGITAL_DOCUMENT_TASK"
    | "EYE"
    | "EYE_CROSSED_LINE"
    | "BACK"
    | "CHECK_LIST"
    | "STUDENT_ICON"
    | "STAFF_ICON"
    | "NOTIFY"
    | "DUPLICATE"
    | "HAND"
    | "QUESTION"
    | "SEARCH"
    | "MEN_WOMEN"
    | "CLOUD_UPLOAD"
    | "ARROW_LEFT_CIRCLE"
    | "ARROW_RIGHT_CIRCLE"
    | "INFO"
    | "FILE_EMPTY"
    | "BULB"
    | "CLIPBOARD"
    | "ARCHIVE_FILL"
    | "ACTIVE"
    | "INACTIVE"
    | "PRIVACY_POLICY"
    | "ALERT"
    | "ALERT_CIRCLE"
    | "ALERT_CIRCLE_FILL"
    | "USERS"
    | "WHITE_INFO"
    | "WHITE_CALENDAR"
    | "CLOCK"
    | "PIN"
    | "BOARD_PIN"
    | "BOARD_PIN_FILLED"
    | "BOOKMARK"
    | "BELL"
    | "ACTIVE_WITH_STROKE"
    | "CROSS_CIRCLE"
    | "PROGRAM"
    | "MORE_VERTICAL"
    | "SCHEDULE"
    | "CALENDAR_FILL"
    | "BOX"
    | "TIME_CLOCK_OUTLINE"
    | "NOTES"
    | "USERS_PARTICIPANTS"
    | "CHEVRON_DOWN"
    | "TURN_OFF"
    | "LOGOUT"
    | "COURSE"
    | "PROFILE_FILL"
    | "CONTACT"
    | "LOCK_ACCESS"
    | "LOCK_ACCESS_FILL"
    | "ATTACH"
    | "FILTER"
    | "DOOR"
    | "EMOJI"
    | "USER"
    | "FORWARD"
    | "SETTINGS_2"
    | "EMOJI_2"
    | "SHARE"
    | "SHARE_LINE"
    | "TRASH_LINE"
    | "PUSH_PIN"
    | "MESSAGE_READ"
    | "MESSAGE_UNREAD"
    | "MINUS"
    | "CONTACT_1"
    | "LDA"
    | "PERSON_FILL"
    | "PERSON_REMOVE"
    | "CLIPBOARD_FILL"
    | "FILE_LINE_ALT"
    | "COMPLETE"
    | "COMPLETED"
    | "TICK"
    | "MESSAGE"
    | "EMAIL"
    | "EMAIL_FILL"
    | "PHONE"
    | "LOCATION_FILL"
    | "CONTACT_FAMILY"
    | "CONTACT_MEDICAL"
    | "CONTACT_HOME"
    | "ADD_CIRCLE_BLUE"
    | "RIGHT_OUTLINED"
    | "LEFT_OUTLINED"
    | "VERTICAL_LEFT_OUTLINED"
    | "VERTICAL_RIGHT_OUTLINED"
    | "SKIP_PAGE_LEFT"
    | "SKIP_PAGE_RIGHT"
    | "ARROW_RIGHT_1"
    | "DOWNLOAD"
    | "DOOR_OPEN"
    | "DOOR_OPEN_1"
    | "TARGET"
    | "LOCK_CHECKMARK"
    | "RATES"
    | "WORK"
    | "BLUB"
    | "COPY_SMALL"
    | "POINTS_BIG"
    | "ADMISSION_START_DATE"
    | "EXPAND"
    | "FILE_TEXT"
    | "CHECK_CIRCLE"
    | "CALENDAR_FILL_INPUT"
    | "CHECKMARK_CIRCLE"
    | "CROSS_CIRCLE_FILL"
    | "CHECKMARK_CIRCLE_1"
    | "UPLOAD"
    | "ALERT_WHITE"
    | "VOL"
    | "UNION"
    | "CHECKBOX_CHECKED"
    | "COLUMNS"
    | "PIE_CHART"
    | "ARROW_UP_FILL"
    | "ARROW_DOWN_FILL"
    | "EVENT"
    | "ACADEMIC"
    | "FIN_AID_FILL"
    | "PERSON_ADD"
    | "BELL_LINE"
    | "LOCK_LINE"
    | "APPOINTMENT"
    | "UNREAD"
    | "PERSONS"
    | "FILE_ADD"
    | "FILE_REMOVE"
    | "FACE_SCAN_FILL"
    | "SIGN_HAND_DRAWN"
    | "TEXT"
    | "GRID_FILL"
    | "HOME"
    | "COMMUNICATION"
    | "INSTRUCTIONAL"
    | "SETTINGS_FILL"
    | "SCHOOL_FILL"
    | "INITIALS"
    | "GRADE"
    | "PERSON_CONTACT"
    | "CAMERA"
    | "UPLOAD_THIN"
    | "PERSON_DONE"
    | "MESSAGE_CIRCLE"
    | "MESSAGE_CIRCLE_LINE"
    | "TASK_FILL"
    | "PLAY_VIDEO"
    | "NEWS"
    | "CLIENTS"
    | "DOCUMENT"
    | "TYPE_FILL"
    | "TYPE_LINE"
    | "ADMISSIONS_FILL"
    | "STAR_FILL"
    | "OPEN_BOOK"
    | "RESCHEDULE"
    | "ICON_EXPEND"
    | "SELECT_ALL"
    | "DESELECT_ALL"
    | "CIRCLE_DOWN"
    | "ISIR"
    | "FILE_CHECK"
    | "LOCK_CHECK"
    | "WORKFLOW"
    | "PROFILE_FILL_CIRCLE"
    | "DETAIL_FILL_CIRCLE"
    | "APPOINTMENT_FILL_CIRCLE"
    | "MESSAGE_FILL_CIRCLE"
    | "CHECK_DOUBLE"
    | "REFUND"
    | "OP_EQUALS"
    | "OP_PLUS"
    | "OP_MINUS"
    | "OP_DEVIDE"
    | "OP_MULTIPLY"
    | "DISABLE"
    | "PEN_FILL"
    | "QUESTION_OPEN"
    | "GLOBE"
    | "CHECKIN_FILL"
    | "CHECKOUT_FILL"
    | "GPA"
    | "CREDIT_CARD"
    | "STUDENTS_IN_CLASS"
    | "PARTICIPATION"
    | "SAP_PASS"
    | "SAP_FAIL"
    | "LINK"
    | "EXPAND_NEW_WINDOW"
    | "VIEW_DETAILS"
    | "VIEW_LIST"
    | "VIEW_LIST_COLUMNS"
    | "CONFIRM_INFO"
    | "DOCUMENT_FILL_CIRCLE"
    | "REFRESH"
    | "SEND_VIA_EMAIL"
    | "WATCH_VIDEO"
    | "STICKY_NOTE"
    | "ID_BADGE"
    | "QR_LINE"
    | "EYE_VIEW_PERSON"
    | "ARROW_LEFT_LINE"
    | "ACTIVE_LESSON"
    | "BREAK_END"
    | "BREAK_START"
    | "RECORD_START"
    | "RECORD_STOP"
    | "AWARD_FILL"
    | "LESSON_IN_PROGRESS"
    | "LESSON_NOT_STARTED"
    | "LESSON_ENDED_NOT_VERIFY"
    | "TERM_COURSES_COURSES"
    | "TERM_COURSES_HOURS"
    | "TERM_COURSES_STARTING_DAY"
    | "TERM_COURSES_STUDENTS"
    | "CALENDAR_ATTENDANCE"
    | "ATTENDANCE_OUT"
    | "ATTENDANCE_IN"
    | "NOTES_ATTENDANCE"
    | "PAUSE"
    | "RESUME"
    | "CHAT_LINE"
    | "SMS"
    | "PLUS_PERSON"
    | "IN_CLASS"
    | "OUT_CLASS"
    | "REGISTERED"
    | "TOTAL_DROP"
    | "ARROW_CIRCLE_RIGHT"
    | "REPLY"
    | "FOLLOW_UP"
    | "TRENDING_UP"
    | "IMAGE"
    | "EDIT_SIGNATURE"
    | "CROSS_CIRCLE_BORDER"
    | "ATTENDANCE_QR_CODE"
    | "SIGN_MAKEUP_ATTENDANCE"
    | "SUPPORT_HUB"
    | "VIEW_BLOCKS"
    | "CHECKLIST"
    | "DEVICE_PHONE"
    | "FILE_UP"
    | "DECIMAL_INCREASE"
    | "DECIMAL_DECREASE"
    | "QUICKBOOKS"
    | "KNOWLEDGE"
    | "APPROVE"
    | "DIALPAD"
    | "SOUND_OFF"
    | "SOUND_ON"
    | "PERSON_CROSS"
    | "SYNC_ERROR"

export type Props = {
    icon: IconType
    className?: string
    color?: string
    size?: number
    onClick?: () => void
}

export function Icon({className, icon, color, size, onClick}: Props) {
    const fillColor = color || "#1E90FF"

    switch (icon) {
        case "LOGOUT":
        case "TURN_OFF": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M15.24 3.54c.254-.492.858-.684 1.35-.43l.322.174c1.695.955 3.077 2.387 3.972 4.12 2.535 4.907.613 10.94-4.294 13.475s-10.94.612-13.474-4.295C.58 11.678 2.503 5.645 7.41 3.11l.107-.048c.47-.177 1.007.022 1.243.478.254.492.062 1.096-.43 1.35l-.291.158c-1.342.765-2.437 1.904-3.147 3.28-2.027 3.926-.488 8.752 3.438 10.779 3.926 2.027 8.752.487 10.779-3.438 2.026-3.926.487-8.752-3.439-10.779l-.1-.06c-.417-.28-.566-.834-.33-1.29zM12 1c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1l-.117-.007c-.497-.057-.883-.48-.883-.993V2c0-.552.448-1 1-1z"
                        />
                    </g>
                </svg>
            )
        }
        case "TERM_COURSES_COURSES": {
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.544 17.012c-.407-.406-.195-.291-1.175-.554-.445-.12-.837-.348-1.19-.623l-2.123 5.204a.749.749 0 0 0 .722 1.03l2.465-.093 1.696 1.79a.748.748 0 0 0 1.236-.231l2.435-5.971a3.397 3.397 0 0 1-1.652.448c-.912 0-1.77-.355-2.414-1zm13.365 4.027-2.123-5.204c-.353.275-.745.504-1.19.623-.985.264-.769.149-1.175.554-.645.645-1.502 1-2.415 1a3.4 3.4 0 0 1-1.652-.448l2.436 5.97a.748.748 0 0 0 1.236.233l1.696-1.791 2.465.094a.749.749 0 0 0 .722-1.03zm-5.605-5.085c.715-.728.797-.665 1.815-.943a1.901 1.901 0 0 0 1.332-1.355c.35-1.329.259-1.168 1.214-2.14a1.94 1.94 0 0 0 .487-1.852c-.35-1.328-.35-1.143 0-2.472a1.94 1.94 0 0 0-.487-1.852c-.955-.972-.864-.812-1.214-2.14a1.901 1.901 0 0 0-1.332-1.356c-1.304-.356-1.147-.263-2.103-1.235a1.861 1.861 0 0 0-1.82-.497c-1.303.356-1.121.356-2.428 0A1.86 1.86 0 0 0 8.95.61c-.955.972-.798.88-2.102 1.235A1.901 1.901 0 0 0 5.515 3.2c-.35 1.328-.26 1.168-1.214 2.14a1.94 1.94 0 0 0-.488 1.852c.35 1.327.35 1.142 0 2.471a1.942 1.942 0 0 0 .488 1.852c.955.973.864.812 1.214 2.14a1.901 1.901 0 0 0 1.332 1.357c1.047.285 1.125.24 1.814.942a1.86 1.86 0 0 0 2.327.272 1.856 1.856 0 0 1 1.99 0c.743.47 1.707.358 2.326-.272zM7.57 8.279c0-2.48 1.976-4.492 4.413-4.492 2.438 0 4.414 2.011 4.414 4.492s-1.976 4.492-4.414 4.492c-2.437 0-4.413-2.01-4.413-4.492z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "TERM_COURSES_HOURS": {
            return (
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.5 4h-1V3a1 1 0 1 0-2 0v1h-6V3a1 1 0 1 0-2 0v1h-1a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-12 2h1v1a1 1 0 1 0 2 0V6h6v1a1 1 0 1 0 2 0V6h1a1 1 0 0 1 1 1v4h-14V7a1 1 0 0 1 1-1zm-1 13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6h-14v6zm3.707-3.707a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414zM12.5 15h4a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "TERM_COURSES_STARTING_DAY": {
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm9.66-2.75a1 1 0 0 0-1.41.09l-1.87 2.15-.63-.71a1.002 1.002 0 0 0-1.5 1.33l1.39 1.56a1 1 0 0 0 .75.33 1 1 0 0 0 .74-.34l2.61-3a1 1 0 0 0-.08-1.41zM3 20a7 7 0 1 1 14 0 1 1 0 1 1-2 0 5 5 0 0 0-10 0 1 1 0 1 1-2 0z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "TERM_COURSES_STUDENTS": {
            return (
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm5 13c0 .552-.576 1-1.286 1H4.786c-.71 0-1.286-.448-1.286-1 0-3.866 4.03-7 9-7s9 3.134 9 7z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "LESSON_ENDED_NOT_VERIFY": {
            return (
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.5 2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1.08-6.61 3.78-5h-.01a1.006 1.006 0 0 1 1.6 1.22l-4.57 6a1 1 0 0 1-1.58.01l-2.43-3.11a1.001 1.001 0 0 1 1.58-1.23l1.63 2.11z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "LESSON_NOT_STARTED": {
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 21.625a9.625 9.625 0 1 0 0-19.25 9.625 9.625 0 0 0 0 19.25zM12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
                        fill="#E6E6E6"
                    />
                </svg>
            )
        }
        case "LESSON_IN_PROGRESS": {
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="m17.526 12.698 2.156 2.79c.24.31.838.31 1.078 0l2.156-2.79c.24-.31-.06-.698-.54-.698h-1.46c0-2.314-.799-4.556-2.26-6.344A9.95 9.95 0 0 0 12.9 2.192a9.921 9.921 0 0 0-6.637.989 9.985 9.985 0 0 0-4.506 4.992 10.04 10.04 0 0 0-.33 6.73 9.997 9.997 0 0 0 3.998 5.412 9.926 9.926 0 0 0 12.573-1.244l-.982-.987a8.54 8.54 0 0 1-10.82 1.07 8.602 8.602 0 0 1-3.439-4.656 8.639 8.639 0 0 1 .284-5.79A8.592 8.592 0 0 1 6.919 4.41a8.537 8.537 0 0 1 5.71-.85 8.562 8.562 0 0 1 4.952 2.98A8.627 8.627 0 0 1 19.526 12h-1.46c-.48 0-.78.388-.54.698z"
                        fill="#1E90FF"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11 6a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.8.4l-4-3a.5.5 0 0 1 .6-.8l3.2 2.4V6.5A.5.5 0 0 1 11 6z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "CREDIT_CARD": {
            return (
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity=".01" d="M0 0h32v32H0V0z" fill="#F5F5F5" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.667 9.538c0-1.586 1.194-2.871 2.666-2.871h21.334c1.473 0 2.666 1.285 2.666 2.871v1.436H2.667V9.538zm0 4.308h26.666v8.616c0 1.586-1.193 2.871-2.666 2.871H5.333c-1.472 0-2.666-1.285-2.666-2.871v-8.616zm10.666 5.744h-8v2.872h8V19.59z"
                        fill="#939393"
                    />
                </svg>
            )
        }
        case "USERS_PARTICIPANTS": {
            return (
                <svg viewBox="0 0 25 24" width="24" height="24">
                    <path
                        fill="#62B1FF"
                        fillRule="evenodd"
                        d="M4.107 15.07a7 7 0 0 1 9.9-.02l.205-.15a5 5 0 0 1 7.855 4.1 1 1 0 0 1-1 1h-5a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1l.007-.307a7 7 0 0 1 2.033-4.624zM17.067 7a3 3 0 0 1 0 6l-.177-.005A3 3 0 0 1 14.067 10l.005-.176A3 3 0 0 1 17.067 7zm-8-4a4 4 0 1 1 0 8l-.2-.005A4 4 0 0 1 5.067 7l.005-.2A4 4 0 0 1 9.067 3z"></path>
                </svg>
            )
        }
        case "DISABLE": {
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 21A9 9 0 0 1 5.156 6.156l12.689 12.688A8.965 8.965 0 0 1 12 21zm7.213-3.616A9 9 0 0 0 6.616 4.787l12.597 12.597zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "WARNING_SOLID": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill="#FFF"
                            d="M36.66 26.488L24.196 5.817c-1.658-2.594-5.104-3.353-7.698-1.695-.68.435-1.259 1.014-1.694 1.695L2.34 26.488c-.896 1.493-.927 3.352-.081 4.875.978 1.714 2.803 2.77 4.777 2.762h24.928c1.96.02 3.782-1.008 4.777-2.697.871-1.54.84-3.43-.081-4.94zM19.5 27.625c-.897 0-1.625-.728-1.625-1.625s.728-1.625 1.625-1.625 1.625.728 1.625 1.625-.728 1.625-1.625 1.625zm1.625-6.5c0 .897-.728 1.625-1.625 1.625s-1.625-.728-1.625-1.625v-6.5c0-.897.728-1.625 1.625-1.625s1.625.728 1.625 1.625v6.5z"
                        />
                    </g>
                </svg>
            )
        }
        case "LOCATION": {
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28"
                    className={className}>
                    <path
                        fill="#62B1FF"
                        fillRule="evenodd"
                        d="M14 2.333c-5.118 0-9.282 4.122-9.333 9.24 0 6.383 8.196 13.486 8.573 13.812l.002.002c.437.373 1.08.373 1.517 0 .408-.303 8.575-7.42 8.575-13.814-.052-5.118-4.215-9.24-9.334-9.24zm0 20.592c-1.948-1.855-7-7-7-11.352 0-3.866 3.134-7 7-7s7 3.134 7 7c0 4.317-5.051 9.497-7 11.352zM14 7c-2.255 0-4.083 1.828-4.083 4.084 0 2.255 1.828 4.083 4.083 4.083 2.256 0 4.084-1.828 4.084-4.083C18.084 8.828 16.256 7 14 7zm0 5.834c-.966 0-1.75-.784-1.75-1.75 0-.967.784-1.75 1.75-1.75.967 0 1.75.783 1.75 1.75 0 .966-.783 1.75-1.75 1.75z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "PIE": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                    <path
                        fill="#62B1FF"
                        fillRule="evenodd"
                        d="M15.166 2.333C14.522 2.333 14 2.857 14 3.5v9.334c0 .644.523 1.166 1.167 1.166H24.5c.644 0 1.166-.522 1.166-1.166 0-5.8-4.7-10.5-10.5-10.5zm1.167 9.334V4.749c3.585.516 6.402 3.333 6.918 6.918h-6.918zm6.465 5.442c.217-.606.885-.922 1.492-.706.604.215.921.877.711 1.482-1.174 3.325-3.79 5.94-7.114 7.114-6.075 2.146-12.74-1.038-14.886-7.114C.854 11.81 4.039 5.145 10.115 2.998c.608-.212 1.274.11 1.487.718.213.609-.109 1.275-.717 1.487-2.657.94-4.747 3.03-5.687 5.687-1.719 4.86.827 10.192 5.687 11.912 4.86 1.718 10.192-.827 11.911-5.687l.002-.006z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CIRCLE_DOWN": {
            return (
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="18.333" fill="#F5F5F5" />
                    <path
                        d="M12.175 14.983a1.616 1.616 0 0 0-2.129 0 1.347 1.347 0 0 0 0 2.034l8.89 8c.288.26.672.4 1.064.4s.775-.14 1.064-.4l8.889-8a1.347 1.347 0 0 0 0-2.034 1.616 1.616 0 0 0-2.129 0L20 22.025l-7.825-7.042z"
                        fill="#939393"
                    />
                </svg>
            )
        }
        case "CLOSE_ARROW": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill="#1E90FF"
                            d="M18.77 13.36c-.352-.425-.983-.484-1.408-.132l-.002.002L13 16.86V5c0-.552-.448-1-1-1s-1 .448-1 1v11.86l-4.36-3.63c-.425-.353-1.057-.295-1.41.13s-.295 1.057.13 1.41l6 5 .15.09.13.07c.232.09.488.09.72 0l.13-.07.15-.09 6-5c.425-.352.484-.983.132-1.408l-.002-.002z"
                        />
                    </g>
                </svg>
            )
        }
        case "OUTLINE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill="#62B1FF"
                        fillRule="evenodd"
                        d="M18.667 7H9.333C8.045 7 7 8.045 7 9.333v9.334C7 19.955 8.045 21 9.333 21h9.334C19.955 21 21 19.955 21 18.667V9.333C21 8.045 19.955 7 18.667 7zM9.333 4.667c-2.577 0-4.666 2.089-4.666 4.666v9.334c0 2.577 2.089 4.666 4.666 4.666h9.334c2.577 0 4.666-2.089 4.666-4.666V9.333c0-2.577-2.089-4.666-4.666-4.666H9.333z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "PENCIL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M5.833 21h.105l4.865-.444c.533-.053 1.032-.288 1.412-.665l10.5-10.5c.849-.896.812-2.31-.082-3.161l-3.196-3.197c-.864-.811-2.199-.846-3.104-.082l-10.5 10.5c-.377.38-.612.88-.665 1.412l-.501 4.865c-.032.346.092.688.338.933.22.219.518.34.828.339zM17.815 4.666L21 7.851l-2.333 2.275L15.54 7l2.275-2.334zM5.833 23.333h16.334c.644 0 1.166.522 1.166 1.167 0 .644-.522 1.166-1.166 1.166H5.833c-.644 0-1.166-.522-1.166-1.166 0-.645.522-1.167 1.166-1.167z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "TIMER": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path fill="#62B1FF" d="M0 0h28v28H0V0z" opacity=".01" />
                    <path
                        fill="#62B1FF"
                        fillRule="evenodd"
                        d="M23.333 14c0 5.155-4.178 9.333-9.333 9.333S4.667 19.155 4.667 14 8.845 4.667 14 4.667 23.333 8.845 23.333 14zm2.334 0c0 6.443-5.224 11.667-11.667 11.667S2.333 20.443 2.333 14 7.557 2.333 14 2.333 25.667 7.557 25.667 14zm-10.5-5.833C15.167 7.522 14.644 7 14 7s-1.167.522-1.167 1.167v6.416c0 .645.523 1.167 1.167 1.167h3.5c.644 0 1.167-.522 1.167-1.167 0-.644-.523-1.166-1.167-1.166h-2.333v-5.25z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "REPEAT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M6.895 5.833h14c2.294-.019 4.17 1.825 4.188 4.119v2.881c0 .645-.522 1.167-1.166 1.167-.645 0-1.167-.522-1.167-1.167V9.951c-.02-1.005-.85-1.804-1.855-1.784h-14l1.517 1.505.006.006c.454.458.451 1.197-.006 1.65l-.007.007c-.458.454-1.196.45-1.65-.007l-3.5-3.5-.007-.006c-.453-.458-.45-1.197.007-1.65l3.5-3.5c.457-.458 1.2-.458 1.657 0 .457.457.457 1.199 0 1.656L6.895 5.833zm12.693 10.839c.458-.458 1.2-.458 1.657 0l3.5 3.5.007.006c.454.458.45 1.197-.007 1.65l-3.5 3.5-.007.007c-.457.454-1.196.45-1.65-.007l-.007-.006c-.453-.458-.45-1.197.007-1.65l1.517-1.505h-14c-2.294.019-4.17-1.825-4.188-4.119v-2.881c0-.645.522-1.167 1.166-1.167.645 0 1.167.522 1.167 1.167V18.049c.02 1.005.85 1.804 1.855 1.784h14l-1.517-1.505c-.457-.457-.457-1.199 0-1.656z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "SORT_SOLID":
            return (
                <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="sort"
                    className={className}
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512">
                    <path
                        fill={fillColor}
                        d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path>
                </svg>
            )
        case "SORT_UP_SOLID":
            return (
                <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="sort-up"
                    className={className}
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512">
                    <path
                        fill={fillColor}
                        d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"></path>
                </svg>
            )
        case "SORT_DOWN_SOLID":
            return (
                <svg
                    className={className}
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="sort-down"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512">
                    <path
                        fill={fillColor}
                        d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"></path>
                </svg>
            )
        case "PROFILE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M12 13.596a7 7 0 0 1 7 7l-.007.116a1 1 0 0 1-.993.884H6a1 1 0 0 1-1-1l.004-.241A7 7 0 0 1 12 13.595zm0-10a4 4 0 1 1 0 8l-.2-.005A4 4 0 0 1 8 7.596l.005-.2A4 4 0 0 1 12 3.596z"
                    />
                </svg>
            )
        case "DOLLAR_SIGN":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    className={className}
                    viewBox="0 0 56 56">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M28 2.333c1.289 0 2.333.958 2.333 2.14v6.415h9.334c1.232 0 2.242.877 2.327 1.987l.006.153c0 1.181-1.045 2.139-2.333 2.139h-9.334V25.86l3.5.001c5.703 0 10.343 4.167 10.496 9.36l.004.265c0 5.316-4.7 9.625-10.5 9.625h-3.5v6.417c0 1.13-.955 2.055-2.166 2.133l-.167.006c-1.289 0-2.333-.958-2.333-2.14V45.11L14 45.111c-1.233 0-2.242-.876-2.327-1.986l-.006-.153c0-1.181 1.044-2.139 2.333-2.139h11.667V30.138h-3.5c-5.703 0-10.343-4.166-10.496-9.36l-.004-.264c0-5.316 4.7-9.625 10.5-9.625h3.5V4.471c0-1.13.955-2.055 2.166-2.133zm2.333 38.5h3.5c3.222 0 5.834-2.394 5.834-5.347 0-2.953-2.612-5.347-5.834-5.347h-3.5v10.694zM25.667 25.86V15.166h-3.5c-3.145 0-5.709 2.282-5.83 5.138l-.004.21c0 2.953 2.612 5.347 5.834 5.347h3.5z"
                    />
                </svg>
            )
        case "DOLLAR_SIGN_FILL":
            return (
                <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path
                        d="M13.402 10.286h1.559v4.761h-1.559c-1.434 0-2.597-1.066-2.597-2.38 0-1.316 1.163-2.381 2.597-2.381zM17.039 21.714v-4.762h1.558c1.435 0 2.598 1.066 2.598 2.381 0 1.315-1.163 2.381-2.598 2.381H17.04z"
                        fill={fillColor}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.515 2.667a4.848 4.848 0 0 0-4.848 4.848v16.97a4.849 4.849 0 0 0 4.848 4.848h16.97a4.849 4.849 0 0 0 4.848-4.848V7.515a4.849 4.849 0 0 0-4.848-4.848H7.515zm7.446 2.857V8.38h-1.559c-2.582 0-4.675 1.918-4.675 4.285s2.093 4.286 4.675 4.286h1.559v4.762H9.766c-.574 0-1.039.427-1.039.952 0 .526.465.953 1.04.953h5.194v2.857c0 .526.465.952 1.039.952.574 0 1.039-.426 1.039-.952v-2.857h1.558c2.582 0 4.676-1.919 4.676-4.286 0-2.367-2.094-4.286-4.676-4.286H17.04v-4.761h4.156c.573 0 1.039-.427 1.039-.953s-.466-.952-1.04-.952H17.04V5.524c0-.526-.465-.953-1.04-.953-.573 0-1.038.427-1.038.953z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "SENT":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M20.94 3.73v-.09a1 1 0 0 0-.2-.3 1 1 0 0 0-.29-.19h-.09a.86.86 0 0 0-.31-.15H20a1 1 0 0 0-.3 0l-18 6a1 1 0 0 0 0 1.9l8.53 2.84 2.84 8.53a1 1 0 0 0 1.9 0l6-18A1 1 0 0 0 21 4a1.31 1.31 0 0 0-.06-.27zM16.3 6.29l-5.57 5.57L5.16 10 16.3 6.29zM14 18.84l-1.86-5.57 5.57-5.57L14 18.84z"
                    />
                </svg>
            )
        case "VIEWED":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fill="#FF8A38"
                        fillRule="evenodd"
                        d="M11.73 5c5.98-.18 9.5 5.39 10.14 6.5a1 1 0 0 1 0 1l-.06.103c-.94 1.606-4.13 6.26-9.54 6.397h-.25c-5.89 0-9.26-5.41-9.89-6.5a1 1 0 0 1 0-1l.06-.103C3.14 9.791 6.32 5.137 11.73 5zM12 8.5a3.5 3.5 0 1 0 0 7l.192-.005A3.5 3.5 0 0 0 15.5 12l-.005-.192A3.5 3.5 0 0 0 12 8.5zm1.06 2.44a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12z"
                    />
                </svg>
            )
        case "DONE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fill="#18A957"
                        fillRule="evenodd"
                        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.3 7.61l-4.57 6a1 1 0 0 1-1.58.01l-2.44-3.11a1.001 1.001 0 0 1 1.58-1.23l1.63 2.08 3.78-5a1.006 1.006 0 1 1 1.6 1.22v.03z"
                    />
                </svg>
            )
        case "OPTIONS":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fillRule="evenodd"
                        d="M13.414 10.586a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828zm7 0a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828zm-14 0a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828z"
                    />
                </svg>
            )
        case "FILE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M26.651 9.808l-5.944-6.69a1.34 1.34 0 0 0-.991-.442H9.005A3.387 3.387 0 0 0 5.578 6.02v20.07a3.387 3.387 0 0 0 3.427 3.346h14.567a3.387 3.387 0 0 0 3.427-3.345V10.704c0-.331-.125-.65-.348-.896zm-7.685-4.456l5.007 5.352h-4.016a1.057 1.057 0 0 1-.99-1.137V5.352z"
                    />
                </svg>
            )
        case "FILE_CREATE":
            return (
                <svg
                    className={className}
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.972 38.252h-.128a1.422 1.422 0 0 1-1.422-1.55l.611-5.93c.065-.649.351-1.256.81-1.72l12.798-12.796a2.844 2.844 0 0 1 3.782.099l3.896 3.896a2.73 2.73 0 0 1 .1 3.853L26.621 36.901c-.464.46-1.071.746-1.72.81l-5.93.54zm18.356-16.025-3.882-3.881-2.772 2.843L34.484 25l2.844-2.773z"
                        fill={fillColor}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m21.676 3.912 7.863 8.75c.295.32.46.738.46 1.172v1.75L16.913 28.516a7.187 7.187 0 0 0-.404 9.818H6.199c-2.474.028-4.504-1.93-4.533-4.375V7.709c.03-2.445 2.06-4.404 4.533-4.375h14.167c.5.001.976.211 1.31.578zm4.321 9.922-6.623-7v5.513l-.001.024a1.388 1.388 0 0 0 1.312 1.463h5.312z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "CALENDAR":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M4.628 28.14c0 1.455 1.156 2.635 2.582 2.635h18.935c1.426 0 2.582-1.18 2.582-2.635V13.213h-24.1V28.14zm17.214-10.756c0-.362.29-.659.645-.659h2.152c.355 0 .645.297.645.659v2.195c0 .362-.29.659-.645.659h-2.152a.654.654 0 0 1-.645-.659v-2.195zm0 7.025c0-.363.29-.659.645-.659h2.152c.355 0 .645.296.645.659v2.195c0 .362-.29.658-.645.658h-2.152a.654.654 0 0 1-.645-.658v-2.195zm-6.886-7.025c0-.362.29-.659.645-.659h2.152c.355 0 .646.297.646.659v2.195c0 .362-.29.659-.646.659h-2.152a.654.654 0 0 1-.645-.659v-2.195zm0 7.025c0-.363.29-.659.645-.659h2.152c.355 0 .646.296.646.659v2.195c0 .362-.29.658-.646.658h-2.152a.654.654 0 0 1-.645-.658v-2.195zM8.07 17.384c0-.362.29-.659.646-.659h2.152c.355 0 .645.297.645.659v2.195c0 .362-.29.659-.645.659H8.716a.654.654 0 0 1-.646-.659v-2.195zm0 7.025c0-.363.29-.659.646-.659h2.152c.355 0 .645.296.645.659v2.195c0 .362-.29.658-.645.658H8.716a.654.654 0 0 1-.646-.658v-2.195zm18.075-18.22h-2.582V3.553a.872.872 0 0 0-.86-.878H20.98a.872.872 0 0 0-.86.878v2.634h-6.886V3.554a.872.872 0 0 0-.861-.878h-1.722a.872.872 0 0 0-.86.878v2.634H7.21c-1.426 0-2.582 1.18-2.582 2.635v2.634h24.1V8.823c0-1.455-1.157-2.635-2.583-2.635z"
                        />
                    </g>
                </svg>
            )
        case "CALENDAR_ATTENDANCE":
            return (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity=".01" d="M0 0h20v20H0V0z" fill="#1E90FF" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.555 1.667h4.718V3.53a.671.671 0 1 0 1.342 0V1.667h2.034a2.685 2.685 0 0 1 2.685 2.684v2.295H1.667V4.351a2.685 2.685 0 0 1 2.685-2.684h1.86V3.53a.671.671 0 0 0 1.343 0V1.667zM1.667 7.989v7.921a2.685 2.685 0 0 0 2.685 2.685h11.297a2.685 2.685 0 0 0 2.685-2.685V7.989H1.667zm6.818 4.632c0-.371.3-.671.671-.671h5.476a.671.671 0 1 1 0 1.342H9.156c-.37 0-.67-.3-.67-.671zM5.37 11.95a.671.671 0 1 0 0 1.342h.93a.671.671 0 0 0 0-1.342h-.93z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "CALENDAR_INPUT":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18 4h-1V3c0-.552-.448-1-1-1-.553 0-1 .448-1 1v1H9V3c0-.552-.448-1-1-1-.553 0-1 .448-1 1v1H6C4.343 4 3 5.343 3 7v12c0 1.657 1.343 3 3 3h12c1.657 0 3-1.343 3-3V7c0-1.657-1.343-3-3-3zM6 6h1v1c0 .552.447 1 1 1 .552 0 1-.448 1-1V6h6v1c0 .552.447 1 1 1 .552 0 1-.448 1-1V6h1c.552 0 1 .448 1 1v4H5V7c0-.552.447-1 1-1zm0 14h12c.552 0 1-.448 1-1v-6H5v6c0 .552.447 1 1 1zm2.707-4.707c.39.39.39 1.024 0 1.414-.39.39-1.024.39-1.414 0-.39-.39-.39-1.024 0-1.414.39-.39 1.023-.39 1.414 0zM12 15h4c.552 0 1 .448 1 1s-.448 1-1 1h-4c-.553 0-1-.448-1-1s.447-1 1-1z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "SEND":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        d="M28.58 3.443c-.666-.685-1.653-.94-2.574-.671L4.544 9.012c-.971.27-1.66 1.045-1.845 2.029-.19 1.001.472 2.272 1.337 2.803l6.71 4.125c.689.423 1.577.317 2.147-.258l7.684-7.732c.387-.403 1.027-.403 1.414 0 .387.39.387 1.02 0 1.423l-7.698 7.733c-.57.573-.677 1.466-.257 2.159l4.1 6.778c.48.805 1.307 1.261 2.215 1.261.106 0 .226 0 .333-.013 1.04-.134 1.867-.846 2.174-1.852l6.363-21.435c.28-.913.026-1.906-.64-2.59z"
                    />
                </svg>
            )
        case "COPY":
            return (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9 13v-1a3 3 0 0 1 3-3h1V5.67c0-.37-.3-.67-.67-.67H5.67C5.3 5 5 5.3 5 5.67v6.66c0 .37.3.67.67.67H9zm0 2H5.67A2.68 2.68 0 0 1 3 12.33V5.67A2.68 2.68 0 0 1 5.67 3h6.66A2.68 2.68 0 0 1 15 5.67V9h3a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3v-3zm3-4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "ADD":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32">
                    <path
                        fill="#FF349B"
                        fillRule="evenodd"
                        d="M26.28 7.77L21.91 3.4a2.5 2.5 0 0 0-1.766-.733H9.514a2.508 2.508 0 0 0-2.5 2.504v21.663a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5V9.54c0-.661-.266-1.302-.735-1.77zm-1.178 1.182c.11.11.182.24.219.385h-4.974V4.364a.82.82 0 0 1 .385.219l4.37 4.369zm-.588 18.715h-15a.836.836 0 0 1-.834-.833V5.17c0-.458.375-.833.834-.833h9.166v5.416c0 .692.558 1.25 1.25 1.25h5.417v15.83a.836.836 0 0 1-.833.833zm-2.5-9.373v.416a.627.627 0 0 1-.625.625h-3.542v3.541a.627.627 0 0 1-.625.625h-.417a.627.627 0 0 1-.625-.625v-3.54H12.64a.627.627 0 0 1-.625-.626v-.416c0-.344.28-.625.625-.625h3.541v-3.541c0-.344.282-.625.625-.625h.417c.344 0 .625.281.625.625v3.54h3.542c.343 0 .625.282.625.626z"
                    />
                </svg>
            )

        case "ADD_CIRCLE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="32"
                    fill="none"
                    viewBox="0 0 33 32">
                    <path
                        fill="#FF349B"
                        fillRule="evenodd"
                        d="M16.667 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm5.458 17.625h-3.75v3.75c0 1.035-.84 1.875-1.875 1.875-1.036 0-1.875-.84-1.875-1.875v-3.75h-3.75C9.839 17.625 9 16.785 9 15.75c0-1.036.84-1.875 1.875-1.875h3.75v-3.75c0-1.036.84-1.875 1.875-1.875 1.035 0 1.875.84 1.875 1.875v3.75h3.75c1.035 0 1.875.84 1.875 1.875 0 1.035-.84 1.875-1.875 1.875z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "EDIT":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="32"
                    viewBox="-6 -6 33 32">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M16.323 2.445L14.535.657c-.876-.876-2.294-.876-3.17 0L.827 11.126l-.816 4.947c-.089.539.377 1.005.916.916l4.947-.816 10.47-10.538c.874-.874.882-2.287-.021-3.19zm-9.668 7.9c.143.142.33.214.517.214s.374-.072.516-.214l3.953-3.953.948.95-5.616 5.652v-1.373H5.379v-1.594H4.006l5.653-5.616.948.948-3.952 3.953c-.285.285-.285.747 0 1.033zM2.727 15.21l-.938-.938.403-2.443.61-.607h1.382v1.593h1.593v1.381l-.607.611-2.443.403zm12.584-10.61l-.002.003-.002.001-1.595 1.605-2.922-2.922 1.605-1.595.001-.002.002-.001c.304-.304.796-.308 1.104 0l1.788 1.788c.328.328.33.815.02 1.124z"
                    />
                </svg>
            )

        case "EDIT_LINE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M5 18h.09l4.17-.38c.457-.046.884-.247 1.21-.57l9-9c.727-.768.696-1.98-.07-2.71L16.66 2.6c-.74-.695-1.884-.726-2.66-.07l-9 9c-.323.326-.524.753-.57 1.21L4 16.91c-.027.296.08.59.29.8.189.187.444.291.71.29zM15.27 4L18 6.73l-2 1.95L13.32 6l1.95-2zM5 20h14c.552 0 1 .448 1 1s-.448 1-1 1H5c-.552 0-1-.448-1-1s.448-1 1-1z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "CERTIFICATE":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M48.36 14.238l-8.922-8.932c-.703-.702-1.458-.638-2.106-.638v11.667H49c0-.687.058-1.4-.638-2.097zm-13.944 2.826V4.668H16.188a2.182 2.182 0 0 0-2.187 2.188v9.934c1.668-.456 1.784-.456 2.41-.456a5.6 5.6 0 0 1 3.968 1.668c.795.874.402.636 1.666.98a5.624 5.624 0 0 1 3.94 3.993c.284 1.203.055.789.98 1.73a5.684 5.684 0 0 1 1.43 5.41c-.341 1.207-.337.73 0 2.017a5.685 5.685 0 0 1-1.43 5.411c-.878.853-.64.445-.979 1.731a5.637 5.637 0 0 1-3.236 3.748v8.311h24.061A2.182 2.182 0 0 0 49 49.146V19.25H36.603a2.194 2.194 0 0 1-2.187-2.187zM24.885 35.5a2.749 2.749 0 0 0 .69-2.624c-.494-1.882-.495-1.617 0-3.502a2.75 2.75 0 0 0-.69-2.624c-1.354-1.378-1.224-1.15-1.72-3.033a2.693 2.693 0 0 0-1.888-1.92c-1.848-.504-1.626-.374-2.979-1.75a2.636 2.636 0 0 0-2.578-.704c-1.852.505-1.59.504-3.44 0a2.638 2.638 0 0 0-2.578.703c-1.359 1.384-1.139 1.249-2.98 1.751a2.694 2.694 0 0 0-1.887 1.92c-.497 1.89-.364 1.653-1.72 3.033a2.749 2.749 0 0 0-.69 2.624c.496 1.887.493 1.621 0 3.5a2.75 2.75 0 0 0 .69 2.625c1.354 1.377 1.224 1.15 1.72 3.032.247.937.966 1.67 1.888 1.92 1.304.356 1.05.271 1.443.456v10.426L14 48.417l5.833 2.916V40.908c.393-.184.138-.1 1.444-.456a2.694 2.694 0 0 0 1.887-1.92c.499-1.89.366-1.652 1.72-3.032zM14 36.75a5.833 5.833 0 1 1 0-11.667 5.833 5.833 0 0 1 0 11.667z"
                    />
                </svg>
            )
        case "WARNING":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25">
                    <path
                        fill="#939393"
                        fillRule="evenodd"
                        d="M10.153 3.037A3.43 3.43 0 0 1 14.89 4.08l7.67 12.72a3 3 0 0 1 .05 3.04l-.113.18a3.37 3.37 0 0 1-2.827 1.48H4.33a3.37 3.37 0 0 1-2.94-1.7l-.097-.19a3 3 0 0 1 .147-2.81L9.11 4.08a3.43 3.43 0 0 1 1.043-1.043zm2.74 1.796a1.48 1.48 0 0 0-2.073.287L3.14 17.85a1 1 0 0 0 0 1l.08.121a1.31 1.31 0 0 0 1.11.529h15.34a1.31 1.31 0 0 0 1.19-.65l.059-.12a1 1 0 0 0-.069-.89L13.18 5.12a1.48 1.48 0 0 0-.287-.287zm-.186 10.96a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414zM12 8.5l.117.007A1 1 0 0 1 13 9.5v4a1 1 0 1 1-2 0v-4l.007-.117A1 1 0 0 1 12 8.5z"
                    />
                </svg>
            )
        case "SMALL_PROFILE":
            const style = {
                width: "22px",
                height: "22px",
                backgroundColor: "var(--black-200)",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
            return (
                <div style={style}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
                        <path
                            fill="#FFF"
                            fillRule="evenodd"
                            d="M6 7a3.5 3.5 0 0 1 3.5 3.5l-.008.09A.5.5 0 0 1 9 11H3a.5.5 0 0 1-.5-.5l.005-.192A3.5 3.5 0 0 1 6 7zm0-5a2 2 0 1 1 0 4l-.15-.005A2 2 0 0 1 4 4l.005-.15A2 2 0 0 1 6 2z"
                        />
                    </svg>
                </div>
            )
        case "MORE_HORZ":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill="#666"
                            d="M13.414 10.586c.781.78.781 2.047 0 2.828-.78.781-2.047.781-2.828 0-.781-.78-.781-2.047 0-2.828.78-.781 2.047-.781 2.828 0zm7 0c.781.78.781 2.047 0 2.828-.78.781-2.047.781-2.828 0-.781-.78-.781-2.047 0-2.828.78-.781 2.047-.781 2.828 0zm-14 0c.781.78.781 2.047 0 2.828-.78.781-2.047.781-2.828 0-.781-.78-.781-2.047 0-2.828.78-.781 2.047-.781 2.828 0z"
                        />
                    </g>
                </svg>
            )
        case "ARROW_RIGHT":
            return (
                <svg className={className} version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.005 512.005">
                    <g>
                        <g>
                            <path
                                fill={fillColor}
                                d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005
                       L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251
                       l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"
                            />
                        </g>
                    </g>
                </svg>
            )
        case "ARROW_LEFT":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="22"
                    fill="none"
                    viewBox="0 0 12 22">
                    <path
                        stroke={fillColor}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M11 1L1 11l10 10"
                    />
                </svg>
            )
        case "ARROW_DOWN":
            return (
                <svg
                    className={className}
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512.005 512.005"
                    width="32"
                    height="32">
                    <g>
                        <g>
                            <path
                                fill={fillColor}
                                d="M505.755,123.592c-8.341-8.341-21.824-8.341-30.165,0L256.005,343.176L36.421,123.592c-8.341-8.341-21.824-8.341-30.165,0
			s-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251c5.462,0,10.923-2.091,15.083-6.251l234.667-234.667
			C514.096,145.416,514.096,131.933,505.755,123.592z"
                            />
                        </g>
                    </g>
                </svg>
            )
        case "CHECKED":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={color || "#18A957"}
                            d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.3 7.61l-4.57 6c-.189.245-.48.39-.79.39-.308.002-.6-.139-.79-.38l-2.44-3.11c-.34-.436-.261-1.065.175-1.405.436-.34 1.065-.261 1.405.175l1.63 2.08 3.78-5c.337-.442.968-.527 1.41-.19.442.337.527.968.19 1.41v.03z"
                        />
                    </g>
                </svg>
            )
        case "LIBRARY":
            return (
                <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M19.92 4.11c.376-.097.776-.012 1.08.23l.11.093c.243.23.385.549.39.887V17c.004.574-.384 1.078-.94 1.22L13 20.16V5.89zm-16.803.15c.281-.17.62-.225.943-.15L11 5.89v14.27l-7.54-1.95c-.553-.141-.94-.64-.94-1.21V5.34c-.005-.39.173-.76.48-1z"
                            transform="translate(.333)"></path>
                    </g>
                </svg>
            )
        case "PACKAGE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M23.93 6.857c.022-.027.027-.037.049-.064l-3.017-5.62C20.727.471 20.073 0 19.334 0h-5.62l1.715 6.857h8.501zm-15.359 0L10.286 0h-5.62c-.74 0-1.393.471-1.629 1.173L.022 6.793c.022.027.027.037.049.064H8.57zm6.858 1.714v4.286c0 .472-.386.857-.858.857H9.43c-.472 0-.858-.385-.858-.857V8.571H0v13.715C0 23.234.766 24 1.714 24h20.572c.948 0 1.714-.766 1.714-1.714V8.57h-8.571z"
                    />
                </svg>
            )
        case "PAPER_PLANE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M20.94 3.73v-.09c-.048-.111-.116-.213-.2-.3-.085-.08-.183-.144-.29-.19h-.09c-.092-.07-.198-.121-.31-.15H20c-.1-.015-.2-.015-.3 0l-18 6c-.525.172-.81.738-.638 1.262.1.302.336.539.638.638l8.53 2.84 2.84 8.53c.172.525.738.81 1.262.638.302-.1.539-.336.638-.638l6-18c.022-.088.032-.18.03-.27-.01-.092-.03-.182-.06-.27zM16.3 6.29l-5.57 5.57L5.16 10 16.3 6.29zM14 18.84l-1.86-5.57 5.57-5.57L14 18.84z"
                        />
                    </g>
                </svg>
            )
        case "WARNING_TRIANGLE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M12 16.727c.602 0 1.09.489 1.09 1.091 0 .603-.488 1.091-1.09 1.091-.602 0-1.09-.488-1.09-1.09 0-.603.488-1.092 1.09-1.092zM12 8c.602 0 1.09.488 1.09 1.09v4.365c0 .602-.488 1.09-1.09 1.09-.602 0-1.09-.488-1.09-1.09V9.09C10.91 8.488 11.397 8 12 8zm11.52 9.329L15.149 3.21c-.688-1.094-1.877-1.756-3.154-1.756-1.278 0-2.467.662-3.155 1.756L.467 17.33c-.602 1.02-.623 2.29-.055 3.33.657 1.17 1.883 1.891 3.21 1.886h16.744c1.317.015 2.541-.688 3.21-1.842.585-1.052.564-2.343-.055-3.374zm-1.855 2.275c-.267.467-.768.745-1.299.721H3.621c-.531.024-1.031-.254-1.299-.721-.195-.343-.195-.766 0-1.11l8.384-14.129c.305-.41.782-.65 1.288-.65s.982.24 1.288.65l8.372 14.118c.203.344.207.773.011 1.121z"
                    />
                </svg>
            )
        case "WARNING_TRIANGLE_FILL":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={color || "#DF1642"}
                        fillRule="evenodd"
                        d="M30.08 21.733L19.853 4.773c-1.36-2.128-4.188-2.75-6.316-1.39-.559.357-1.033.831-1.39 1.39L1.92 21.733c-.735 1.226-.76 2.75-.067 4 .803 1.407 2.3 2.273 3.92 2.267h20.454c1.608.017 3.103-.828 3.92-2.214.714-1.263.689-2.814-.067-4.053zM16 22.666c-.736 0-1.333-.597-1.333-1.333 0-.737.597-1.333 1.333-1.333s1.333.596 1.333 1.333c0 .736-.597 1.333-1.333 1.333zm1.333-5.333c0 .736-.597 1.333-1.333 1.333s-1.333-.597-1.333-1.333V12c0-.737.597-1.334 1.333-1.334s1.333.597 1.333 1.333v5.334z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "PEOPLE":
            return (
                <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        fill={fillColor}
                        d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path>
                </svg>
            )
        case "BAR_CHART":
            return (
                <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                    <path fill={fillColor} d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"></path>
                </svg>
            )
        case "PERSON":
            return (
                <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        fill={fillColor}
                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path>
                </svg>
            )
        case "PERSON_CONTACT":
            return (
                <svg className={className} width="48" height="48" fill="none" viewBox="0 0 48 48">
                    <rect width="48" height="48" fill="#E6E6E6" rx="12" />
                    <path
                        fill="#939393"
                        fillRule="evenodd"
                        d="M30.333 16.083c0 3.498-2.835 6.334-6.333 6.334s-6.333-2.836-6.333-6.334c0-3.497 2.835-6.333 6.333-6.333s6.333 2.835 6.333 6.333zm7.917 20.584c0 .874-.911 1.583-2.036 1.583H11.786c-1.125 0-2.036-.709-2.036-1.583 0-6.122 6.38-11.084 14.25-11.084s14.25 4.963 14.25 11.084z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "SETTINGS":
            return (
                <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        fill={fillColor}
                        d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"></path>
                </svg>
            )
        case "CLOSE":
            return (
                <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        fill={fillColor}
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                </svg>
            )
        case "PLUS":
            return (
                <svg className={className} viewBox="0 0 24 24" width="24" height="24">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M19 11h-6V5c0-.552-.448-1-1-1s-1 .448-1 1v6H5c-.552 0-1 .448-1 1s.448 1 1 1h6v6c0 .552.448 1 1 1s1-.448 1-1v-6h6c.552 0 1-.448 1-1s-.448-1-1-1z"
                        />
                    </g>
                </svg>
            )
        case "PLUS_CIRCLE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    fill="none"
                    viewBox="0 0 34 34">
                    <path
                        stroke={fillColor}
                        strokeWidth="2"
                        d="M24.749 24.778c-4.296 4.296-11.26 4.296-15.556 0-4.296-4.296-4.296-11.26 0-15.556 4.295-4.296 11.26-4.296 15.556 0 4.296 4.296 4.296 11.26 0 15.556z"
                    />
                    <path
                        stroke={fillColor}
                        strokeWidth="2"
                        d="M18.022 17.052h-1v5.259h-.103v-5.26h-5.26v-.103h5.26v-5.26h.103v5.26h5.26v.104h-4.26z"
                    />
                </svg>
            )
        case "DELETE":
            return (
                <svg className={className} viewBox="0 0 24 24">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M21 6h-5V4.33c-.049-1.333-1.167-2.375-2.5-2.33h-3c-1.333-.045-2.451.997-2.5 2.33V6H3c-.552 0-1 .448-1 1s.448 1 1 1h1v11c0 1.657 1.343 3 3 3h10c1.657 0 3-1.343 3-3V8h1c.552 0 1-.448 1-1s-.448-1-1-1zM10 16c0 .552-.448 1-1 1s-1-.448-1-1v-4c0-.552.448-1 1-1s1 .448 1 1v4zm0-11.67c0-.16.21-.33.5-.33h3c.29 0 .5.17.5.33V6h-4V4.33zM16 16c0 .552-.448 1-1 1s-1-.448-1-1v-4c0-.552.448-1 1-1s1 .448 1 1v4z"
                        />
                    </g>
                </svg>
            )
        case "UNORDER_LIST":
            return (
                <svg className={className} viewBox="0 0 33 33">
                    <path
                        fill={fillColor}
                        d="M3 22.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm29.06 0c.52 0 .94.42.94.94v1.12c0 .52-.42.94-.94.94H9.94c-.52 0-.94-.42-.94-.94v-1.12c0-.52.42-.94.94-.94h22.12zM3 13.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm29.06 0c.52 0 .94.42.94.94v1.12c0 .52-.42.94-.94.94H9.94c-.52 0-.94-.42-.94-.94v-1.12c0-.52.42-.94.94-.94h22.12zM3 4.5c.828 0 1.5.672 1.5 1.5S3.828 7.5 3 7.5 1.5 6.828 1.5 6 2.172 4.5 3 4.5zm29.06 0c.52 0 .94.42.94.94v1.12c0 .52-.42.94-.94.94H9.94c-.52 0-.94-.42-.94-.94V5.44c0-.52.42-.94.94-.94h22.12z"
                    />
                </svg>
            )
        case "SCAN_TASK":
            return (
                <svg className={className} viewBox="0 0 24 24">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M13.5 3C14.88 3 16 4.12 16 5.5V7h3c1.657 0 3 1.343 3 3v8c0 1.657-1.343 3-3 3H5c-1.657 0-3-1.343-3-3v-8l.005-.176C2.096 8.249 3.402 7 5 7h3V5.5l.005-.164C8.09 4.032 9.175 3 10.5 3zM12 10.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5l.192-.005c1.844-.1 3.308-1.626 3.308-3.495l-.005-.192c-.1-1.844-1.626-3.308-3.495-3.308zm1.06 2.44c.586.585.586 1.535 0 2.12-.585.586-1.535.586-2.12 0-.586-.585-.586-1.535 0-2.12.585-.586 1.535-.586 2.12 0zM13.5 5h-3c-.276 0-.5.224-.5.5V7h4V5.5c0-.276-.224-.5-.5-.5z"
                        />
                    </g>
                </svg>
            )
        case "DIGITAL_DOCUMENT_TASK":
            return (
                <svg className={className} viewBox="0 0 25 24">
                    <path
                        fill={fillColor}
                        d="M14.115 6.375V0H4.74c-.624 0-1.125.502-1.125 1.125v21.75c0 .623.501 1.125 1.125 1.125h15.75c.623 0 1.125-.502 1.125-1.125V7.5H15.24c-.62 0-1.125-.506-1.125-1.125zm-7.5-3c0-.207.167-.375.375-.375h3.75c.207 0 .375.168.375.375v.75c0 .207-.168.375-.375.375H6.99c-.208 0-.375-.168-.375-.375v-.75zm0 3c0-.207.167-.375.375-.375h3.75c.207 0 .375.168.375.375v.75c0 .207-.168.375-.375.375H6.99c-.208 0-.375-.168-.375-.375v-.75zm0 5c0-.207.298-.375.666-.375h6.667c.368 0 .667.168.667.375v.75c0 .207-.299.375-.667.375H7.281c-.368 0-.666-.168-.666-.375v-.75zm5 3c0-.207.298-.375.666-.375h6.667c.368 0 .667.168.667.375v.75c0 .207-.299.375-.667.375h-6.667c-.368 0-.666-.168-.666-.375v-.75zm-5 0c0-.207.149-.375.333-.375h3.333c.185 0 .334.168.334.375v.75c0 .207-.15.375-.334.375H6.948c-.184 0-.333-.168-.333-.375v-.75zm9-3c0-.207.149-.375.333-.375h3.333c.185 0 .334.168.334.375v.75c0 .207-.15.375-.334.375h-3.333c-.184 0-.333-.168-.333-.375v-.75zm1.778 9.469h1.66c.31 0 .562.259.562.578 0 .32-.252.578-.563.578h-1.659c-.578 0-1.1-.33-1.358-.862-.104-.214-.285-.236-.358-.236-.073 0-.254.022-.352.224l-.27.554c-.095.196-.29.32-.503.32l-.04-.002c-.227-.016-.422-.172-.493-.394l-.592-1.823-.373 1.152c-.207.638-.787 1.067-1.441 1.067h-.436c-.31 0-.562-.259-.562-.578 0-.32.251-.578.562-.578h.436c.17 0 .32-.111.374-.277l.64-1.974c.115-.355.437-.593.8-.593.364 0 .685.238.8.593l.489 1.504c.695-.585 1.9-.35 2.32.512.071.147.21.235.357.235zm3.894-15.922L16.697.328c-.21-.21-.496-.328-.796-.328h-.286v6h6v-.286c0-.295-.118-.581-.328-.792z"
                    />
                </svg>
            )
        case "EYE":
            return (
                <svg className={className} viewBox="0 0 26 25">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M11.879 5c6.056-.18 9.62 5.39 10.269 6.5.18.31.18.69 0 1l-.059.1c-.951 1.605-4.182 6.263-9.663 6.4h-.253c-5.965 0-9.378-5.41-10.016-6.5-.18-.31-.18-.69 0-1l.06-.1c.96-1.605 4.18-6.263 9.662-6.4zm.424 1.999L11.98 7c-4.05.1-6.694 3.39-7.706 5 .89 1.41 3.737 5.1 8.101 5 4.051-.1 6.664-3.39 7.707-5-.901-1.41-3.757-5.11-8.102-5zm-.15 1.501l.194.005c1.867.1 3.35 1.626 3.35 3.495l-.005.192c-.101 1.844-1.647 3.308-3.54 3.308-1.957 0-3.544-1.567-3.544-3.5s1.587-3.5 3.544-3.5zm0 2c-.84 0-1.52.672-1.52 1.5s.68 1.5 1.52 1.5l.138-.006c.774-.07 1.38-.712 1.38-1.494l-.006-.137c-.07-.764-.72-1.363-1.513-1.363z"
                            transform="translate(.91 .5)"
                        />
                    </g>
                </svg>
            )
        case "EYE_CROSSED_LINE":
            return (
                <svg className={className} viewBox="0 0 24 24" fill="none">
                    <path
                        d="M9.76 14.367a3.123 3.123 0 0 1-.925-2.23A3.16 3.16 0 0 1 12 8.973c.867 0 1.665.35 2.23.925M15.105 12.699a3.158 3.158 0 0 1-2.537 2.542"
                        stroke="#010000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.655 17.472c-1.587-1.246-2.931-3.066-3.905-5.335.984-2.279 2.337-4.109 3.934-5.365C8.27 5.516 10.1 4.834 11.999 4.834c1.91 0 3.74.692 5.336 1.957M19.447 8.99a15.358 15.358 0 0 1 1.802 3.147c-1.967 4.557-5.443 7.302-9.25 7.302-.863 0-1.714-.14-2.532-.413M19.887 4.25 4.113 20.023"
                        stroke="#010000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case "BACK":
            return (
                <svg className={className} viewBox="0 0 40 40">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm-3.72 27.686l-5.72-6.246c-.084-.09-.152-.196-.2-.312-.084-.098-.152-.211-.2-.333-.213-.504-.213-1.079 0-1.583.096-.255.238-.489.42-.687l6-6.246c.785-.816 2.056-.816 2.84 0 .784.816.784 2.14 0 2.956l-2.6 2.686H28c1.105 0 2 .932 2 2.082s-.895 2.082-2 2.082H16.68l2.5 2.728c.762.834.731 2.153-.07 2.946-.8.793-2.068.76-2.83-.073z"
                        />
                    </g>
                </svg>
            )
        case "CHECK_LIST":
            return (
                <svg className={className} viewBox="0 0 25 24">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M9.759 5.716h13.447c.411 0 .747-.336.747-.747V3.1c0-.41-.336-.747-.747-.747H9.76c-.411 0-.747.336-.747.747V4.97c0 .41.336.747.747.747zm0 7.47h13.447c.411 0 .747-.335.747-.746v-1.868c0-.41-.336-.747-.747-.747H9.76c-.411 0-.747.336-.747.747v1.868c0 .41.336.747.747.747zm0 7.472h13.447c.411 0 .747-.337.747-.747v-1.868c0-.411-.336-.747-.747-.747H9.76c-.411 0-.747.336-.747.747v1.868c0 .41.336.747.747.747zm-6.724-3.923c-1.237 0-2.27 1.004-2.27 2.242 0 1.237 1.033 2.24 2.27 2.24s2.241-1.003 2.241-2.24c0-1.238-1.004-2.242-2.241-2.242zm4.32-13.96l-3.372 3.37-.729.729c-.219.22-.602.22-.821 0L.21 4.66c-.22-.22-.22-.575 0-.794l.733-.733c.22-.22.575-.22.794 0l1.06 1.032L5.77 1.21c.22-.22.575-.22.794 0l.794.77c.215.22.215.575-.005.794zm0 7.451l-3.372 3.372-.733.733c-.22.22-.603.22-.822 0L.21 12.113c-.22-.22-.22-.574 0-.794l.733-.733c.22-.22.575-.22.794 0l1.06 1.032L5.77 8.644c.22-.22.575-.22.794 0l.794.793c.215.215.215.57-.005.79z"
                            transform="translate(.222)"
                        />
                    </g>
                </svg>
            )
        case "STUDENT_ICON":
            return (
                <svg className={className} viewBox="0 0 74 74">
                    <path
                        fill={fillColor}
                        d="M49.157 46.39L35.395 60.153 21.634 46.391c-10.314.447-18.55 8.885-18.55 19.3v1.385c0 3.823 3.1 6.924 6.923 6.924h50.776c3.823 0 6.924-3.101 6.924-6.924v-1.385c0-10.415-8.237-18.853-18.55-19.3zM5.045 11.656l.923.217v8.424c-1.01.606-1.73 1.659-1.73 2.928 0 1.212.663 2.222 1.6 2.842l-2.25 8.987c-.245.995.303 2.02 1.097 2.02h6.03c.793 0 1.34-1.025 1.095-2.02l-2.25-8.987c.938-.62 1.601-1.63 1.601-2.842 0-1.27-.72-2.322-1.73-2.928v-7.588l9.52 2.294c-1.24 2.481-2.02 5.25-2.02 8.222 0 10.199 8.266 18.464 18.464 18.464 10.199 0 18.464-8.265 18.464-18.464 0-2.971-.764-5.741-2.02-8.222l13.892-3.347c2.625-.634 2.625-3.909 0-4.543L38.266.476c-1.875-.447-3.852-.447-5.727 0L5.045 7.097c-2.61.635-2.61 3.924 0 4.558z"
                    />
                </svg>
            )
        case "STAFF_ICON":
            return (
                <svg className={className} viewBox="0 0 74 74">
                    <path
                        fill={fillColor}
                        d="M0 32.067v31.45c0 1.022.828 1.85 1.85 1.85h9.25v-37H3.7c-2.043 0-3.7 1.657-3.7 3.7zm41.625-5.55H38.85v-4.625c0-.511-.414-.925-.925-.925h-1.85c-.511 0-.925.414-.925.925v7.4c0 .51.414.925.925.925h5.55c.511 0 .925-.414.925-.925v-1.85c0-.511-.414-.925-.925-.925zm15.927-7.396l-18.5-12.333c-1.243-.828-2.861-.828-4.104 0l-18.5 12.333c-1.03.686-1.648 1.841-1.648 3.078v43.168h14.8v-16.65c0-1.022.828-1.85 1.85-1.85h11.1c1.022 0 1.85.828 1.85 1.85v16.65h14.8V22.2c0-1.237-.619-2.393-1.648-3.079zM37 35.767c-5.108 0-9.25-4.142-9.25-9.25 0-5.109 4.142-9.25 9.25-9.25s9.25 4.141 9.25 9.25c0 5.108-4.142 9.25-9.25 9.25zm33.3-7.4h-7.4v37h9.25c1.022 0 1.85-.828 1.85-1.85v-31.45c0-2.043-1.657-3.7-3.7-3.7z"
                    />
                </svg>
            )
        case "NOTIFY":
            return (
                <svg className={className} viewBox="0 0 24 24">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M20.52 15.21l-1.8-1.81V8.94c.05-3.425-2.435-6.361-5.82-6.88-3.69-.486-7.076 2.112-7.562 5.802-.038.288-.057.578-.058.868v4.67l-1.8 1.81c-.635.646-.627 1.684.02 2.32.304.299.713.468 1.14.47H8v.34c.097 2.114 1.886 3.75 4 3.66 2.114.09 3.903-1.546 4-3.66V18h3.36c.906-.005 1.636-.743 1.63-1.65-.002-.426-.17-.836-.47-1.14zM14 18.34c-.115 1-.997 1.73-2 1.66-1.003.07-1.885-.66-2-1.66V18h4v.34z"
                        />
                    </g>
                </svg>
            )
        case "DUPLICATE":
            return (
                <svg className={className} viewBox="0 0 24 24">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M18 9h-3V5.67c-.005-1.472-1.198-2.665-2.67-2.67H5.67C4.198 3.005 3.005 4.198 3 5.67v6.66c.005 1.472 1.198 2.664 2.67 2.67H9v3c0 1.657 1.343 3 3 3h6c1.657 0 3-1.343 3-3v-6c0-1.657-1.343-3-3-3zm-9 3v1H5.67c-.37 0-.67-.3-.67-.67V5.67c0-.37.3-.67.67-.67h6.66c.37 0 .67.3.67.67V9h-1c-1.657 0-3 1.343-3 3z"
                        />
                    </g>
                </svg>
            )
        case "HAND":
            return (
                <svg className={className} viewBox="0 0 75 74">
                    <path
                        fill="#FF71B9"
                        d="M62.665 18.501c-3.241-.062-5.894 2.653-5.894 5.894V37h-1.156V11.532c0-3.242-2.653-5.956-5.895-5.894-3.14.06-5.668 2.625-5.668 5.78V37h-1.156V5.895c0-3.241-2.653-5.956-5.894-5.894-3.141.06-5.669 2.625-5.669 5.78V37h-1.156V11.677c0-3.242-2.653-5.957-5.894-5.895-3.14.06-5.668 2.625-5.668 5.78v34.109l-4.575-6.29c-1.877-2.582-5.493-3.153-8.076-1.275-2.582 1.878-3.152 5.493-1.275 8.076l18.154 24.96c1.305 1.796 3.39 2.858 5.61 2.858h28.558c3.22 0 6.016-2.215 6.753-5.349l3.832-16.282c.49-2.083.737-4.216.737-6.356V24.28c0-3.155-2.527-5.72-5.668-5.78z"
                    />
                </svg>
            )
        case "QUESTION":
            return (
                <svg className={className} viewBox="0 0 39 39">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M19.5 3.25c-8.975 0-16.25 7.275-16.25 16.25s7.275 16.25 16.25 16.25 16.25-7.275 16.25-16.25S28.475 3.25 19.5 3.25zm0 26c-.897 0-1.625-.728-1.625-1.625S18.603 26 19.5 26s1.625.728 1.625 1.625-.728 1.625-1.625 1.625zm1.625-8.385v1.885c0 .897-.728 1.625-1.625 1.625s-1.625-.728-1.625-1.625V19.5c0-.897.728-1.625 1.625-1.625 1.346 0 2.437-1.091 2.437-2.437 0-1.347-1.09-2.438-2.437-2.438-1.346 0-2.438 1.091-2.438 2.438 0 .897-.727 1.625-1.625 1.625-.897 0-1.625-.728-1.625-1.625-.012-3.142 2.524-5.698 5.665-5.71 3.141-.013 5.698 2.523 5.71 5.664.01 2.523-1.644 4.752-4.062 5.473z"
                        />
                    </g>
                </svg>
            )
        case "SEARCH":
            return (
                <svg className={className} viewBox="0 0 24 24">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M20.71 19.29l-3.4-3.39c1.097-1.398 1.692-3.123 1.69-4.9 0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8c1.777.002 3.502-.593 4.9-1.69l3.39 3.4c.389.392 1.022.395 1.414.006l.006-.006c.392-.389.395-1.022.006-1.414l-.006-.006zM5 11c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6z"
                        />
                    </g>
                </svg>
            )
        case "MEN_WOMEN":
            return (
                <svg className={className} viewBox="0 0 76 74">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M17.173 3.083c5.173 0 9.367 3.797 9.367 8.48 0 4.682-4.194 8.479-9.367 8.479-5.173 0-9.367-3.797-9.367-8.48 0-4.682 4.194-8.479 9.367-8.479m7.025 19.078h-1.662c-3.324 1.384-7.258 1.444-10.726 0h-1.662c-3.88 0-7.026 2.848-7.026 6.36v18.018c0 1.756 1.573 3.18 3.513 3.18h2.342v18.018c0 1.756 1.572 3.18 3.512 3.18h9.368c1.94 0 3.512-1.424 3.512-3.18V49.719h2.342c1.94 0 3.513-1.424 3.513-3.18V28.521c0-3.512-3.146-6.36-7.026-6.36zM56.202 3.083c4.599 0 8.326 3.797 8.326 8.48 0 4.682-3.727 8.479-8.326 8.479-4.598 0-8.325-3.797-8.325-8.48 0-4.682 3.727-8.479 8.325-8.479M71.72 50.007L65.475 24.57c-.347-1.416-1.596-2.409-3.028-2.409h-1.478c-2.955 1.384-6.451 1.444-9.533 0h-1.478c-1.432 0-2.681.993-3.029 2.409l-6.244 25.437c-.492 2.004.998 3.951 3.03 3.951h7.284v13.779c0 1.756 1.398 3.18 3.122 3.18h4.163c1.724 0 3.122-1.424 3.122-3.18V53.958h7.285c2.028 0 3.521-1.943 3.029-3.95z"
                            transform="translate(.278)"
                        />
                    </g>
                </svg>
            )
        case "CLOUD_UPLOAD":
            return (
                <svg className={className} viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M20.16 11.297c.154-.4.24-.84.24-1.297 0-1.988-1.612-3.6-3.6-3.6-.739 0-1.429.225-1.999.607C13.762 5.208 11.824 4 9.6 4c-3.315 0-6 2.685-6 6 0 .101.004.203.007.304C1.507 11.043 0 13.045 0 15.4c0 2.981 2.419 5.4 5.4 5.4h13.8c2.651 0 4.8-2.149 4.8-4.8 0-2.321-1.65-4.26-3.84-4.703zM14.752 13.6H12.3v4.2c0 .33-.27.6-.6.6H9.9c-.33 0-.6-.27-.6-.6v-4.2H6.847c-.536 0-.802-.645-.423-1.024l3.952-3.952c.233-.233.615-.233.848 0l3.952 3.952c.379.379.109 1.024-.424 1.024z"
                    />
                </svg>
            )
        case "ARROW_LEFT_CIRCLE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM9.768 16.612l-3.432-3.748c-.05-.054-.091-.118-.12-.187-.05-.06-.091-.127-.12-.2-.128-.303-.128-.647 0-.95.057-.153.143-.293.252-.412l3.6-3.748c.47-.49 1.234-.49 1.704 0s.47 1.284 0 1.774l-1.56 1.612H16.8c.663 0 1.2.56 1.2 1.249 0 .69-.537 1.25-1.2 1.25h-6.792l1.5 1.636c.457.5.439 1.291-.042 1.767-.48.476-1.24.457-1.698-.043z"
                        />
                    </g>
                </svg>
            )

        case "ARROW_RIGHT_CIRCLE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM9.768 16.612l-3.432-3.748c-.05-.054-.091-.118-.12-.187-.05-.06-.091-.127-.12-.2-.128-.303-.128-.647 0-.95.057-.153.143-.293.252-.412l3.6-3.748c.47-.49 1.234-.49 1.704 0s.47 1.284 0 1.774l-1.56 1.612H16.8c.663 0 1.2.56 1.2 1.249 0 .69-.537 1.25-1.2 1.25h-6.792l1.5 1.636c.457.5.439 1.291-.042 1.767-.48.476-1.24.457-1.698-.043z"
                            transform="rotate(180 12 12)"
                        />
                    </g>
                </svg>
            )
        case "INFO":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                    />
                </svg>
            )
        case "FILE_EMPTY":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="127"
                    height="127"
                    viewBox="0 0 127 127">
                    <g fill="none">
                        <path
                            fill={fillColor}
                            d="M104.457 38.788L80.963 12.33c-1-1.109-2.423-1.743-3.916-1.748H34.713c-7.393-.087-13.458 5.835-13.546 13.229v79.376c.087 7.394 6.151 13.317 13.544 13.23h57.576c7.393.088 13.458-5.834 13.546-13.228V42.333c-.003-1.311-.493-2.575-1.376-3.545zM74.084 79.375H52.917c-2.923 0-5.292-2.37-5.292-5.292 0-2.922 2.37-5.291 5.292-5.291h21.166c2.923 0 5.292 2.369 5.292 5.291 0 2.923-2.37 5.292-5.292 5.292zm3.757-37.042c-2.27-.223-3.94-2.224-3.757-4.498V21.167l19.791 21.166H77.84z"
                        />
                    </g>
                </svg>
            )
        case "BULB":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M13 5c0 .552-.448 1-1 1s-1-.448-1-1V3c0-.552.448-1 1-1s1 .448 1 1v2zm-1 2c-2.761 0-5 2.239-5 5 0 1.574.741 3.056 2 4v4c0 1.105.895 2 2 2h2c1.105 0 2-.895 2-2v-4c2.21-1.657 2.657-4.79 1-7-.944-1.259-2.426-2-4-2zm1.5 7.59c-.31.18-.501.511-.5.87V20h-2v-4.54c.001-.359-.19-.69-.5-.87-.926-.534-1.497-1.521-1.5-2.59 0-1.657 1.343-3 3-3s3 1.343 3 3c-.003 1.069-.574 2.056-1.5 2.59zM21 11h-2c-.552 0-1 .448-1 1s.448 1 1 1h2c.552 0 1-.448 1-1s-.448-1-1-1zM3 11h2c.552 0 1 .448 1 1s-.448 1-1 1H3c-.552 0-1-.448-1-1s.448-1 1-1zm4.66-4.58L6.22 5c-.406-.384-1.046-.366-1.43.04-.384.406-.366 1.046.04 1.43l1.44 1.39c.195.189.459.29.73.28.272-.001.532-.113.72-.31.372-.406.345-1.037-.06-1.41zm10.12-1.37c.39-.388 1.02-.388 1.41 0l.006.006c.389.392.386 1.025-.006 1.414l-1.44 1.39c-.185.179-.433.279-.69.28-.272-.001-.532-.113-.72-.31-.388-.39-.388-1.02 0-1.41l1.44-1.37z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "CLIPBOARD":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M18 5V4c0-1.105-.895-2-2-2H8c-1.105 0-2 .895-2 2v1C4.343 5 3 6.343 3 8v11c0 1.657 1.343 3 3 3h12c1.657 0 3-1.343 3-3V8c0-1.657-1.343-3-3-3zM8 4h8v4H8V4zm11 15c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1V8c0-.552.448-1 1-1v1c0 1.105.895 2 2 2h8c1.105 0 2-.895 2-2V7c.552 0 1 .448 1 1v11z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "ARCHIVE_FILL":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M18 3H6c-1.657.01-2.992 1.36-2.982 3.018.005.839.36 1.638.982 2.202V18c0 1.657 1.343 3 3 3h10c1.657 0 3-1.343 3-3V8.22c1.226-1.114 1.317-3.012.202-4.238C19.638 3.362 18.84 3.005 18 3zm-3 10.13c0 .48-.39.87-.87.87H9.87c-.48 0-.87-.39-.87-.87v-.26c0-.48.39-.87.87-.87h4.26c.48 0 .87.39.87.87v.26zM18 7H6c-.552 0-1-.448-1-1s.448-1 1-1h12c.552 0 1 .448 1 1s-.448 1-1 1z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "ACTIVE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    fill="none"
                    viewBox="0 0 36 36">
                    <path
                        fill="#18A957"
                        fillRule="evenodd"
                        d="M18 0C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18S27.941 0 18 0zm8.622 12.072l-8.371 11.2c-.346.458-.88.727-1.447.728-.564.003-1.098-.259-1.447-.71l-4.47-5.804c-.622-.815-.479-1.989.32-2.623.8-.634 1.952-.488 2.574.327l2.986 3.882 6.925-9.333c.617-.824 1.773-.983 2.582-.354.81.629.966 1.807.348 2.632v.056z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "INACTIVE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    fill="none"
                    viewBox="0 0 36 36">
                    <path
                        fill={color || "#E6E6E6"}
                        fillRule="evenodd"
                        d="M0 18C0 8.056 8.056 0 18 0s18 8.056 18 18-8.056 18-18 18S0 27.944 0 18zm9-1.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h18c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5H9z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "PRIVACY_POLICY":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M19.547 36.523c.184.096.39.145.597.144.207-.002.411-.053.598-.15l5.946-3.18c1.686-.899 3.007-1.904 4.037-3.074 2.24-2.55 3.463-5.803 3.441-9.159l-.07-11.067c-.007-1.275-.844-2.413-2.082-2.826L20.95 3.499c-.666-.225-1.396-.22-2.05.012L7.88 7.355c-1.232.43-2.054 1.575-2.048 2.852l.07 11.06c.023 3.36 1.288 6.599 3.565 9.122 1.04 1.154 2.372 2.144 4.077 3.028l6.002 3.106zm-1.574-13.008c.248.238.57.356.892.353.323-.002.643-.123.888-.365l6.498-6.406c.489-.482.484-1.257-.01-1.733-.495-.475-1.292-.472-1.78.01l-5.614 5.534-2.299-2.21c-.495-.475-1.29-.47-1.78.012-.488.482-.483 1.257.012 1.732l3.193 3.073z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "ALERT":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill="#FF8A38"
                        fillRule="evenodd"
                        d="M22.56 16.3L14.89 3.58c-1.02-1.596-3.141-2.063-4.737-1.042-.42.267-.775.623-1.043 1.042L1.44 16.3c-.551.92-.57 2.063-.05 3 .602 1.055 1.725 1.705 2.94 1.7h15.34c1.207.013 2.328-.62 2.94-1.66.536-.947.517-2.11-.05-3.04zM12 17c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm1-4c0 .552-.448 1-1 1s-1-.448-1-1V9c0-.552.448-1 1-1s1 .448 1 1v4z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "ALERT_CIRCLE":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fill={fillColor || "#DF1642"}
                        fillRule="evenodd"
                        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 15c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm1-4c0 .552-.448 1-1 1s-1-.448-1-1V8c0-.552.448-1 1-1s1 .448 1 1v5z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "ALERT_CIRCLE_FILL":
            return (
                <svg
                    className={className}
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.999 2.333C7.555 2.333 2.332 7.556 2.332 14c0 6.443 5.223 11.666 11.667 11.666 6.443 0 11.666-5.223 11.666-11.666 0-6.444-5.223-11.667-11.666-11.667zm0 17.5a1.167 1.167 0 1 1 0-2.333 1.167 1.167 0 0 1 0 2.333zm1.166-4.667a1.167 1.167 0 0 1-2.333 0V9.333a1.167 1.167 0 0 1 2.333 0v5.833z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "USERS":
            return (
                <svg viewBox="0 0 25 24" version="1.1">
                    <title>09CE4A5E-0C1E-4AAB-B2E1-9032C819157C</title>
                    <g id="Admissions" stroke="none" strokeWidth="1" fillRule="evenodd">
                        <g id="admissionsWorkspaceTasksPanel" transform="translate(-1544.000000, -872.000000)">
                            <g id="actionPanel" transform="translate(1055.000000, 795.000000)">
                                <g id="navigationTabs" transform="translate(0.000000, 50.000000)">
                                    <g
                                        id="Tab_Navigation/--Tabs/Icon_+_Label"
                                        transform="translate(424.000000, 0.000000)">
                                        <g id="Icon/People/Fill" transform="translate(65.733333, 27.000000)">
                                            <polygon
                                                id="24pt_Bounding_Box"
                                                opacity="0"
                                                fillRule="nonzero"
                                                points="0 0 24 0 24 24 0 24"></polygon>
                                            <path
                                                d="M4.04055996,15.0693293 C6.76887996,12.3303187 11.20103,12.3216387 13.94004,15.0499587 L13.94004,15.0499587 L14.1454011,14.8992476 C14.9804204,14.31857 15.9746623,14.0051523 16.99577,14.0042887 C19.7572,14.0019587 21.9976646,16.2386387 22,19.0000587 C22,19.552285 21.552285,20 20.99999,20 L20.99999,20 L15.99999,19.9999995 C15.99999,20.5522845 15.5522749,20.9999995 14.99999,20.9999995 L14.99999,20.9999995 L2.99998996,20.9999995 C2.44770496,20.9999995 1.99998996,20.5522845 1.99998996,19.9999995 L1.99998996,19.9999995 L2.00714501,19.6926829 C2.08573783,17.9559634 2.80849441,16.306221 4.04055996,15.0693293 Z M16.9999999,7 C18.6568499,7 19.9999999,8.34315 19.9999999,10 C19.9999999,11.65685 18.6568499,13 16.9999999,13 L16.9999999,13 L16.8237275,12.9949073 C15.2489238,12.9036606 13.9999999,11.5976772 13.9999999,10 L13.9999999,10 L14.0050926,9.82372764 C14.0963393,8.24892392 15.4023231,7 16.9999999,7 Z M8.99999983,3 C11.2091398,3 12.9999998,4.79086 12.9999998,7 C12.9999998,9.20914 11.2091398,11 8.99999983,11 L8.99999983,11 L8.8003594,10.9951047 C6.68396735,10.8910789 4.99999983,9.14219578 4.99999983,7 L4.99999983,7 L5.00489513,6.80035957 C5.10892089,4.68396753 6.85780346,3 8.99999983,3 Z"
                                                id="Fill"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        case "WHITE_INFO":
            return (
                <svg
                    className={className}
                    onClick={onClick}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0 2c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
                        clipRule="evenodd"
                    />
                    <path fill={fillColor} d="M14 26V11.644h4V26h-4zm0-16.356V6h4v3.644h-4z" />
                </svg>
            )
        case "WHITE_CALENDAR":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M10.438 16.115H8.562c-.309 0-.562-.259-.562-.574v-1.915c0-.315.253-.574.563-.574h1.874c.31 0 .563.259.563.575v1.913c0 .316-.253.575-.563.575zm5.062-.574v-1.915c0-.315-.253-.574-.563-.574h-1.874c-.31 0-.563.259-.563.575v1.913c0 .316.253.575.563.575h1.874c.31 0 .563-.259.563-.574zm4.5 0v-1.915c0-.315-.253-.574-.563-.574h-1.875c-.309 0-.562.259-.562.575v1.913c0 .316.253.575.563.575h1.875c.309 0 .562-.259.562-.574zm-4.5 4.593V18.22c0-.316-.253-.574-.563-.574h-1.874c-.31 0-.563.258-.563.574v1.914c0 .316.253.575.563.575h1.874c.31 0 .563-.259.563-.575zm-4.5 0V18.22c0-.316-.253-.574-.563-.574H8.563c-.31 0-.563.258-.563.574v1.914c0 .316.253.575.563.575h1.874c.31 0 .563-.259.563-.575zm9 0V18.22c0-.316-.253-.574-.563-.574h-1.875c-.309 0-.562.258-.562.574v1.914c0 .316.253.575.563.575h1.875c.309 0 .562-.259.562-.575zm4.5-12.441v16.844c0 1.268-1.008 2.297-2.25 2.297H5.75c-1.242 0-2.25-1.03-2.25-2.297V7.693c0-1.268 1.008-2.297 2.25-2.297H8V2.908c0-.316.253-.575.563-.575h1.874c.31 0 .563.259.563.575v2.488h6V2.908c0-.316.253-.575.563-.575h1.875c.309 0 .562.259.562.575v2.488h2.25c1.242 0 2.25 1.029 2.25 2.297zm-2.25 16.556V9.99H5.75v14.26c0 .158.127.288.281.288H21.97c.154 0 .281-.13.281-.287z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "CLOCK":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <circle cx="11.513" cy="12" r="8.75" stroke={fillColor} strokeWidth="2.5" />
                    <path
                        stroke={fillColor}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M11.513 7v5.5h3"
                    />
                </svg>
            )

        case "PIN":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M12 2C7.613 2 4.044 5.533 4 9.92c0 5.47 7.025 11.559 7.348 11.839l.002.001c.374.32.926.32 1.3 0C13 21.5 20 15.4 20 9.92 19.956 5.533 16.387 2 12 2zm0 17.65c-1.67-1.59-6-6-6-9.73 0-3.314 2.686-6 6-6s6 2.686 6 6c0 3.7-4.33 8.14-6 9.73zM12 6c-1.933 0-3.5 1.567-3.5 3.5S10.067 13 12 13s3.5-1.567 3.5-3.5S13.933 6 12 6zm0 5c-.828 0-1.5-.672-1.5-1.5S11.172 8 12 8c.829 0 1.5.672 1.5 1.5S12.829 11 12 11z"
                        clipRule="evenodd"
                    />
                </svg>
            )

        case "BOARD_PIN":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.9894 4.9502L16.52 4.42014L16.52 4.42014L15.9894 4.9502ZM19.0717 8.03562L18.5411 8.56568L18.5411 8.56568L19.0717 8.03562ZM8.73845 19.429L8.20785 19.9591L8.73845 19.429ZM4.62176 15.3081L5.15236 14.7781L4.62176 15.3081ZM17.567 14.9943L17.3032 14.2922L17.567 14.9943ZM15.6499 15.7146L15.9137 16.4167L15.6499 15.7146ZM8.33227 8.38177L7.62805 8.12375H7.62805L8.33227 8.38177ZM9.02673 6.48636L9.73095 6.74438L9.02673 6.48636ZM5.84512 10.6735L6.04445 11.3965H6.04445L5.84512 10.6735ZM7.30174 10.1351L6.86354 9.52646L6.86354 9.52646L7.30174 10.1351ZM7.6759 9.79038L8.24673 10.2768H8.24673L7.6759 9.79038ZM14.2511 16.3805L14.7421 16.9475L14.7421 16.9475L14.2511 16.3805ZM13.3807 18.2012L12.6575 18.0022V18.0022L13.3807 18.2012ZM13.917 16.7466L13.3076 16.3094L13.3076 16.3094L13.917 16.7466ZM2.71854 12.7552L1.96855 12.76V12.76L2.71854 12.7552ZM2.93053 11.9521L2.28061 11.5778H2.28061L2.93053 11.9521ZM11.3053 21.3431L11.3064 20.5931H11.3064L11.3053 21.3431ZM12.0933 21.1347L11.7216 20.4833L11.7216 20.4833L12.0933 21.1347ZM11.6973 2.03606L11.8589 2.76845L11.6973 2.03606ZM15.4588 5.48026L18.5411 8.56568L19.6023 7.50556L16.52 4.42014L15.4588 5.48026ZM9.26905 18.8989L5.15236 14.7781L4.09116 15.8382L8.20785 19.9591L9.26905 18.8989ZM17.3032 14.2922L15.3861 15.0125L15.9137 16.4167L17.8308 15.6964L17.3032 14.2922ZM9.03649 8.63979L9.73095 6.74438L8.32251 6.22834L7.62805 8.12375L9.03649 8.63979ZM6.04445 11.3965C6.75591 11.2003 7.29726 11.0625 7.73995 10.7438L6.86354 9.52646C6.6906 9.65097 6.46608 9.72428 5.64578 9.95044L6.04445 11.3965ZM7.62805 8.12375C7.3351 8.92332 7.24345 9.14153 7.10507 9.30391L8.24673 10.2768C8.60048 9.86175 8.78237 9.33337 9.03649 8.63979L7.62805 8.12375ZM7.73995 10.7438C7.92704 10.6091 8.09719 10.4523 8.24673 10.2768L7.10507 9.30391C7.03377 9.38757 6.95268 9.46229 6.86354 9.52646L7.73995 10.7438ZM15.3861 15.0125C14.697 15.2714 14.1717 15.4571 13.7601 15.8135L14.7421 16.9475C14.9029 16.8082 15.1193 16.7152 15.9137 16.4167L15.3861 15.0125ZM14.1038 18.4001C14.3291 17.5813 14.4022 17.3569 14.5263 17.1838L13.3076 16.3094C12.9903 16.7517 12.853 17.2919 12.6575 18.0022L14.1038 18.4001ZM13.7601 15.8135C13.5904 15.9605 13.4385 16.1269 13.3076 16.3094L14.5263 17.1838C14.5888 17.0968 14.6612 17.0175 14.7421 16.9475L13.7601 15.8135ZM5.15236 14.7781C4.50623 14.1313 4.06806 13.691 3.78374 13.3338C3.49842 12.9753 3.46896 12.8201 3.46852 12.7505L1.96855 12.76C1.97223 13.3422 2.26135 13.8297 2.6101 14.2679C2.95984 14.7073 3.47123 15.2176 4.09116 15.8382L5.15236 14.7781ZM5.64578 9.95044C4.80056 10.1835 4.10403 10.3743 3.58304 10.5835C3.06349 10.792 2.57124 11.0732 2.28061 11.5778L3.58045 12.3264C3.61507 12.2663 3.717 12.146 4.14187 11.9755C4.56531 11.8055 5.16345 11.6394 6.04445 11.3965L5.64578 9.95044ZM3.46852 12.7505C3.46758 12.6016 3.50623 12.4553 3.58045 12.3264L2.28061 11.5778C2.07362 11.9372 1.96593 12.3452 1.96855 12.76L3.46852 12.7505ZM8.20785 19.9591C8.83172 20.5836 9.34472 21.0987 9.78654 21.4506C10.2271 21.8015 10.718 22.0922 11.3042 22.0931L11.3064 20.5931C11.237 20.593 11.0815 20.5644 10.7211 20.2773C10.3619 19.9912 9.91931 19.5499 9.26905 18.8989L8.20785 19.9591ZM12.6575 18.0022C12.4133 18.8897 12.2463 19.4924 12.0752 19.9188C11.9034 20.3467 11.7822 20.4487 11.7216 20.4833L12.4651 21.7861C12.9741 21.4956 13.2573 21.0004 13.4672 20.4775C13.6777 19.9532 13.8695 19.2516 14.1038 18.4001L12.6575 18.0022ZM11.3042 22.0931C11.7113 22.0937 12.1115 21.9879 12.4651 21.7861L11.7216 20.4833C11.5951 20.5555 11.452 20.5933 11.3064 20.5931L11.3042 22.0931ZM18.5411 8.56568C19.6046 9.63022 20.3403 10.3695 20.7918 10.9788C21.2353 11.5774 21.2864 11.8959 21.2322 12.1464L22.6983 12.4634C22.8882 11.5854 22.5383 10.8162 21.997 10.0857C21.4636 9.36592 20.6306 8.53486 19.6023 7.50556L18.5411 8.56568ZM17.8308 15.6964C19.1922 15.1849 20.2941 14.773 21.0771 14.3384C21.8719 13.8973 22.5084 13.3416 22.6983 12.4634L21.2322 12.1464C21.178 12.3968 21.0002 12.6655 20.3492 13.0268C19.6865 13.3946 18.7113 13.7632 17.3032 14.2922L17.8308 15.6964ZM16.52 4.42014C15.4841 3.3832 14.6481 2.54353 13.9246 2.00638C13.1909 1.46165 12.4175 1.10912 11.5357 1.30367L11.8589 2.76845C12.1086 2.71335 12.4278 2.7633 13.0305 3.21075C13.6434 3.66579 14.3877 4.40801 15.4588 5.48026L16.52 4.42014ZM9.73095 6.74438C10.2526 5.32075 10.6162 4.33403 10.9813 3.66315C11.3403 3.00338 11.6091 2.82357 11.8589 2.76845L11.5357 1.30367C10.6541 1.49819 10.1006 2.14332 9.6637 2.94618C9.23286 3.73793 8.82695 4.85154 8.32251 6.22834L9.73095 6.74438Z"
                    />
                    <path
                        opacity="0.5"
                        fill={fillColor}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.4694 21.4697C1.17666 21.7627 1.1769 22.2376 1.46994 22.5304C1.76298 22.8231 2.23786 22.8229 2.5306 22.5298L1.4694 21.4697ZM7.18383 17.8719C7.47657 17.5788 7.47633 17.1039 7.18329 16.8112C6.89024 16.5185 6.41537 16.5187 6.12263 16.8117L7.18383 17.8719ZM2.5306 22.5298L7.18383 17.8719L6.12263 16.8117L1.4694 21.4697L2.5306 22.5298Z"
                    />
                </svg>
            )

        case "BOARD_PIN_FILLED":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.1835 7.80516L16.2188 4.83755C14.1921 2.8089 13.1788 1.79457 12.0904 2.03468C11.0021 2.2748 10.5086 3.62155 9.5217 6.31506L8.85373 8.1381C8.59063 8.85617 8.45908 9.2152 8.22239 9.49292C8.11619 9.61754 7.99536 9.72887 7.86251 9.82451C7.56644 10.0377 7.19811 10.1392 6.46145 10.3423C4.80107 10.8 3.97088 11.0289 3.65804 11.5721C3.5228 11.8069 3.45242 12.0735 3.45413 12.3446C3.45809 12.9715 4.06698 13.581 5.28476 14.8L6.69935 16.2163L2.22345 20.6964C1.92552 20.9946 1.92552 21.4782 2.22345 21.7764C2.52138 22.0746 3.00443 22.0746 3.30236 21.7764L7.77841 17.2961L9.24441 18.7635C10.4699 19.9902 11.0827 20.6036 11.7134 20.6045C11.9792 20.6049 12.2404 20.5358 12.4713 20.4041C13.0192 20.0914 13.2493 19.2551 13.7095 17.5825C13.9119 16.8472 14.013 16.4795 14.2254 16.1835C14.3184 16.054 14.4262 15.9358 14.5468 15.8314C14.8221 15.593 15.1788 15.459 15.8922 15.191L17.7362 14.4981C20.4 13.4973 21.7319 12.9969 21.9667 11.9115C22.2014 10.826 21.1954 9.81905 19.1835 7.80516Z"
                    />
                </svg>
            )

        case "BOOKMARK":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                        fill="#62B1FF"
                        fillRule="evenodd"
                        d="M6 21c-.172 0-.34-.045-.49-.13-.314-.177-.51-.51-.51-.87V5.33C4.972 4.082 5.953 3.043 7.2 3h9.6c1.248.043 2.228 1.082 2.2 2.33V20c-.002.355-.192.682-.5.86-.31.179-.69.179-1 0l-5.67-3.21-5.33 3.2c-.15.093-.323.145-.5.15z"
                        clipRule="evenodd"
                    />
                </svg>
            )

        case "BELL":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M20.52 15.21l-1.8-1.81V8.94c.05-3.425-2.435-6.361-5.82-6.88-3.69-.486-7.076 2.112-7.562 5.802-.038.288-.058.578-.058.868v4.67l-1.8 1.81c-.635.646-.627 1.684.02 2.32.304.299.713.467 1.14.47H8v.34c.097 2.114 1.886 3.75 4 3.66 2.114.09 3.903-1.546 4-3.66V18h3.36c.906-.005 1.636-.744 1.63-1.65-.002-.426-.17-.836-.47-1.14zM14 18.34c-.115 1-.997 1.73-2 1.66-1.003.07-1.885-.66-2-1.66V18h4v.34z"
                        clipRule="evenodd"
                    />
                </svg>
            )

        case "ACTIVE_WITH_STROKE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        stroke="#E6E6E6"
                        strokeWidth="2"
                        d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11z"
                    />
                    <path
                        stroke="#E6E6E6"
                        strokeWidth="2"
                        d="M16.056 8.494l.027-.036c.06-.04.142-.04.202.006l.605-.792-.605.792c.077.059.091.168.033.244h0l-5.329 6.996v.001c-.032.04-.08.064-.131.064h-.003c-.051 0-.1-.023-.131-.062l-2.832-3.624s0 0 0 0c-.057-.073-.043-.179.03-.236.073-.056.178-.044.235.029 0 0 0 0 0 0l1.9 2.46.8 1.035.789-1.044 4.41-5.833z"
                    />
                </svg>
            )
        case "CROSS_CIRCLE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width={size || 32}
                    height={size || 32}
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        stroke={fillColor}
                        strokeWidth="3"
                        d="M30.5 16c0 8.008-6.492 14.5-14.5 14.5S1.5 24.008 1.5 16 7.992 1.5 16 1.5 30.5 7.992 30.5 16z"
                    />
                    <path
                        stroke={fillColor}
                        strokeWidth="2"
                        d="M17.276 15.293L16.57 16l.707.707 4.252 4.251-.57.57-4.251-4.252L16 16.57l-.707.707-4.252 4.252-.569-.57 4.252-4.25.707-.708-.707-.707-4.252-4.252.57-.569 4.25 4.252.708.707.707-.707 4.251-4.252.57.57-4.252 4.251z"
                    />
                </svg>
            )
        case "PROGRAM":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M25.348 7.155l-4.453-4.457c-.351-.351-.728-.319-1.051-.319v5.822h5.822c0-.342.03-.698-.318-1.046zm-6.96 1.41V2.379H9.293c-.605 0-1.091.487-1.091 1.092v4.957c.832-.227.89-.227 1.203-.227.738 0 1.46.303 1.98.832.396.436.2.318.831.49.958.261 1.712 1.024 1.966 1.992.142.6.028.394.49.863.693.706.966 1.74.713 2.7-.17.602-.168.365 0 1.006.254.96-.02 1.995-.713 2.7-.439.427-.32.223-.49.865-.222.845-.825 1.535-1.614 1.87v4.148h12.007c.605 0 1.092-.487 1.092-1.092V9.657H19.48c-.6 0-1.091-.492-1.091-1.092zm-4.756 9.2c.337-.342.468-.841.345-1.31-.247-.939-.247-.806 0-1.747.123-.467-.008-.967-.345-1.31-.676-.687-.61-.573-.858-1.513-.123-.467-.482-.833-.942-.958-.922-.252-.811-.186-1.487-.874-.336-.342-.827-.476-1.286-.35-.924.252-.794.251-1.717 0-.46-.126-.95.008-1.286.35-.679.69-.569.623-1.487.874-.46.126-.819.49-.942.958-.249.944-.182.825-.859 1.514-.336.342-.468.841-.344 1.31.248.941.246.808 0 1.746-.124.468.008.967.344 1.31.676.687.611.573.859 1.513.123.468.482.833.942.958.65.178.524.135.72.228v5.203L8.2 24.21l2.911 1.456v-5.203c.196-.092.07-.05.72-.227.46-.126.82-.491.943-.959.248-.943.182-.824.858-1.513zm-5.431.625c-1.608 0-2.911-1.303-2.911-2.911s1.303-2.911 2.91-2.911c1.608 0 2.912 1.303 2.912 2.91 0 1.609-1.304 2.912-2.911 2.912z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "MORE_VERTICAL":
            return (
                <svg className={className} version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512">
                    <g>
                        <path
                            fill={fillColor}
                            d="M315.1,452.9c0,32.6-26.5,59.1-59.1,59.1s-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1S315.1,420.3,315.1,452.9z
		 M315.1,256c0,32.6-26.5,59.1-59.1,59.1s-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1S315.1,223.4,315.1,256z M315.1,59.1
		c0,32.6-26.5,59.1-59.1,59.1s-59.1-26.5-59.1-59.1S223.4,0,256,0S315.1,26.5,315.1,59.1z"
                        />
                    </g>
                </svg>
            )
        case "SCHEDULE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18 4h-1V3c0-.552-.448-1-1-1s-1 .448-1 1v1H9V3c0-.552-.448-1-1-1s-1 .448-1 1v1H6C4.343 4 3 5.343 3 7v12c0 1.657 1.343 3 3 3h12c1.657 0 3-1.343 3-3V7c0-1.657-1.343-3-3-3zM8 17c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm8 0h-4c-.552 0-1-.448-1-1s.448-1 1-1h4c.552 0 1 .448 1 1s-.448 1-1 1zm3-6H5V7c0-.552.448-1 1-1h1v1c0 .552.448 1 1 1s1-.448 1-1V6h6v1c0 .552.448 1 1 1s1-.448 1-1V6h1c.552 0 1 .448 1 1v4z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "CALENDAR_FILL":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M8.946 13.813H7.34c-.265 0-.482-.222-.482-.493v-1.64c0-.271.217-.492.482-.492h1.607c.266 0 .483.221.483.492v1.64c0 .271-.217.492-.483.492zm4.34-.493v-1.64c0-.271-.217-.492-.482-.492h-1.608c-.265 0-.482.221-.482.492v1.64c0 .271.217.492.482.492h1.608c.265 0 .482-.221.482-.492zm3.857 0v-1.64c0-.271-.217-.492-.482-.492h-1.607c-.266 0-.483.221-.483.492v1.64c0 .271.217.492.483.492h1.607c.265 0 .482-.221.482-.492zm-3.857 3.938v-1.64c0-.271-.217-.493-.482-.493h-1.608c-.265 0-.482.222-.482.492v1.64c0 .271.217.493.482.493h1.608c.265 0 .482-.221.482-.492zm-3.857 0v-1.64c0-.271-.217-.493-.483-.493H7.34c-.265 0-.482.222-.482.492v1.64c0 .271.217.493.482.493h1.607c.266 0 .483-.221.483-.492zm7.714 0v-1.64c0-.271-.217-.493-.482-.493h-1.607c-.266 0-.483.222-.483.492v1.64c0 .271.217.493.483.493h1.607c.265 0 .482-.221.482-.492zM21 6.594V21.03C21 22.118 20.136 23 19.071 23H4.93C3.864 23 3 22.118 3 21.031V6.594c0-1.087.864-1.969 1.929-1.969h1.928V2.492c0-.27.217-.492.482-.492h1.607c.266 0 .483.221.483.492v2.133h5.142V2.492c0-.27.217-.492.483-.492h1.607c.265 0 .482.221.482.492v2.133h1.928c1.065 0 1.929.882 1.929 1.969zm-1.929 14.191V8.562H4.93v12.223c0 .136.108.246.24.246H18.83c.133 0 .241-.11.241-.246z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "BOX":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18.667 7H9.333C8.045 7 7 8.043 7 9.332v9.333c0 1.289 1.045 2.333 2.333 2.333h9.334C19.955 21 21 19.955 21 18.666V9.333c0-1.289-1.045-2.334-2.333-2.334zM9.333 4.665c-2.577 0-4.666 2.09-4.666 4.667v9.333c0 2.577 2.089 4.667 4.666 4.667h9.334c2.577 0 4.666-2.09 4.666-4.667V9.333c0-2.578-2.089-4.667-4.666-4.667H9.333z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "TIME_CLOCK_OUTLINE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path fill={fillColor} d="M0 0h28v28H0V0z" opacity=".01" />
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M23.333 14c0 5.155-4.178 9.334-9.333 9.334s-9.333-4.179-9.333-9.333c0-5.155 4.178-9.334 9.333-9.334s9.333 4.179 9.333 9.334zm2.334 0c0 6.444-5.224 11.667-11.667 11.667S2.333 20.444 2.333 14.001C2.333 7.557 7.557 2.334 14 2.334s11.667 5.223 11.667 11.667zm-10.5-5.833c0-.644-.523-1.166-1.167-1.166s-1.167.522-1.167 1.166v6.417c0 .644.523 1.167 1.167 1.167h3.5c.644 0 1.167-.523 1.167-1.167s-.523-1.167-1.167-1.167h-2.333v-5.25z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "NOTES":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M9.607 4c-.52 0-.94.42-.94.94v.12c0 .52.42.94.94.94H21.06c.52 0 .94-.42.94-.94v-.12c0-.52-.42-.94-.94-.94H9.607zM2 11.94c0-.52.42-.94.94-.94h18.12c.52 0 .94.42.94.94v.12c0 .52-.42.94-.94.94H2.94c-.52 0-.94-.42-.94-.94v-.12zm0 7c0-.52.42-.94.94-.94h18.12c.52 0 .94.42.94.94v.12c0 .52-.42.94-.94.94H2.94c-.52 0-.94-.42-.94-.94v-.12z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "CHEVRON_DOWN":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        stroke={fillColor}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 8l-8 8-8-8"
                    />
                </svg>
            )
        case "COURSE":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M7.544 17.012c-.407-.406-.195-.291-1.176-.554-.445-.12-.836-.348-1.19-.623l-2.122 5.204c-.205.504.178 1.051.722 1.03l2.465-.093 1.695 1.79c.375.395 1.032.272 1.237-.231l2.435-5.971c-.507.282-1.07.448-1.652.448-.912 0-1.77-.355-2.414-1zm13.365 4.027l-2.123-5.204c-.354.275-.745.504-1.19.623-.985.264-.77.149-1.175.554-.645.645-1.502 1-2.415 1-.582 0-1.145-.166-1.652-.448l2.435 5.97c.206.504.863.627 1.237.233l1.696-1.791 2.465.094c.543.02.927-.527.722-1.03zm-5.605-5.085c.715-.728.797-.665 1.815-.943.65-.177 1.158-.694 1.332-1.355.35-1.329.259-1.168 1.214-2.14.476-.485.661-1.19.487-1.852-.35-1.328-.35-1.143 0-2.472.174-.661-.011-1.367-.487-1.852-.955-.972-.864-.812-1.214-2.14-.174-.662-.682-1.178-1.332-1.356-1.304-.356-1.147-.263-2.103-1.235-.476-.485-1.17-.674-1.82-.497-1.303.356-1.121.356-2.428 0-.65-.177-1.343.012-1.819.497-.955.972-.798.88-2.102 1.235-.65.178-1.158.694-1.332 1.356-.35 1.328-.26 1.168-1.214 2.14-.476.485-.662 1.19-.488 1.852.35 1.327.35 1.142 0 2.471-.174.662.012 1.368.488 1.852.954.973.864.812 1.214 2.14.174.662.682 1.18 1.332 1.357 1.047.285 1.125.24 1.814.942.619.63 1.583.743 2.327.272.607-.385 1.382-.385 1.99 0 .743.47 1.707.358 2.326-.272zM7.57 8.279c0-2.48 1.976-4.492 4.413-4.492 2.438 0 4.414 2.011 4.414 4.492s-1.976 4.492-4.414 4.492c-2.437 0-4.413-2.01-4.413-4.492z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "PROFILE_FILL":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M19.5 0h-15C3.12 0 2 1.008 2 2.25v19.5C2 22.992 3.12 24 4.5 24h15c1.38 0 2.5-1.008 2.5-2.25V2.25C22 1.008 20.88 0 19.5 0zM9.75 1.5h4.5c.412 0 .75.337.75.75s-.338.75-.75.75h-4.5C9.338 3 9 2.663 9 2.25s.338-.75.75-.75zm2.25 6c1.655 0 3 1.345 3 3s-1.345 3-3 3-3-1.345-3-3 1.345-3 3-3zm5.25 11.1c0 .497-.469.9-1.05.9H7.8c-.581 0-1.05-.403-1.05-.9v-.9c0-1.49 1.41-2.7 3.15-2.7h.234c.577.24 1.205.375 1.866.375.66 0 1.294-.136 1.866-.375h.234c1.74 0 3.15 1.21 3.15 2.7v.9z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "CONTACT":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M22 3H2C.896 3 0 3.864 0 4.929V19.07C0 20.136.896 21 2 21h20c1.104 0 2-.864 2-1.929V4.93C24 3.864 23.104 3 22 3zM7.333 7C8.804 7 10 8.196 10 9.667c0 1.47-1.196 2.666-2.667 2.666-1.47 0-2.666-1.196-2.666-2.666C4.667 8.196 5.863 7 7.333 7zM12 16.867c0 .441-.417.8-.933.8H3.6c-.517 0-.933-.359-.933-.8v-.8c0-1.325 1.254-2.4 2.8-2.4h.208c.513.212 1.07.333 1.658.333.588 0 1.15-.12 1.659-.333H9.2c1.546 0 2.8 1.075 2.8 2.4v.8zm9.333-2.2c0 .183-.15.333-.333.333h-6c-.183 0-.333-.15-.333-.333V14c0-.183.15-.333.333-.333h6c.183 0 .333.15.333.333v.667zm0-2.667c0 .183-.15.333-.333.333h-6c-.183 0-.333-.15-.333-.333v-.667c0-.183.15-.333.333-.333h6c.183 0 .333.15.333.333V12zm0-2.667c0 .184-.15.334-.333.334h-6c-.183 0-.333-.15-.333-.334v-.666c0-.184.15-.334.333-.334h6c.183 0 .333.15.333.334v.666z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "LOCK_ACCESS_FILL":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M17 8h-1V6.11c0-2.21-1.79-4-4-4s-4 1.79-4 4V8H7c-1.657 0-3 1.343-3 3v8c0 1.657 1.343 3 3 3h10c1.657 0 3-1.343 3-3v-8c0-1.657-1.343-3-3-3zm-7-1.89c-.028-1.134.866-2.077 2-2.11 1.134.033 2.028.976 2 2.11V8h-4V6.11zM12 18c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "LOCK_ACCESS":
            return (
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.332 10.666h1.333a4 4 0 0 1 4 4v10.666a4 4 0 0 1-4 4H9.332a4 4 0 0 1-4-4V14.666a4 4 0 0 1 4-4h1.333v-2.52a5.333 5.333 0 1 1 10.667 0v2.52zm-5.333-5.334a2.747 2.747 0 0 0-2.667 2.814v2.52h5.333v-2.52A2.747 2.747 0 0 0 16 5.332zm8 20c0 .737-.597 1.334-1.334 1.334H9.332a1.333 1.333 0 0 1-1.333-1.334V14.666c0-.736.597-1.334 1.333-1.334h13.333c.737 0 1.334.598 1.334 1.334v10.666zm-8-9.333a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 5.333a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666z"
                    />
                </svg>
            )
        case "ATTACH":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className={className}>
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M9.29 21c-1.669-.008-3.265-.685-4.43-1.88-2.405-2.28-2.507-6.077-.227-8.482l.007-.008L12 3.2c.794-.793 1.878-1.226 3-1.2 1.201.004 2.35.49 3.19 1.35 1.721 1.657 1.788 4.39.15 6.13l-7.4 7.43c-.479.482-1.13.752-1.81.75-.734.001-1.437-.295-1.95-.82-1.056-1.022-1.091-2.704-.08-3.77l6.83-6.86c.46-.306 1.08-.18 1.386.28.229.344.222.793-.016 1.13l-6.83 6.86c-.237.285-.201.708.08.95.14.142.33.224.53.23.15.002.293-.055.4-.16l7.39-7.43c.863-.959.796-2.433-.15-3.31-.877-.91-2.313-.977-3.27-.15L6.06 12c-1.505 1.617-1.415 4.148.202 5.653l.018.017c.786.815 1.867 1.28 3 1.29.976.008 1.916-.374 2.61-1.06l7.39-7.43c.39-.392 1.023-.394 1.415-.005.392.39.394 1.023.005 1.415l-7.39 7.43c-1.06 1.079-2.508 1.687-4.02 1.69z"
                        />
                    </g>
                </svg>
            )
        case "FILTER":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    className={className}>
                    <g fill="none" fillRule="evenodd" transform="translate(.6)">
                        <path
                            fill={fillColor}
                            d="M9.778 19.636h5.171v-2.545H9.778v2.545zM.728 4.364v2.545H24V4.364H.727zm3.878 8.909h15.515v-2.546H4.606v2.546z"
                        />
                    </g>
                </svg>
            )
        case "DOOR":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="77"
                    height="78"
                    className={className}
                    viewBox="0 0 77 78">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            fillRule="nonzero"
                            d="M36.735 40.828c1.395 0 2.527-1.546 2.527-3.453 0-1.907-1.132-3.453-2.527-3.453-1.394 0-2.526 1.546-2.526 3.453 0 1.907 1.132 3.453 2.526 3.453zM72.107 59.82h-11.79V21.992c0-2.941-2.267-5.336-5.053-5.336h-8.422V13.33c0-2.024-1.557-3.58-3.363-3.58-.27 0-.546.035-.824.109l-20.213 5.367c-1.499.399-2.55 1.83-2.55 3.472V59.82H8.1c-.93 0-1.684.773-1.684 1.727v1.726C6.417 64.227 7.17 65 8.1 65h64.006c.93 0 1.685-.773 1.685-1.727v-1.726c0-.954-.754-1.727-1.685-1.727zm-30.318 0H24.945V19.913l16.844-4.473v44.38zm13.475 0h-8.422V21.836h8.422V59.82z"
                        />
                    </g>
                </svg>
            )
        case "DOOR_OPEN":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="17"
                    fill="none"
                    viewBox="0 0 21 17"
                    className={className}>
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M16.8 15.406h3.675c.29 0 .525.238.525.531v.532c0 .293-.235.531-.525.531H.525C.235 17 0 16.762 0 16.469v-.532c0-.293.235-.53.525-.53H4.2V2.752c0-.505.328-.945.795-1.068l6.3-1.651c.087-.023.173-.034.257-.034.563 0 1.048.479 1.048 1.102v1.023h2.625c.868 0 1.575.737 1.575 1.642v11.64zM10.237 8.5c0 .587-.352 1.063-.787 1.063-.435 0-.787-.476-.787-1.063s.352-1.063.787-1.063c.435 0 .788.476.788 1.063zm.788 6.906h-5.25V3.127l5.25-1.376v13.655zm1.575 0h2.625V3.72H12.6v11.687z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "DOOR_OPEN_1":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.833 6.175a2 2 0 0 1 1.451-1.923l8.833-2.523a2 2 0 0 1 2.55 1.923v16.697a2 2 0 0 1-2.55 1.923l-8.833-2.524a2 2 0 0 1-1.45-1.923V6.175zm19.083 12.158a1.75 1.75 0 0 1-1.75 1.75h-1.75v-1.5h1.75a.25.25 0 0 0 .25-.25V5.667a.25.25 0 0 0-.25-.25h-1.75v-1.5h1.75c.967 0 1.75.783 1.75 1.75v12.666zM12 12.917a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "TASK_FILL":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.302 2a1.62 1.62 0 0 0-.145.672c0 .898.728 1.192 1.626 1.192h4.384c.899 0 1.627-.294 1.627-1.192 0-.24-.052-.467-.145-.672h2.619a3.253 3.253 0 0 1 3.253 3.253v14.494A3.253 3.253 0 0 1 18.268 23H5.682a3.253 3.253 0 0 1-3.252-3.253V5.253A3.253 3.253 0 0 1 5.682 2h2.62zm3.886 13.152a.813.813 0 0 0 0 1.626h5.055a.813.813 0 0 0 0-1.626h-5.055zm-.813-5.657c0-.449.364-.813.813-.813h5.055a.813.813 0 1 1 0 1.626h-5.055a.813.813 0 0 1-.813-.813zM5.683 8.364c0-.45.364-.813.813-.813h2.439c.45 0 .813.364.813.813v2.44a.813.813 0 0 1-.813.812h-2.44a.813.813 0 0 1-.812-.813v-2.44zm3.973 5.9c.334.301.36.815.06 1.149l-1.718 1.909a.813.813 0 0 1-1.209 0l-1.145-1.273a.813.813 0 0 1 1.209-1.088l.54.601 1.114-1.237a.813.813 0 0 1 1.149-.06z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "BLUB":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M13 5c0 .552-.448 1-1 1s-1-.448-1-1V3c0-.552.448-1 1-1s1 .448 1 1v2zm-1 2c-2.761 0-5 2.239-5 5 0 1.574.741 3.056 2 4v4c0 1.105.895 2 2 2h2c1.105 0 2-.895 2-2v-4c2.21-1.657 2.657-4.79 1-7-.944-1.259-2.426-2-4-2zm1.5 7.59c-.31.18-.501.511-.5.87V20h-2v-4.54c.001-.359-.19-.69-.5-.87-.926-.534-1.497-1.521-1.5-2.59 0-1.657 1.343-3 3-3s3 1.343 3 3c-.003 1.069-.574 2.056-1.5 2.59zM21 11h-2c-.552 0-1 .448-1 1s.448 1 1 1h2c.552 0 1-.448 1-1s-.448-1-1-1zM3 11h2c.552 0 1 .448 1 1s-.448 1-1 1H3c-.552 0-1-.448-1-1s.448-1 1-1zm4.66-4.58L6.22 5c-.406-.384-1.046-.366-1.43.04-.384.406-.366 1.046.04 1.43l1.44 1.39c.195.189.459.29.73.28.272-.001.532-.113.72-.31.372-.406.345-1.037-.06-1.41zm10.12-1.37c.39-.388 1.02-.388 1.41 0l.006.006c.389.392.386 1.025-.006 1.414l-1.44 1.39c-.185.179-.433.279-.69.28-.272-.001-.532-.113-.72-.31-.388-.39-.388-1.02 0-1.41l1.44-1.37z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "FILE_TEXT":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M19.74 7.33l-4.44-5c-.19-.21-.458-.33-.74-.33h-8C5.163 1.983 4.017 3.102 4 4.5v15c.016 1.397 1.162 2.517 2.56 2.5h10.88c1.397.017 2.543-1.102 2.56-2.5V8c0-.248-.093-.487-.26-.67zM9 12h3c.552 0 1 .448 1 1s-.448 1-1 1H9c-.552 0-1-.448-1-1s.448-1 1-1zm6 6H9c-.552 0-1-.448-1-1s.448-1 1-1h6c.552 0 1 .448 1 1s-.448 1-1 1zm-.29-10c-.429-.042-.745-.42-.71-.85V4l3.74 4h-3.03z"
                        clipRule="evenodd"
                    />
                </svg>
            )

        case "EMOJI":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="38"
                    height="38"
                    viewBox="0 0 38 38">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            fillRule="nonzero"
                            d="M19 0C8.504 0 0 8.504 0 19s8.504 19 19 19 19-8.504 19-19S29.496 0 19 0zm0 34.323C10.55 34.323 3.677 27.45 3.677 19S10.55 3.677 19 3.677 34.323 10.55 34.323 19 27.45 34.323 19 34.323zm-6.129-16.549c1.356 0 2.452-1.095 2.452-2.451s-1.096-2.452-2.452-2.452c-1.356 0-2.452 1.096-2.452 2.452 0 1.356 1.096 2.451 2.452 2.451zm12.258 0c1.356 0 2.452-1.095 2.452-2.451s-1.096-2.452-2.452-2.452c-1.356 0-2.452 1.096-2.452 2.452 0 1.356 1.096 2.451 2.452 2.451zm.306 5.562c-1.593 1.916-3.945 3.019-6.435 3.019-2.49 0-4.842-1.096-6.435-3.019-.652-.781-1.816-.88-2.59-.237-.781.651-.881 1.808-.237 2.59 2.298 2.757 5.677 4.336 9.262 4.336 3.585 0 6.964-1.579 9.262-4.337.652-.781.544-1.938-.237-2.59-.774-.643-1.938-.543-2.59.238z"
                        />
                    </g>
                </svg>
            )
        case "USER":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="25"
                    height="24"
                    viewBox="0 0 25 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M12 13c3.866 0 7 3.134 7 7l-.007.117c-.057.497-.48.883-.993.883H6c-.552 0-1-.448-1-1l.004-.24C5.131 16.004 8.214 13 12 13zm0-10c2.21 0 4 1.79 4 4s-1.79 4-4 4l-.2-.005C9.684 10.891 8 9.142 8 7l.005-.2C8.109 4.684 9.858 3 12 3z"
                            transform="translate(.167)"
                        />
                    </g>
                </svg>
            )
        case "FORWARD":
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}>
                    <path
                        d="M9.519 3.875a.54.54 0 0 1 .922-.382l4.03 4.034a.54.54 0 0 1 0 .764l-4.03 4.034a.54.54 0 0 1-.922-.383v-1.821c-3.398 0-5.886.97-7.736 3.074-.164.186-.468.028-.402-.211.954-3.449 3.284-6.67 8.138-7.363V3.875z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "SETTINGS_2":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    className={className}
                    viewBox="0 0 24 24">
                    <path fill={fillColor} d="M0 0h24v24H0V0z" opacity=".01" />
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M10.219 2.245c.621-1.66 2.94-1.66 3.563 0l.147.395c.413 1.102 1.697 1.575 2.712 1l.364-.207c1.53-.867 3.307.643 2.73 2.32l-.138.398c-.383 1.113.3 2.31 1.443 2.531l.41.079c1.722.332 2.125 2.645.618 3.553l-.358.216c-1 .603-1.237 1.965-.5 2.878l.263.327c1.109 1.376-.051 3.41-1.782 3.125l-.411-.068c-1.15-.189-2.196.7-2.211 1.879l-.006.422c-.023 1.775-2.203 2.579-3.348 1.234l-.272-.32c-.76-.893-2.126-.893-2.886 0l-.272.32c-1.145 1.345-3.325.541-3.348-1.234l-.006-.422c-.016-1.179-1.062-2.068-2.21-1.879l-.412.068c-1.731.285-2.89-1.75-1.782-3.125l.264-.327c.736-.913.499-2.275-.501-2.878l-.358-.216C.425 11.406.828 9.093 2.55 8.761l.41-.079c1.143-.22 1.826-1.418 1.443-2.53l-.137-.4c-.578-1.676 1.199-3.186 2.729-2.319l.364.206c1.015.576 2.299.103 2.712-1l.148-.394zM17 12c0 2.761-2.239 5-5 5s-5-2.239-5-5 2.239-5 5-5 5 2.239 5 5z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "CONTACT_1":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18.75 0H5.25C4.008 0 3 1.008 3 2.25v19.5C3 22.992 4.008 24 5.25 24h13.5c1.242 0 2.25-1.008 2.25-2.25V2.25C21 1.008 19.992 0 18.75 0zm-9 1.5h4.5c.412 0 .75.337.75.75s-.338.75-.75.75h-4.5C9.338 3 9 2.663 9 2.25s.338-.75.75-.75zm2.25 6c1.655 0 3 1.345 3 3s-1.345 3-3 3-3-1.345-3-3 1.345-3 3-3zm5.25 11.1c0 .497-.469.9-1.05.9H7.8c-.581 0-1.05-.403-1.05-.9v-.9c0-1.49 1.41-2.7 3.15-2.7h.234c.577.24 1.205.375 1.866.375.66 0 1.294-.136 1.866-.375h.234c1.74 0 3.15 1.21 3.15 2.7v.9z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "PROFILE_LINE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M12 11c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.104 0 2 .895 2 2s-.896 2-2 2c-1.105 0-2-.895-2-2s.895-2 2-2zM5 20c0-3.866 3.134-7 7-7s7 3.134 7 7c0 .552-.448 1-1 1s-1-.448-1-1c0-2.761-2.239-5-5-5s-5 2.239-5 5c0 .552-.448 1-1 1s-1-.448-1-1z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "LDA": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M17.982 3h-12C4.325 3.01 2.99 4.36 3 6.018c.005.839.361 1.638.982 2.202V18c0 1.657 1.343 3 3 3h10c1.657 0 3-1.343 3-3V8.22c1.226-1.114 1.317-3.012.203-4.238-.565-.62-1.364-.977-2.203-.982zm-3 10.13c0 .48-.39.87-.87.87h-4.26c-.48 0-.87-.39-.87-.87v-.26c0-.48.39-.87.87-.87h4.26c.48 0 .87.39.87.87v.26zm3-6.13h-12c-.552 0-1-.448-1-1s.448-1 1-1h12c.553 0 1 .448 1 1s-.447 1-1 1z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "PERSON_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path fill={fillColor} d="M0 0h28v28H0V0z" opacity=".01" />
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M10.5 12.833c2.578 0 4.667-2.089 4.667-4.666 0-2.578-2.089-4.667-4.666-4.667-2.578 0-4.667 2.09-4.667 4.667s2.09 4.666 4.667 4.666zm9.334 2.334c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5-3.5 1.567-3.5 3.5 1.567 3.5 3.5 3.5zm5.833 7c0 .644-.522 1.166-1.166 1.166h-5.834c0 .645-.522 1.167-1.166 1.167h-14c-.645 0-1.167-.522-1.167-1.167.003-2.156.859-4.224 2.38-5.752 3.184-3.196 8.355-3.206 11.55-.023 1.02-.79 2.274-1.219 3.565-1.22 3.222-.002 5.836 2.607 5.838 5.829z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "PERSON_REMOVE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M11.667 12.833c2.577 0 4.666-2.089 4.666-4.666 0-2.578-2.089-4.667-4.666-4.667C9.089 3.5 7 5.59 7 8.167s2.09 4.666 4.667 4.666zM24.5 7h-4.667c-.644 0-1.166.522-1.166 1.167 0 .644.522 1.166 1.166 1.166H24.5c.644 0 1.167-.522 1.167-1.166C25.667 7.522 25.144 7 24.5 7zm-4.667 16.333c0 .645-.522 1.167-1.166 1.167h-14c-.645 0-1.167-.522-1.167-1.167 0-4.51 3.656-8.166 8.167-8.166 4.51 0 8.166 3.656 8.166 8.166z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CLIPBOARD_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M8.167 8.166c0 .645.522 1.167 1.166 1.167h9.334c.644 0 1.166-.522 1.166-1.167V3.5c0-.645-.522-1.167-1.166-1.167H9.333c-.644 0-1.166.522-1.166 1.167v4.666zm12.833 0v-3.5c1.933 0 3.5 1.567 3.5 3.5v14c0 1.933-1.567 3.5-3.5 3.5H7c-1.933 0-3.5-1.567-3.5-3.5v-14c0-1.933 1.567-3.5 3.5-3.5v3.5C7 9.455 8.045 10.5 9.333 10.5h9.334C19.955 10.5 21 9.455 21 8.166z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "FILE_LINE_ALT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M23.855 6.798l-3.823-3.822c-.41-.41-.966-.643-1.545-.643H9.188c-1.207.005-2.187.984-2.187 2.192v3.641h2.187V4.525h7.29v4.738c0 .606.488 1.094 1.094 1.094h4.741v13.122H11.376v2.187H22.31c1.207 0 2.19-.98 2.19-2.187V8.347c0-.578-.235-1.139-.645-1.549zm-5.19 1.372V4.702l3.467 3.468h-3.467zm-6.222 9.58c.337-.344.469-.844.346-1.313-.248-.94-.248-.808 0-1.75.123-.47-.009-.97-.346-1.313-.677-.689-.612-.574-.86-1.516-.123-.469-.483-.835-.944-.96-.924-.252-.813-.187-1.49-.875-.337-.344-.828-.478-1.289-.352-.926.253-.795.252-1.72 0-.46-.126-.951.009-1.289.352-.68.691-.57.624-1.49.875-.46.126-.82.492-.943.96-.249.945-.182.826-.86 1.516-.337.344-.469.843-.345 1.313.248.943.247.81 0 1.75-.124.47.008.97.345 1.312.677.689.612.575.86 1.517.123.469.483.835.944.96.652.178.525.135.722.228v5.212L7 24.208l2.917 1.458v-5.212c.196-.092.069-.05.722-.228.46-.126.82-.492.943-.96.25-.946.183-.827.861-1.517zm-5.442.625c-1.61 0-2.917-1.306-2.917-2.917 0-1.611 1.307-2.917 2.917-2.917 1.61 0 2.917 1.306 2.917 2.917 0 1.611-1.306 2.917-2.917 2.917z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }

        case "EMOJI_2":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M12 21.5c5.247 0 9.5-4.253 9.5-9.5S17.247 2.5 12 2.5 2.5 6.753 2.5 12s4.253 9.5 9.5 9.5zm0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
                        clipRule="evenodd"
                    />
                    <circle cx="7.5" cy="9.5" r="1.5" fill={fillColor} />
                    <circle cx="16.5" cy="9.5" r="1.5" fill={fillColor} />
                    <path
                        fill={fillColor}
                        d="M5.828 14c-.267 0-.46.258-.363.508.022.057.044.114.068.17.352.85.867 1.622 1.517 2.272.65.65 1.422 1.165 2.271 1.517.85.352 1.76.533 2.679.533.92 0 1.83-.181 2.679-.533.849-.352 1.62-.867 2.27-1.517.65-.65 1.166-1.422 1.518-2.271.024-.057.046-.114.068-.171.096-.25-.096-.508-.363-.508H5.828z"
                    />
                </svg>
            )
        case "SHARE":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M20.795 9.97c.273-.27.273-.726 0-.995l-5.894-5.792c-.412-.404-1.082-.096-1.082.498v3.064C7.649 8.035 2.853 13.357 2 20c2.467-4.027 6.75-6.974 11.819-7.883v3.147c0 .594.67.902 1.082.498l5.894-5.792z"
                        clipRule="evenodd"
                    />
                </svg>
            )

        case "COMPLETE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="68"
                    height="68"
                    fill="none"
                    viewBox="0 0 68 68">
                    <g filter="url(#filter0_d)">
                        <circle cx="34" cy="32" r="22" fill="#18A957" />
                    </g>
                    <path
                        fill="#fff"
                        d="M49 32c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15z"
                    />
                    <path
                        stroke="#18A957"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4"
                        d="M27 30.5l5.31 5.5L41 27"
                    />
                    <defs>
                        <filter
                            id="filter0_d"
                            width="68"
                            height="68"
                            x="0"
                            y="0"
                            colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                            <feOffset dy="2" />
                            <feGaussianBlur stdDeviation="6" />
                            <feColorMatrix values="0 0 0 0 0.188235 0 0 0 0 0.192157 0 0 0 0 0.2 0 0 0 0.1 0" />
                            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                        </filter>
                    </defs>
                </svg>
            )
        }
        case "TICK": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="13"
                    fill="none"
                    viewBox="0 0 18 13">
                    <path
                        stroke={fillColor}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4"
                        d="M2 5.5L7.31 11 16 2"
                    />
                </svg>
            )
        }
        case "MESSAGE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M25.333 4H6.667c-2.21 0-4 1.79-4 4v20c0 .481.26.924.68 1.16.199.113.424.173.653.173.24 0 .474-.064.68-.186l5.987-3.627c.221-.132.476-.197.733-.187h13.933c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zM10.667 16c-.737 0-1.334-.597-1.334-1.333 0-.737.597-1.334 1.334-1.334.736 0 1.333.597 1.333 1.334 0 .736-.597 1.333-1.333 1.333zM16 16c-.736 0-1.333-.597-1.333-1.333 0-.737.597-1.334 1.333-1.334s1.333.597 1.333 1.334c0 .736-.596 1.333-1.333 1.333zm5.333 0C20.597 16 20 15.403 20 14.667c0-.737.597-1.334 1.333-1.334.737 0 1.334.597 1.334 1.334 0 .736-.597 1.333-1.334 1.333z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }

        case "SHARE_LINE":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M15.319 7.964l-1.193.25c-3.325.695-6.23 2.713-8.182 5.534 2.221-1.525 4.809-2.605 7.61-3.108l1.764-.317v2.925l3.843-3.776-3.843-3.775v2.267zM4.203 17.168C3.363 18.032 2.623 18.982 2 20c.163-1.268.47-2.488.902-3.641 1.832-4.887 5.924-8.57 10.916-9.614V3.681c0-.594.671-.902 1.083-.498l5.894 5.792c.273.269.273.726 0 .995l-5.894 5.791c-.412.405-1.082.097-1.082-.497v-3.147c-.509.09-1.01.202-1.5.334-3.17.846-5.968 2.505-8.116 4.717z"
                        clipRule="evenodd"
                    />
                </svg>
            )

        case "EMAIL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <circle cx="16" cy="16" r="16" fill="#1E90FF" />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M21.6 9.6H10.4C9.075 9.6 8 10.674 8 12v8c0 1.325 1.075 2.4 2.4 2.4h11.2c1.325 0 2.4-1.075 2.4-2.4v-8c0-1.326-1.075-2.4-2.4-2.4zm0 1.6l-5.2 3.576c-.247.143-.552.143-.8 0L10.4 11.2h11.2z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }

        case "EMAIL_FILL":
            return (
                <svg className={className} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm0 2-6.5 4.47a1 1 0 0 1-1 0L5 6h14z"
                        fill="#1E90FF"
                    />
                </svg>
            )

        case "PHONE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <circle cx="16" cy="16" r="16" fill="#1E90FF" />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M20.32 24C13.52 23.99 8.009 18.48 8 11.68 8 9.647 9.648 8 11.68 8c.207-.002.413.017.616.056.196.029.39.077.576.144.267.094.465.322.52.6l1.096 4.8c.06.265-.018.542-.208.736-.104.112-.112.12-1.096.632.788 1.729 2.17 3.117 3.896 3.912.52-.992.528-1 .64-1.104.194-.19.471-.268.736-.208l4.8 1.096c.269.062.486.259.576.52.067.19.118.385.152.584.032.2.048.404.048.608-.03 2.023-1.689 3.642-3.712 3.624z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "TRASH_LINE":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M13.659 2c1.262.039 2.294 1.05 2.341 2.33V6h5c.552 0 1 .448 1 1s-.448 1-1 1h-1v11c0 1.657-1.343 3-3 3H7c-1.657 0-3-1.343-3-3V8H3c-.552 0-1-.448-1-1s.448-1 1-1h5V4.33C8.049 2.997 9.167 1.955 10.5 2zM18 8H6v11l.007.117c.057.497.48.883.993.883h10c.552 0 1-.448 1-1V8zm-9 3c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1l-.117-.007C8.386 16.936 8 16.513 8 16v-4c0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1l-.117-.007c-.497-.057-.883-.48-.883-.993v-4c0-.552.448-1 1-1zm-1.5-7h-3c-.29 0-.5.17-.5.33V6h4V4.33c0-.16-.21-.33-.5-.33z"
                    />
                </svg>
            )
        case "PUSH_PIN":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path fill={fillColor} d="M0 0h24v24H0V0z" opacity=".01" />
                    <path
                        fill={fillColor}
                        d="M14.73 2.406c.54-.541 1.419-.541 1.96 0l4.904 4.898c.541.541.541 1.419 0 1.96l-3.923 3.919-.662 5.952c-.128 1.154-1.537 1.648-2.359.827l-4.824-4.82L2.96 22H1l7.845-7.838-4.824-4.82c-.822-.82-.328-2.228.828-2.356l5.958-.661 3.922-3.92z"
                    />
                </svg>
            )
        case "MESSAGE_READ":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M21.639 6.244L11.424 16.93l-.086.108c-.201.305-.155.715.128.97.318.287.815.27 1.11-.04L22.79 7.283l.087-.11c.2-.304.155-.714-.128-.97-.318-.286-.815-.268-1.11.04zM16.14 6.24L6.4 16.337 2.355 12.21l-.107-.09c-.3-.214-.725-.194-1.004.064-.314.29-.327.774-.027 1.08l4.617 4.711.111.094c.314.22.757.186 1.032-.098l10.31-10.686.088-.108c.202-.304.158-.714-.123-.97-.317-.289-.814-.273-1.11.034z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "LOCATION_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <circle cx="16" cy="16" r="16" fill="#1E90FF" />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M16 8c-3.51 0-6.364 2.826-6.4 6.336 0 4.376 5.62 9.247 5.88 9.47v.002c.3.256.741.256 1.04 0 .28-.208 5.88-5.088 5.88-9.472C22.367 10.826 19.51 8 16 8zm0 8.8c-1.546 0-2.8-1.254-2.8-2.8 0-1.546 1.254-2.8 2.8-2.8 1.547 0 2.8 1.254 2.8 2.8 0 1.546-1.253 2.8-2.8 2.8zm.85-1.952c.468-.468.468-1.228 0-1.697-.47-.468-1.23-.468-1.698 0-.468.47-.468 1.229 0 1.697.469.47 1.229.47 1.697 0z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CONTACT_FAMILY": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="none"
                    viewBox="0 0 48 48">
                    <rect width="48" height="48" fill="#E6E6E6" rx="12" />
                    <path
                        fill="#666"
                        fillRule="evenodd"
                        d="M17.5 12.333c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm2.25 6.854h-.532c-1.065.45-2.325.468-3.435 0h-.533c-1.243 0-2.25.924-2.25 2.063v5.844c0 .57.504 1.03 1.125 1.03h.75v5.845c0 .57.504 1.03 1.125 1.03h3c.621 0 1.125-.46 1.125-1.03v-5.844h.75c.621 0 1.125-.462 1.125-1.031V21.25c0-1.14-1.007-2.063-2.25-2.063zM30 13c1.473 0 2.666 1.194 2.666 2.667 0 1.472-1.193 2.666-2.666 2.666-1.473 0-2.666-1.194-2.666-2.666C27.334 14.194 28.527 13 30 13zm5.3 15.09l-2.132-8c-.119-.444-.546-.757-1.035-.757h-.505c-1.01.436-2.204.454-3.256 0h-.505c-.49 0-.916.313-1.035.758l-2.133 8c-.168.63.34 1.242 1.034 1.242h2.49v4.334c0 .552.477 1 1.066 1h1.422c.589 0 1.066-.448 1.066-1v-4.334h2.49c.692 0 1.202-.611 1.034-1.242z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CONTACT_HOME": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="none"
                    viewBox="0 0 48 48">
                    <rect width="48" height="48" fill="#E6E6E6" rx="12" />
                    <path
                        fill="#666"
                        fillRule="evenodd"
                        d="M24.828 12.683l8.996 9.194c.434.45.677 1.053.676 1.68v9.776c.002 1.24-.967 2.265-2.205 2.334h-3.628v-10.5c0-.645-.523-1.167-1.167-1.167h-7c-.644 0-1.166.522-1.166 1.167v10.5h-3.629c-1.238-.069-2.207-1.094-2.205-2.334v-9.776c-.007-.625.237-1.226.677-1.669l8.995-9.205.007-.006c.457-.454 1.196-.451 1.65.006zm1.505 13.65h-4.666V34.5h4.666v-8.167z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CONTACT_MEDICAL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="none"
                    viewBox="0 0 48 48">
                    <rect width="48" height="48" fill="#E6E6E6" rx="12" />
                    <path
                        fill="#666"
                        fillRule="evenodd"
                        d="M37.3 29.555h-.7V24.67c0-.574-.223-1.125-.617-1.532l-4.37-4.513c-.394-.406-.928-.637-1.484-.637H28.2v-2.168c0-1.197-.94-2.169-2.1-2.169h-14c-1.16 0-2.1.972-2.1 2.169v14.456c0 1.197.94 2.169 2.1 2.169h.7c0 2.394 1.881 4.337 4.2 4.337s4.2-1.943 4.2-4.337h5.6c0 2.394 1.881 4.337 4.2 4.337s4.2-1.943 4.2-4.337h2.1c.385 0 .7-.325.7-.723v-1.446c0-.397-.315-.723-.7-.723zM17 34.614c-1.16 0-2.1-.972-2.1-2.17 0-1.196.94-2.168 2.1-2.168 1.16 0 2.1.972 2.1 2.169s-.94 2.168-2.1 2.168zm6.3-11.205c0 .199-.158.361-.35.361H20.5v2.53c0 .2-.157.362-.35.362h-2.1c-.192 0-.35-.163-.35-.362v-2.53h-2.45c-.193 0-.35-.162-.35-.36v-2.17c0-.198.157-.36.35-.36h2.45v-2.53c0-.2.158-.362.35-.362h2.1c.193 0 .35.162.35.361v2.53h2.45c.192 0 .35.163.35.362v2.168zM31 34.614c-1.16 0-2.1-.971-2.1-2.168s.94-2.169 2.1-2.169c1.16 0 2.1.972 2.1 2.169s-.94 2.168-2.1 2.168zm3.5-9.396h-6.3v-5.06h1.93l4.37 4.513v.547z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "ADD_CIRCLE_BLUE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="66"
                    height="66"
                    fill="none"
                    viewBox="0 0 66 66">
                    <path
                        fill="#E9F4FF"
                        fillRule="evenodd"
                        d="M33 66c18.225 0 33-14.775 33-33S51.225 0 33 0 0 14.775 0 33s14.775 33 33 33z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M33 57c13.255 0 24-10.745 24-24S46.255 9 33 9 9 19.745 9 33s10.745 24 24 24z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M33 20.5c-1.105 0-2 .895-2 2V31h-8.5c-1.105 0-2 .895-2 2s.895 2 2 2H31v8.5c0 1.105.895 2 2 2s2-.895 2-2V35h8.5c1.105 0 2-.895 2-2s-.895-2-2-2H35v-8.5c0-1.105-.895-2-2-2z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "MESSAGE_UNREAD":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path fill={fillColor} d="M0 0h24v24H0V0z" opacity=".01" />
                    <path
                        fill={fillColor}
                        d="M6.399 16.337l9.742-10.096c.297-.307.794-.323 1.11-.035.282.257.326.667.124.97l-.087.11L6.977 17.97c-.275.284-.718.318-1.032.098l-.11-.094-4.618-4.712c-.3-.305-.287-.788.027-1.079.28-.258.703-.278 1.004-.064l.107.09 4.044 4.127 9.742-10.096L6.4 16.337z"
                    />
                </svg>
            )
        case "MINUS":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M19 13H5c-.552 0-1-.448-1-1s.448-1 1-1h14c.552 0 1 .448 1 1s-.448 1-1 1z"
                        />
                    </g>
                </svg>
            )

        case "RIGHT_OUTLINED": {
            return (
                <svg width="16" height="16" viewBox="0 0 16 16" className={className}>
                    <path
                        fillRule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                    />
                </svg>
            )
        }
        case "LEFT_OUTLINED": {
            return (
                <svg width="16" height="16" viewBox="0 0 16 16" className={className}>
                    <path
                        fillRule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                </svg>
            )
        }
        case "VERTICAL_LEFT_OUTLINED": {
            return (
                <svg width="16" height="16" viewBox="0 0 16 16" className={className}>
                    <path
                        fillRule="evenodd"
                        d="M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0zM11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"
                    />
                </svg>
            )
        }
        case "VERTICAL_RIGHT_OUTLINED": {
            return (
                <svg width="16" height="16" viewBox="0 0 16 16" className={className}>
                    <path
                        fillRule="evenodd"
                        d="M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0zM4.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"
                    />
                </svg>
            )
        }
        case "SKIP_PAGE_LEFT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="22"
                    fill="none"
                    viewBox="0 0 15 22">
                    <path stroke={color} strokeLinecap="round" strokeWidth="1.5" d="M14.25 21.25L14.25 0.75" />
                    <path
                        stroke={color}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M1 1l10 10L1 21"
                    />
                </svg>
            )
        }
        case "SKIP_PAGE_RIGHT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="22"
                    fill="none"
                    viewBox="0 0 15 22">
                    <path stroke={color} strokeLinecap="round" strokeWidth="1.5" d="M14.25 21.25L14.25 0.75" />
                    <path
                        stroke={color}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M1 1l10 10L1 21"
                    />
                </svg>
            )
        }
        case "ARROW_RIGHT_1": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="22"
                    fill="none"
                    viewBox="0 0 12 22">
                    <path
                        stroke={color}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M1 1l10 10L1 21"
                    />
                </svg>
            )
        }
        case "DOWNLOAD": {
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fill="none" fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M19 16c.552 0 1 .448 1 1v2c0 .513-.386.936-.883.993L19 20H5c-.552 0-1-.448-1-1v-2c0-.513.386-.936.883-.993L5 16c.552 0 1 .448 1 1v.999h12V17c0-.513.386-.936.883-.993L19 16zm-6.001-3.993L15.4 10.2c.442-.331 1.069-.242 1.4.2.331.442.242 1.069-.2 1.4l-4 3c-.138.104-.3.17-.471.192L12 15c-.207.002-.41-.061-.58-.18l-4-2.82c-.414-.294-.538-.846-.305-1.283l.065-.107c.317-.452.94-.562 1.393-.245l.007.005 2.423 1.692L11 12V4c0-.552.448-1 1-1 .513 0 .936.386.993.883L13 4l-.001 8.007z"
                        />
                    </g>
                </svg>
            )
        }
        case "TARGET": {
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path fill="#1E90FF" d="M12 16c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" />
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zm-1.5 0c0 5.247-4.253 9.5-9.5 9.5S2.5 17.247 2.5 12 6.753 2.5 12 2.5s9.5 4.253 9.5 9.5z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "LOCK_CHECKMARK": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M17 8h-1V6.11c0-2.21-1.79-4-4-4s-4 1.79-4 4V8H7c-1.657 0-3 1.343-3 3v8c0 1.657 1.343 3 3 3h10c1.657 0 3-1.343 3-3v-8c0-1.657-1.343-3-3-3zm-7-1.89c-.028-1.134.866-2.077 2-2.11 1.134.033 2.028.976 2 2.11V8h-4V6.11zm5.718 7.586c.384-.396.375-1.029-.021-1.414-.397-.384-1.03-.375-1.415.021l-3.164 3.261-1.4-1.442c-.385-.397-1.018-.406-1.414-.021-.397.384-.406 1.017-.022 1.413l2.118 2.182c.188.194.447.304.718.304.27 0 .529-.11.717-.304l3.883-4z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "RATES": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill="#1E90FF"
                        d="M11 9.458v10.084c0 .253.224.458.5.458s.5-.205.5-.458V9.458c0-.253-.224-.458-.5-.458s-.5.205-.5.458z"
                    />
                    <path
                        fill="#1E90FF"
                        stroke="#1E90FF"
                        d="M14 11h-3.75C9.007 11 8 11.881 8 12.969c0 1.087 1.007 1.969 2.25 1.969h2.5c.69 0 1.25.49 1.25 1.093 0 .604-.56 1.094-1.25 1.094H8.5c-.276 0-.5.196-.5.438 0 .241.224.437.5.437h4.25c1.243 0 2.25-.881 2.25-1.969 0-1.087-1.007-1.968-2.25-1.968h-2.5c-.69 0-1.25-.49-1.25-1.094 0-.604.56-1.094 1.25-1.094H14c.276 0 .5-.196.5-.438 0-.241-.224-.437-.5-.437z"
                    />
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M19.74 8.33l-5.44-6c-.19-.21-.458-.33-.74-.33h-7C5.163 1.984 4.017 3.103 4 4.5v15c.016 1.397 1.162 2.517 2.56 2.5h10.88c1.397.017 2.543-1.102 2.56-2.5V9c0-.248-.093-.486-.26-.67zM14 5l2.74 3h-2c-.435-.026-.767-.4-.741-.836L14 7.15V5zM6.56 20H17.442c.292.016.542-.207.558-.5V10h-3.29c-1.533-.043-2.744-1.316-2.71-2.85V4H6.558c-.292-.016-.542.208-.558.5v15.002c.017.292.268.515.56.498z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "WORK": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="23"
                    fill="none"
                    viewBox="0 0 24 23">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M10.704 2.519c-.67 0-1.24.466-1.4 1.094h5.382c-.16-.628-.73-1.094-1.4-1.094h-2.582zm5.503 1.094h1.981C20.29 3.613 22 5.344 22 7.47c0 0-.06.9-.08 2.154-.002.099-.05.196-.13.255-.48.355-.92.65-.96.67-1.661 1.113-3.591 1.897-5.647 2.287-.134.026-.267-.044-.335-.163-.576-.999-1.652-1.649-2.853-1.649-1.193 0-2.28.643-2.872 1.643-.07.117-.2.185-.333.16-2.039-.391-3.969-1.174-5.62-2.269l-.96-.668c-.08-.05-.13-.142-.13-.243C2.05 9.132 2 7.471 2 7.471c0-2.127 1.71-3.858 3.812-3.858h1.97C7.974 2.144 9.205 1 10.705 1h2.582c1.5 0 2.731 1.144 2.921 2.613zm5.453 8.202l-.04.02c-2.021 1.357-4.452 2.259-7.004 2.633-.36.051-.72-.182-.82-.546-.22-.83-.93-1.378-1.781-1.378h-.03c-.85 0-1.56.547-1.78 1.378-.1.364-.461.597-.821.546-2.552-.374-4.983-1.276-7.004-2.633-.01-.01-.11-.07-.19-.02-.09.05-.09.172-.09.172l.07 5.165C2.17 19.279 3.87 21 5.972 21h12.046c2.101 0 3.802-1.721 3.802-3.848l.08-5.165s0-.121-.09-.172c-.05-.03-.11-.02-.15 0zm-8.915 4.243c0 .426-.33.76-.75.76-.41 0-.75-.334-.75-.76v-1.306c0-.415.34-.76.75-.76.42 0 .75.345.75.76v1.306z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "COPY_SMALL": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18 9h-3V5.67c-.005-1.472-1.198-2.665-2.67-2.67H5.67C4.198 3.005 3.005 4.198 3 5.67v6.66c.005 1.472 1.198 2.665 2.67 2.67H9v3c0 1.657 1.343 3 3 3h6c1.657 0 3-1.343 3-3v-6c0-1.657-1.343-3-3-3zm-9 3v1H5.67c-.37 0-.67-.3-.67-.67V5.67c0-.37.3-.67.67-.67h6.66c.37 0 .67.3.67.67V9h-1c-1.657 0-3 1.343-3 3z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "POINTS_BIG": {
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    fill="none"
                    viewBox="0 0 48 48"
                    className={className}>
                    <circle r="24" fill="#F7D98F" transform="matrix(1 0 0 -1 24 24)" />
                    <circle r="21.58" fill="url(#paint0_linear)" transform="matrix(1 0 0 -1 24 24)" />
                    <path
                        fill="#fff"
                        d="M23.26 10.191c.28-.65 1.201-.65 1.481 0l3.268 7.59c.117.271.373.457.667.484l8.228.763c.705.066.99.942.458 1.41l-6.208 5.453c-.222.195-.32.496-.255.784l1.817 8.061c.156.69-.59 1.233-1.199.871l-7.105-4.219c-.254-.15-.57-.15-.824 0l-7.105 4.22c-.609.36-1.355-.181-1.199-.872l1.817-8.061c.065-.288-.033-.589-.255-.784l-6.208-5.453c-.532-.468-.247-1.345.458-1.41l8.228-.763c.294-.027.55-.213.667-.484l3.268-7.59z"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear"
                            x1="27.947"
                            x2="21.58"
                            y1="-.461"
                            y2="43.16"
                            gradientUnits="userSpaceOnUse">
                            <stop stopColor="#F5BA2A" />
                            <stop offset=".292" stopColor="#F7C447" />
                            <stop offset=".599" stopColor="#F9D172" />
                            <stop offset="1" stopColor="#F2B92E" />
                        </linearGradient>
                    </defs>
                </svg>
            )
        }
        case "ADMISSION_START_DATE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <circle r="12" fill="#1E90FF" transform="matrix(1 0 0 -1 12 12)" />
                    <path
                        fill="#fff"
                        d="M11.599 3.97c.151-.37.65-.37.802 0l1.77 4.307c.063.154.202.26.36.275l4.457.433c.381.037.535.535.247.8l-3.361 3.096c-.12.11-.173.281-.138.445l.984 4.576c.084.392-.32.7-.65.494l-3.847-2.395c-.138-.085-.309-.085-.446 0l-3.848 2.395c-.33.205-.733-.102-.649-.494l.984-4.576c.035-.164-.018-.334-.138-.445L4.764 9.785c-.288-.265-.133-.763.248-.8l4.456-.433c.16-.015.298-.12.36-.275l1.77-4.308z"
                    />
                </svg>
            )
        }
        case "EXPAND": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M26.767 5C27.447 5 28 5.552 28 6.233V12.4c0 .681-.552 1.233-1.233 1.233s-1.233-.552-1.233-1.233V9.218l-6.418 6.417-.007.007c-.484.48-1.264.477-1.744-.007l-.007-.007c-.48-.484-.477-1.264.007-1.744l6.405-6.417H20.6c-.681 0-1.233-.552-1.233-1.234 0-.68.552-1.233 1.233-1.233h6.167zM5.233 29C4.553 29 4 28.448 4 27.767v-6.165c0-.681.552-1.234 1.233-1.234s1.233.553 1.233 1.234v3.18l6.418-6.417.008-.007c.483-.48 1.264-.477 1.743.007l.008.007c.48.483.476 1.264-.008 1.744L8.23 26.534h3.168c.681 0 1.234.552 1.234 1.233 0 .68-.553 1.233-1.233 1.233H5.232z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CHECK_CIRCLE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 29.333c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333C8.636 2.667 2.667 8.637 2.667 16c0 7.364 5.97 13.333 13.333 13.333zM32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
                        fill={fillColor}
                    />
                    <path
                        d="m21.142 11.124.062-.082a.565.565 0 0 1 .712-.021l.568-.745-.568.745c.248.189.296.543.107.791l.795.607-.796-.606-7.105 9.329-.002.002a.555.555 0 0 1-.437.215l.002 1-.005-1a.555.555 0 0 1-.438-.21l-.001-.001-3.776-4.832v-.001a.557.557 0 0 1 .88-.684l2.533 3.279.8 1.036.79-1.044 5.88-7.778zM9.472 16.93l3.78 4.838-3.78-4.838z"
                        stroke={fillColor}
                        strokeWidth="2"
                    />
                </svg>
            )
        }
        case "CALENDAR_FILL_INPUT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18 4h-1V3c0-.552-.448-1-1-1s-1 .448-1 1v1H9V3c0-.552-.448-1-1-1s-1 .448-1 1v1H6C4.343 4 3 5.343 3 7v12c0 1.657 1.343 3 3 3h12c1.657 0 3-1.343 3-3V7c0-1.657-1.343-3-3-3zM8 17c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm8 0h-4c-.552 0-1-.448-1-1s.448-1 1-1h4c.552 0 1 .448 1 1s-.448 1-1 1zm3-6H5V7c0-.552.448-1 1-1h1v1c0 .552.448 1 1 1s1-.448 1-1V6h6v1c0 .552.448 1 1 1s1-.448 1-1V6h1c.552 0 1 .448 1 1v4z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CHECKMARK_CIRCLE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm7.664 10.731l-7.44 9.955c-.308.407-.783.646-1.287.647-.502.003-.976-.23-1.287-.63l-3.973-5.16c-.553-.724-.425-1.768.285-2.331.71-.564 1.735-.434 2.288.29l2.654 3.451 6.155-8.296c.549-.733 1.577-.874 2.296-.315.72.559.858 1.606.31 2.34v.05z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CROSS_CIRCLE_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M16 0C7.161 0 0 7.161 0 16s7.161 16 16 16 16-7.161 16-16S24.839 0 16 0zm7.845 20.2c.303.303.303.794 0 1.097l-2.555 2.548c-.303.303-.793.303-1.096 0L16 19.613l-4.2 4.232c-.303.303-.793.303-1.097 0L8.155 21.29c-.303-.303-.303-.793 0-1.096L12.387 16l-4.232-4.2c-.303-.303-.303-.793 0-1.097l2.555-2.555c.303-.303.793-.303 1.096 0L16 12.388l4.2-4.233c.303-.303.794-.303 1.097 0l2.555 2.555c.303.303.303.793 0 1.096L19.613 16l4.232 4.2z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "BREAK_END": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <image
                        width="24"
                        x="0"
                        y="0"
                        height="24"
                        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAvVJREFUSEu1lV2IFXUYxn/PLFvZxwqBBrbnnN30IjFYyUK7CAmiz5tqISsSEixBrTNnIYzqLsjQ8MzZuzAoKYvWrEwougoivEgWFgqENNqdc1oQL7QNM12cJ2bcPe4ez65TW3P5n3ee3/u+/+d9R/zPj+bT797jm4OAfsEjhlXAsqn4huBYIr5UJ1/EW3V6Lp22gJ73fF0ywQ7MANAF/Io4IjiZChluwdwD3Ib43WaXE6qNAZ1rBV0B6Km6JxGfAndiDgSwc7SikXYZ9lS9Ogl4DdMPDCcJjzUG9NvM2FmAWwfd3ZFwBLhBYuNYWV/luaJS1Q9b7AfOJgnrZkKagBWDvvaCOYrpThLWNwb0Y6t4MfLz6Vkcau8V7/Z4FQHfAyeCxdw7ukl/pTFNQCny64Y3DA/VQ33TLvNC5G/T83qo++Z4/6Dga8SrcVlvNQErBt11IWFccHgs1NNzteVqgPS7YuQhxAN00pu6K6ugVPVmi72Iu+KyhhcC6B1038WEEZtN9YrevwSI/LlhZRzq9vkuNU8FU1X8bPipHuqJDFCMfFxwdCzUM/8FoBB5v2BNmnAGSCd28iLnT76ss1cDCPoQl9tohlpdVaz5Tcz2OFTXvKuiFVaI/LZE36zzNoBC1bslXohDLf5HgDxDN9XyfcDaZosKkd+VuWnJ9Tw7vEWTadCad9x56k8+BCbiirIBy/sUI/9iGKmHShclFKv+BPEkcHDJIrI5OHWOj4F+0hZUtCGv+LRNEc/FZe3LAFm204JwcEosXWAZcLqqPJBizQcw9wemd7SiM5fvYMgdpXE+MJcq+DfipaoftTiMeCUua1dzVWRyLQDDZ0sX8VTe7As13yHzHeJ40MX6WctuoS0q1Zz+8T7CTLiDdfUXNT7dzgVdciHy3YIdmRnEDw54fKZ4s0Xz2dTij3qozWnw8t1eOtnJNmBl9seD5cAZxM5rRO3ESzrfaoTcg1aIvEEQATcCDcMxiUNBwqHULXM5LDcgj0XbxfwNzvdXKEyPW9MAAAAASUVORK5CYII="
                    />
                </svg>
            )
        }
        case "BREAK_START": {
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M22.998 12c0 6.075-4.925 11-11 11-.695 0-1.375-.064-2.035-.188l2.39-1.319c5.083-.186 9.145-4.365 9.145-9.493a9.5 9.5 0 0 0-9.5-9.5c-4.949 0-9.014 3.785-9.46 8.618a1.933 1.933 0 0 0-1.51.077C1.438 5.495 6.193 1 11.997 1c6.075 0 11 4.925 11 11z"
                        fill="#1E90FF"
                    />
                    <path
                        d="M12.748 6a.75.75 0 0 0-1.5 0v6.75h4.75a.75.75 0 0 0 0-1.5h-3.25V6zM9.499 19.373a1.012 1.012 0 0 0 0-1.746l-6-3.49c-.667-.388-1.5.096-1.5.872v6.982c0 .776.833 1.26 1.5.872l6-3.49z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "CHECKMARK_CIRCLE_1": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        stroke={fillColor}
                        strokeWidth="2"
                        d="M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15z"
                    />
                    <path
                        stroke={fillColor}
                        strokeWidth="2"
                        d="M21.142 11.123l.062-.081c.198-.172.495-.187.712-.022l.604-.792-.604.792c.248.19.296.544.107.792h0l-7.107 9.33v.001c-.106.135-.267.215-.438.215h-.003c-.17.001-.332-.076-.438-.21l-3.777-4.833s0 0 0 0c-.189-.243-.145-.593.098-.782.242-.189.592-.146.78.096l.002.001 2.533 3.28.8 1.035.79-1.044 5.88-7.777z"
                    />
                </svg>
            )
        }
        case "UPLOAD": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    fill="none"
                    viewBox="0 0 64 64">
                    <rect width="64" height="64" fill={fillColor} rx="12" />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M15.334 28.818c.92 0 1.666.747 1.666 1.667V42c0 2.762 2.239 5 5 5h20c2.762 0 5-2.238 5-5V30.485c0-.92.746-1.667 1.667-1.667.92 0 1.667.747 1.667 1.667V42c0 4.603-3.731 8.334-8.334 8.334H22c-4.602 0-8.333-3.731-8.333-8.334V30.485c0-.92.746-1.667 1.667-1.667z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M23.222 23.761c-.637-.664-.616-1.719.048-2.357l8.73-8.38 8.73 8.38c.664.638.686 1.693.048 2.357-.637.664-1.692.686-2.356.048l-4.755-4.565v17.302c0 .92-.746 1.667-1.667 1.667-.92 0-1.666-.746-1.666-1.667V19.244l-4.755 4.565c-.664.638-1.72.616-2.357-.048z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "ALERT_WHITE": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M37.6 27.166l-12.784-21.2c-1.7-2.66-5.235-3.438-7.895-1.737-.698.446-1.291 1.04-1.738 1.738L2.4 27.167c-.92 1.532-.951 3.438-.083 5 1.003 1.758 2.875 2.84 4.9 2.833h25.566c2.011.021 3.88-1.034 4.9-2.767.894-1.579.862-3.518-.083-5.066zM20 28.334c-.92 0-1.667-.746-1.667-1.666 0-.92.746-1.667 1.667-1.667.92 0 1.666.746 1.666 1.666 0 .921-.746 1.667-1.666 1.667zm1.666-6.666c0 .92-.746 1.666-1.666 1.666-.92 0-1.667-.746-1.667-1.666V15c0-.92.746-1.667 1.667-1.667.92 0 1.666.746 1.666 1.667v6.666z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "VOL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M15 3.122c-.31-.179-.69-.179-1 0l-6.48 4.45h-5c-.552 0-1 .447-1 1v6.86c0 .552.448 1 1 1h5l6.41 4.4c.17.11.368.168.57.17.552 0 1-.448 1-1v-16c.005-.363-.186-.7-.5-.88zm-1.47 15l-5.13-3.52c-.168-.114-.367-.173-.57-.17H3.5v-4.86h4.33c.203.002.402-.057.57-.17l5.1-3.5.03 12.22zm6.11-12.89c-.425-.353-1.056-.295-1.41.13-.353.426-.295 1.057.13 1.41 1.625 1.256 2.595 3.178 2.64 5.23-.045 2.053-1.015 3.975-2.64 5.23-.425.353-.484.983-.131 1.408l.001.002c.19.229.473.36.77.36.234 0 .46-.08.64-.23 2.087-1.631 3.323-4.12 3.36-6.77-.037-2.649-1.273-5.138-3.36-6.77zm-1.36 3.139c-.348-.431-.979-.498-1.41-.15-.43.348-.498.979-.15 1.41 1.037 1.41 1.037 3.33 0 4.74-.348.429-.282 1.058.147 1.406.179.146.403.225.633.224.303 0 .59-.135.78-.37 1.63-2.146 1.63-5.115 0-7.26z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "UNION": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    fill="none"
                    viewBox="0 0 21 21">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M9.5 0c-1.105 0-2 .895-2 2v5.5H2c-1.105 0-2 .895-2 2v2c0 1.105.895 2 2 2h5.5V19c0 1.105.895 2 2 2h2c1.105 0 2-.895 2-2v-5.5H19c1.105 0 2-.895 2-2v-2c0-1.105-.895-2-2-2h-5.5V2c0-1.105-.895-2-2-2h-2z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CHECKBOX_CHECKED": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M15.201 8.396l-3.78 5-1.63-2.11c-.34-.436-.968-.515-1.405-.175-.436.34-.514.969-.175 1.405l2.43 3.11c.191.242.482.382.79.38.31 0 .601-.145.79-.39l4.57-6c.337-.442.252-1.073-.19-1.41-.442-.337-1.073-.252-1.41.19h.01z"
                        clipRule="evenodd"
                    />
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18 21H6c-1.657 0-3-1.343-3-3V6c0-1.657 1.343-3 3-3h12c1.657 0 3 1.343 3 3v12c0 1.657-1.343 3-3 3zM6 5c-.552 0-1 .448-1 1v12c0 .552.448 1 1 1h12c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H6z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "COLUMNS": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        d="M17.905 4.571c0-1.052.853-1.904 1.904-1.904h7.62c1.052 0 1.904.852 1.904 1.904s-.852 1.905-1.904 1.905h-7.62c-1.051 0-1.904-.853-1.904-1.905zM17.905 12.19c0-1.051.853-1.904 1.904-1.904h7.62c1.052 0 1.904.853 1.904 1.905 0 1.051-.852 1.904-1.904 1.904h-7.62c-1.051 0-1.904-.853-1.904-1.905zM17.905 19.81c0-1.052.853-1.905 1.904-1.905h7.62c1.052 0 1.904.852 1.904 1.904s-.852 1.905-1.904 1.905h-7.62c-1.051 0-1.904-.852-1.904-1.904zM17.905 27.429c0-1.052.853-1.905 1.904-1.905h7.62c1.052 0 1.904.853 1.904 1.905s-.852 1.904-1.904 1.904h-7.62c-1.051 0-1.904-.852-1.904-1.904zM2.667 4.571c0-1.052.852-1.904 1.904-1.904h7.62c1.051 0 1.904.852 1.904 1.904s-.853 1.905-1.905 1.905H4.572c-1.052 0-1.904-.853-1.904-1.905zM2.667 12.19c0-1.051.852-1.904 1.904-1.904h7.62c1.051 0 1.904.853 1.904 1.905 0 1.051-.853 1.904-1.905 1.904H4.572c-1.052 0-1.904-.853-1.904-1.905zM2.667 19.81c0-1.052.852-1.905 1.904-1.905h7.62c1.051 0 1.904.852 1.904 1.904s-.853 1.905-1.905 1.905H4.572c-1.052 0-1.904-.852-1.904-1.904zM2.667 27.429c0-1.052.852-1.905 1.904-1.905h7.62c1.051 0 1.904.853 1.904 1.905s-.853 1.904-1.905 1.904H4.572c-1.052 0-1.904-.852-1.904-1.904z"
                    />
                </svg>
            )
        }
        case "PIE_CHART": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M20 12.455c.552 0 1.005.448.95.998-.163 1.625-.722 3.19-1.635 4.557-1.1 1.645-2.66 2.926-4.488 3.683-1.827.757-3.838.955-5.778.57-1.94-.386-3.722-1.339-5.12-2.737-1.399-1.399-2.351-3.18-2.737-5.12-.386-1.94-.188-3.951.57-5.778C2.517 6.8 3.8 5.238 5.443 4.14c1.367-.913 2.933-1.472 4.558-1.635.55-.056.998.397.998.95v8c0 .552.448 1 1 1h8z"
                    />
                    <path
                        fill={fillColor}
                        d="M12.33 1.955c0-.553.449-1.006.998-.95.971.097 1.924.336 2.829.71 1.213.503 2.316 1.24 3.244 2.169.929.928 1.665 2.03 2.168 3.244.375.904.614 1.858.711 2.828.055.55-.398.999-.95.999h-8.6c-.22 0-.4-.18-.4-.4v-8.6z"
                    />
                </svg>
            )
        }
        case "ARROW_DOWN_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        d="M13.975 24.506c1.122 1.103 2.928 1.103 4.05 0l10.449-10.279c1.828-1.798.546-4.894-2.025-4.894H5.551c-2.572 0-3.853 3.096-2.025 4.894l10.449 10.279z"
                    />
                </svg>
            )
        }
        case "ARROW_UP_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        d="M13.975 7.494c1.122-1.103 2.928-1.103 4.05 0l10.449 10.279c1.828 1.798.546 4.894-2.025 4.894H5.551c-2.572 0-3.853-3.096-2.025-4.894L13.975 7.494z"
                    />
                </svg>
            )
        }
        case "EVENT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M16 6H8c-1.105 0-2 .895-2 2v8c0 1.105.895 2 2 2h8c1.105 0 2-.895 2-2V8c0-1.105-.895-2-2-2zM8 4C5.79 4 4 5.79 4 8v8c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4H8z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "ACADEMIC": {
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M10.747 3.549c.728-.414 1.62-.418 2.35-.01l9.443 5.266c.614.343.614 1.226 0 1.569l-9.443 5.266c-.73.407-1.622.404-2.35-.01l-8.94-5.084v6.992c0 .193-.157.35-.35.35-.193 0-.349-.157-.349-.35v-7.484c0-.033.005-.065.013-.095-.178-.399-.052-.907.376-1.15l9.25-5.26zm-6.244 9.386v3.37c0 .36.194.693.507.87l5.766 3.276c.728.414 1.62.418 2.35.01l5.894-3.287c.317-.177.513-.51.513-.873v-3.395l-6.436 3.59c-.731.407-1.622.404-2.35-.01l-6.244-3.55z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "FIN_AID_FILL": {
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    className={className}>
                    <rect width="22" height="22" x="1" y="1" fill={fillColor} rx="6" />
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M11.272 6.667v-2c0-.369.325-.667.727-.667.402 0 .727.298.727.667v2h2.91c.401 0 .727.298.727.666 0 .368-.326.667-.727.667h-2.91v3.333h1.091c1.808 0 3.273 1.343 3.273 3s-1.465 3-3.273 3h-1.09v2c0 .369-.326.667-.728.667-.402 0-.727-.299-.727-.667v-2H7.635c-.401 0-.727-.298-.727-.666 0-.369.326-.667.727-.667h3.637v-3.333H10.18c-1.808 0-3.273-1.344-3.273-3 0-1.657 1.465-3 3.273-3h1.09zm0 1.333H10.18c-1.004 0-1.818.746-1.818 1.667 0 .92.814 1.666 1.818 1.666h1.09V8zm1.454 4.667V16h1.091c1.005 0 1.819-.746 1.819-1.667 0-.92-.814-1.666-1.819-1.666h-1.09z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "PERSON_ADD": {
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28"
                    className={className}>
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M16.333 8.167c0 2.577-2.089 4.666-4.666 4.666C9.089 12.833 7 10.744 7 8.167 7 5.589 9.09 3.5 11.667 3.5s4.666 2.09 4.666 4.667zm-2.333 0c0-1.289-1.045-2.334-2.333-2.334-1.289 0-2.334 1.045-2.334 2.334 0 1.288 1.045 2.333 2.334 2.333C12.955 10.5 14 9.455 14 8.167zM24.5 7h-1.167V5.833c0-.644-.522-1.166-1.166-1.166-.645 0-1.167.522-1.167 1.166V7h-1.167c-.644 0-1.166.522-1.166 1.167 0 .644.522 1.166 1.166 1.166H21V10.5c0 .644.522 1.167 1.167 1.167.644 0 1.166-.523 1.166-1.167V9.333H24.5c.644 0 1.167-.522 1.167-1.166C25.667 7.522 25.144 7 24.5 7zm-21 16.333c0-4.51 3.656-8.166 8.167-8.166 4.51 0 8.166 3.656 8.166 8.166 0 .645-.522 1.167-1.166 1.167-.645 0-1.167-.522-1.167-1.167 0-3.221-2.612-5.833-5.833-5.833-3.222 0-5.834 2.612-5.834 5.833 0 .645-.522 1.167-1.166 1.167-.645 0-1.167-.522-1.167-1.167z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "BELL_LINE": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M23.94 17.745l-2.1-2.112V10.43c.058-3.995-2.84-7.421-6.79-8.027-4.306-.567-8.256 2.464-8.823 6.77-.044.335-.066.673-.067 1.012v5.448l-2.1 2.112c-.741.753-.731 1.965.022 2.706.356.35.833.546 1.331.549h3.92v.397c.114 2.466 2.2 4.375 4.667 4.27 2.466.105 4.553-1.804 4.667-4.27V21h3.92c1.056-.006 1.908-.867 1.902-1.924-.003-.498-.2-.976-.549-1.331zm-7.607 3.652c-.134 1.165-1.162 2.019-2.333 1.936-1.17.083-2.199-.77-2.333-1.936V21h4.666v.397zm-9.905-2.73l1.377-1.377c.441-.438.689-1.035.688-1.657v-5.448c.002-1.592.69-3.106 1.89-4.153 1.184-1.073 2.78-1.572 4.364-1.365 2.79.453 4.82 2.89 4.76 5.716v5.25c-.004.62.24 1.217.676 1.657l1.389 1.377H6.428z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "LOCK_LINE": {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M18.667 9.333h1.167c1.933 0 3.5 1.567 3.5 3.5v9.334c0 1.933-1.567 3.5-3.5 3.5H8.167c-1.933 0-3.5-1.567-3.5-3.5v-9.334c0-1.933 1.567-3.5 3.5-3.5h1.167V7.128c0-2.577 2.089-4.666 4.666-4.666 2.578 0 4.667 2.089 4.667 4.666v2.205zM14 4.667c-1.323.038-2.366 1.138-2.333 2.461v2.205h4.667V7.128c.032-1.323-1.01-2.423-2.334-2.461zm7 17.5c0 .644-.522 1.166-1.166 1.166H8.167c-.644 0-1.167-.522-1.167-1.166v-9.334c0-.644.523-1.166 1.167-1.166h11.667c.644 0 1.166.522 1.166 1.166v9.334zM14 14c-1.933 0-3.5 1.567-3.5 3.5S12.067 21 14 21s3.5-1.567 3.5-3.5S15.933 14 14 14zm0 4.667c-.644 0-1.166-.523-1.166-1.167s.522-1.167 1.166-1.167c.645 0 1.167.523 1.167 1.167s-.522 1.167-1.167 1.167z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "APPOINTMENT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M21 4.667h-1.167V3.5c0-.644-.522-1.167-1.166-1.167-.645 0-1.167.523-1.167 1.167v1.167h-7V3.5c0-.644-.522-1.167-1.167-1.167-.644 0-1.166.523-1.166 1.167v1.167H7c-1.933 0-3.5 1.567-3.5 3.5v14c0 1.933 1.567 3.5 3.5 3.5h14c1.933 0 3.5-1.567 3.5-3.5v-14c0-1.933-1.567-3.5-3.5-3.5zm1.167 3.5V21c0 1.289-1.045 2.333-2.334 2.333H8.167c-1.289 0-2.334-1.044-2.334-2.333V8.167C5.833 7.522 6.356 7 7 7h1.167v1.167c0 .644.522 1.166 1.166 1.166.645 0 1.167-.522 1.167-1.166V7h7v1.167c0 .644.522 1.166 1.167 1.166.644 0 1.166-.522 1.166-1.166V7H21c.644 0 1.167.522 1.167 1.167z"
                        clipRule="evenodd"
                    />
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M17.697 12.282c.396.385.405 1.018.02 1.415l-3.882 4c-.188.194-.447.303-.717.303-.27 0-.53-.11-.718-.303l-2.118-2.182c-.384-.397-.375-1.03.021-1.414.397-.385 1.03-.376 1.415.02l1.4 1.443 3.164-3.26c.385-.397 1.018-.406 1.415-.022z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "UNREAD": {
            return (
                <svg className={className} width="24" height="24" viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        d="M14 3H20C21 3 22.0001 4 22.0001 5V19.0003C22.0001 20 21 21 20 21H14C13 21 6 13 6 13H2V11H6C6 11 13 3 14 3Z"></path>
                </svg>
            )
        }
        case "PERSONS": {
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1" fill="white">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.00001 11C11.2092 11 13 9.20914 13 7C13 4.79086 11.2092 3 9.00001 3C6.79087 3 5.00001 4.79086 5.00001 7C5.00001 9.20914 6.79087 11 9.00001 11ZM17 13C18.6569 13 20 11.6568 20 10C20 8.34315 18.6569 7 17 7C15.3432 7 14 8.34315 14 10C14 11.6569 15.3432 13 17 13ZM22 19C22 19.5523 21.5523 20 21 20H16C16 20.5523 15.5523 21 15 21H3C2.44771 21 2 20.5523 2 20C2.00248 18.1515 2.73603 16.379 4.04057 15.0693C6.76889 12.3303 11.201 12.3216 13.9401 15.05C14.8149 14.373 15.8896 14.0052 16.9958 14.0043C19.7572 14.002 21.9977 16.2386 22 19Z"
                        />
                    </mask>
                    <path
                        d="M9.00001 11L9.00001 13H9.00001V11ZM5.00001 7L7.00001 7V7H5.00001ZM22 19H24V18.9983L22 19ZM16 20V18H14V20H16ZM2 20L0 19.9973V20H2ZM4.04057 15.0693L5.45755 16.4808L5.45755 16.4808L4.04057 15.0693ZM13.9401 15.05L12.5286 16.4669L13.7739 17.7074L15.164 16.6317L13.9401 15.05ZM16.9958 14.0043L16.9941 12.0043H16.9941L16.9958 14.0043ZM11 7C11 8.10457 10.1046 9 9.00001 9V13C12.3137 13 15 10.3137 15 7H11ZM9.00001 5C10.1046 5 11 5.89543 11 7H15C15 3.68629 12.3137 1 9.00001 1V5ZM7.00001 7C7.00001 5.89543 7.89544 5 9.00001 5V1C5.6863 1 3.00001 3.68629 3.00001 7H7.00001ZM9.00001 9C7.89544 9 7.00001 8.10457 7.00001 7L3.00001 7C3.00001 10.3137 5.6863 13 9.00001 13L9.00001 9ZM18 10C18 10.5523 17.5523 11 17 11V15C19.7614 15 22 12.7614 22 10H18ZM17 9C17.5523 9 18 9.44772 18 10H22C22 7.23858 19.7614 5 17 5V9ZM16 10C16 9.44772 16.4477 9 17 9V5C14.2386 5 12 7.23858 12 10H16ZM17 11C16.4477 11 16 10.5523 16 10H12C12 12.7614 14.2386 15 17 15V11ZM21 22C22.6569 22 24 20.6569 24 19H20C20 18.4477 20.4477 18 21 18V22ZM16 22H21V18H16V22ZM15 23C16.6569 23 18 21.6569 18 20H14C14 19.4477 14.4477 19 15 19V23ZM3 23H15V19H3V23ZM0 20C0 21.6569 1.34314 23 3 23V19C3.55229 19 4 19.4477 4 20H0ZM2.6236 13.6579C0.946323 15.3417 0.0031904 17.6207 1.78814e-06 19.9973L4 20.0027C4.00177 18.6823 4.52574 17.4162 5.45755 16.4808L2.6236 13.6579ZM15.3515 13.633C11.8299 10.1251 6.13143 10.1363 2.62359 13.6579L5.45755 16.4808C7.40635 14.5243 10.5722 14.5181 12.5286 16.4669L15.3515 13.633ZM16.9941 12.0043C15.4454 12.0056 13.9409 12.5205 12.7161 13.4682L15.164 16.6317C15.6889 16.2255 16.3338 16.0048 16.9975 16.0043L16.9941 12.0043ZM24 18.9983C23.9967 15.1324 20.8601 12.001 16.9941 12.0043L16.9975 16.0043C18.6544 16.0029 19.9986 17.3449 20 19.0017L24 18.9983Z"
                        fill={fillColor}
                        mask="url(#path-1-inside-1)"
                    />
                </svg>
            )
        }
        case "FILE_ADD": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    fill="none"
                    viewBox="0 0 36 36">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M29.61 10.995l-6.66-7.5c-.284-.314-.687-.494-1.11-.495h-12C7.744 2.975 6.025 4.654 6 6.75v22.5c.025 2.096 1.744 3.775 3.84 3.75h16.32c2.096.025 3.815-1.654 3.84-3.75V12c-.001-.372-.14-.73-.39-1.005zM21 22.5h-1.5V24c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5v-1.5H15c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5h1.5V18c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v1.5H21c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5zM22.065 12c-.643-.063-1.117-.63-1.065-1.275V6l5.61 6h-4.545z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "FILE_REMOVE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    fill="none"
                    viewBox="0 0 40 40">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M32.9 12.217l-7.4-8.334c-.316-.349-.764-.549-1.234-.55H10.933C8.604 3.306 6.693 5.171 6.666 7.5V32.5c.027 2.329 1.937 4.194 4.266 4.167h18.134c2.329.027 4.239-1.838 4.267-4.166V13.333c-.001-.413-.156-.81-.434-1.116zM23.332 25h-6.667c-.92 0-1.667-.746-1.667-1.667 0-.92.746-1.666 1.667-1.666h6.667c.92 0 1.666.746 1.666 1.666 0 .92-.746 1.667-1.666 1.667zm1.183-11.667c-.715-.07-1.241-.7-1.183-1.416v-5.25l6.233 6.666h-5.05z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "FACE_SCAN_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="44"
                    height="44"
                    fill="none"
                    viewBox="0 0 44 44">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M3.667 15.425c0 .693.564 1.255 1.26 1.255.697 0 1.261-.562 1.261-1.255V7.432c0-.693.565-1.255 1.261-1.255h8.027c.697 0 1.261-.562 1.261-1.255 0-.693-.564-1.255-1.26-1.255H7.448c-2.089 0-3.782 1.686-3.782 3.765v7.993zm36.666 13.15c0-.693-.564-1.255-1.26-1.255-.697 0-1.261.562-1.261 1.255v7.993c0 .693-.564 1.255-1.26 1.255h-8.028c-.696 0-1.26.562-1.26 1.255 0 .693.564 1.255 1.26 1.255h8.027c2.089 0 3.782-1.686 3.782-3.765v-7.993zm-1.26-11.895c.696 0 1.26-.562 1.26-1.255V7.432c0-2.08-1.693-3.765-3.782-3.765h-8.027c-.696 0-1.26.562-1.26 1.255 0 .693.564 1.255 1.26 1.255h8.027c.697 0 1.26.562 1.26 1.255v7.993c0 .693.565 1.255 1.262 1.255zM3.667 28.575c0-.693.564-1.255 1.26-1.255.697 0 1.261.562 1.261 1.255v7.993c0 .693.565 1.255 1.261 1.255h8.027c.697 0 1.261.562 1.261 1.255 0 .693-.564 1.255-1.26 1.255H7.448c-2.089 0-3.782-1.686-3.782-3.765v-7.993zm18.553-8.183c2.824 0 5.113-2.279 5.113-5.09 0-2.812-2.289-5.09-5.113-5.09-2.823 0-5.112 2.278-5.112 5.09 0 2.811 2.289 5.09 5.112 5.09zm11.504 11.46c0 .702-.736 1.272-1.643 1.272H12.36c-.908 0-1.644-.57-1.644-1.273 0-4.92 5.15-8.908 11.504-8.908 6.354 0 11.504 3.988 11.504 8.908z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "STAR_FILL": {
            return (
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.459 2.135a.6.6 0 0 1 1.083 0l2.774 5.814a.6.6 0 0 0 .463.337l6.387.841a.6.6 0 0 1 .335 1.03l-4.673 4.436a.6.6 0 0 0-.176.544l1.173 6.335a.6.6 0 0 1-.877.636l-5.662-3.073a.6.6 0 0 0-.572 0l-5.662 3.073a.6.6 0 0 1-.876-.636l1.173-6.335a.6.6 0 0 0-.177-.544l-4.673-4.435a.6.6 0 0 1 .335-1.03l6.387-.842a.6.6 0 0 0 .463-.337l2.775-5.814z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "OPEN_BOOK": {
            return (
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.587 4h.002a.795.795 0 0 1 .794.798V16.77a.8.8 0 0 1-.799.798c-1.858.005-4.971.392-7.119 2.64V7.678c0-.149.038-.289.11-.404 1.763-2.84 5.15-3.27 7.012-3.275zM3.307 16.769V4.799A.795.795 0 0 1 4.102 4h.001c1.863.004 5.25.436 7.013 3.274.072.116.11.256.11.405v12.527c-2.148-2.247-5.261-2.634-7.12-2.639a.8.8 0 0 1-.799-.798z"
                        fill="#1E90FF"
                    />
                    <path
                        d="M1.49 6.76h.578v10.01c0 1.12.913 2.034 2.036 2.037 1.576.003 4.175.312 6.015 2.053-3.183-.779-6.539-.272-8.451.163a.797.797 0 0 1-.977-.777V7.559c0-.44.358-.798.798-.798zM21.623 16.77V6.76h.579A.8.8 0 0 1 23 7.56v12.686a.796.796 0 0 1-.977.778c-1.912-.436-5.268-.942-8.451-.163 1.84-1.742 4.44-2.05 6.015-2.053a2.042 2.042 0 0 0 2.036-2.038z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        }
        case "SIGN_HAND_DRAWN": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    fill="none"
                    viewBox="0 0 36 36">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M3.492 27.631c-.553.711-.655 1.67.003 2.334.3.302.3.794 0 1.096-.3.303-.787.303-1.087 0-1.391-1.404-.98-3.29-.125-4.388.433-.556 1.053-1.02 1.765-1.142.772-.132 1.533.16 2.08.897.462.62.56 1.303.514 1.941-.041.569-.202 1.163-.345 1.689l-.03.106c-.171.637-.313 1.212-.335 1.754.115-.237.237-.495.366-.767l.124-.262c.348-.734.736-1.539 1.111-2.128.183-.288.4-.584.644-.793.224-.19.712-.498 1.267-.217.528.266.757.734.853 1.146.085.364.085.766.085 1.061v.038c0 .348.004.574.043.743.01.045.021.074.03.091.022 0 .055-.003.099-.009.154-.021.36-.074.616-.157.346-.113.704-.255 1.067-.399.187-.073.376-.148.565-.22.26-.098.528-.193.764-.251.117-.03.252-.055.388-.063.12-.006.334-.005.55.104.275.139.455.401.49.709.027.243-.043.453-.097.582-.112.27-.322.575-.585.906-.265.334-.748.389-1.08.12-.16-.129-.256-.31-.282-.502l-.09.036c-.389.153-.827.327-1.217.454-.29.094-.595.179-.881.218-.258.036-.637.056-.98-.117-.528-.266-.757-.734-.853-1.146-.085-.364-.085-.766-.085-1.061v-.038c0-.163 0-.3-.005-.416l-.012.019c-.314.493-.662 1.208-1.018 1.96l-.125.262c-.303.641-.61 1.293-.877 1.746-.137.233-.327.53-.563.715-.116.091-.387.269-.75.204-.389-.069-.586-.358-.668-.523-.762-1.54-.348-3.073-.044-4.197l.003-.01.012-.046c.158-.583.282-1.04.311-1.453.029-.393-.036-.666-.209-.898-.221-.298-.42-.329-.594-.299-.232.04-.541.222-.813.571zM29.99 3.862c.28-.487.903-.653 1.39-.372l3.526 2.035c.486.281.653.904.372 1.39l-1.017 1.763-5.289-3.054 1.018-1.762zm-1.526 2.644l-9.412 16.302 5.288 3.053 9.412-16.302-5.288-3.053zm-10.57 18.009c.063-.374.253-.685.512-.905l5.562 3.211c-.061.335-.235.654-.527.896l-3.325 2.754-2.945-1.7.723-4.256zm-.813 4.791l-.039.226c-.237 1.396 1.39 2.334 2.48 1.432l.176-.147-2.617-1.51z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "TEXT": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    fill="none"
                    viewBox="0 0 36 36">
                    <path
                        fill={fillColor}
                        d="M1.5 6h19.067v4.618h-7.199V31.3h-4.67V10.62H1.5V6zM25.218 8.41h3.89v4.417H33v4.216h-3.891v7.63c0 .803.22 1.446.661 1.928.467.455 1.09.683 1.868.683h.506c.13-.027.246-.054.35-.08.104-.028.208-.068.311-.121v4.015c-.181.08-.389.148-.622.201-.441.134-.947.201-1.518.201-.882 0-1.699-.147-2.451-.442-.726-.321-1.362-.776-1.907-1.365-.519-.59-.934-1.285-1.245-2.088-.285-.803-.428-1.714-.428-2.731v-7.83H21.91v-3.816h1.168c1.426 0 2.14-.736 2.14-2.208V8.41z"
                    />
                </svg>
            )
        }
        case "GRID_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M5 3h4c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2zm10 0h4c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-4c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2zM9 13H5c-1.105 0-2 .895-2 2v4c0 1.105.895 2 2 2h4c1.105 0 2-.895 2-2v-4c0-1.105-.895-2-2-2zm6 0h4c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-4c-1.105 0-2-.895-2-2v-4c0-1.105.895-2 2-2z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "HOME": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    aria-labelledby="icon"
                    role="img">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M11.296 2.294a1 1 0 0 1 1.414.006l7.71 7.88c.373.387.58.903.58 1.44V20a2 2 0 0 1-1.89 2H16v-9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v9H4.89A2 2 0 0 1 3 20v-8.38a2 2 0 0 1 .58-1.43l7.71-7.89zM14 14v7h-4v-7h4z"
                    />
                </svg>
            )
        }
        case "COMMUNICATION": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <g fillRule="evenodd">
                        <path
                            fill={fillColor}
                            d="M11.556 16.124V11.75c0-.965-.798-1.75-1.778-1.75h-8C.798 10 0 10.785 0 11.75v4.374c0 .966.797 1.75 1.778 1.75v1.482c0 .219.253.345.43.213l2.3-1.698h5.27c.98.003 1.778-.781 1.778-1.747zm2.666-1.75h-1.778v1.75c0 1.447-1.197 2.625-2.666 2.625H5.333v1.75c0 .965.798 1.75 1.778 1.75h3.492l2.3 1.698c.178.13.43.005.43-.214V22.25h.89c.98 0 1.777-.785 1.777-1.75v-4.375c0-.965-.797-1.75-1.778-1.75z"
                        />
                        <g filter="url(#prefix__a)">
                            <g>
                                <path fill={fillColor} d="M0 2H4V3H0zM0 0H6V1H0z" transform="translate(2 12)" />
                            </g>
                        </g>
                        <path
                            fill={fillColor}
                            d="M17.755 1h-7.51C9.557 1 9 1.557 9 2.245v7.51C9 10.443 9.557 11 10.245 11h7.51C18.443 11 19 10.443 19 9.755v-7.51C19 1.557 18.443 1 17.755 1zm4.933.982L19.832 3.95v4.098l2.855 1.967c.552.38 1.312-.008 1.312-.672v-6.69c0-.662-.758-1.052-1.313-.672z"
                        />
                    </g>
                </svg>
            )
        }
        case "INSTRUCTIONAL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M5 3h4c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2zm10 0h4c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-4c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2zM9 13H5c-1.105 0-2 .895-2 2v4c0 1.105.895 2 2 2h4c1.105 0 2-.895 2-2v-4c0-1.105-.895-2-2-2zm6 0h4c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-4c-1.105 0-2-.895-2-2v-4c0-1.105.895-2 2-2z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "SETTINGS_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    aria-labelledby="icon"
                    role="img">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M13 2a1.68 1.68 0 0 1 1.63 1.68v1.03a.34.34 0 0 0 .22.29l.079.038A.38.38 0 0 0 15.26 5l.77-.74.008-.008a1.67 1.67 0 0 1 2.362.008l1.34 1.37c.32.314.5.742.5 1.19l-.008.166A1.63 1.63 0 0 1 19.74 8l-.81.74a.34.34 0 0 0 0 .37l.033.071c.061.113.15.189.267.189h1.09c.93.005 1.68.76 1.68 1.69V13a1.68 1.68 0 0 1-1.62 1.67h-1.09a.34.34 0 0 0-.29.22l-.035.07a.34.34 0 0 0 .035.3l.73.73.008.008a1.67 1.67 0 0 1-.008 2.362l-1.34 1.34c-.31.319-.735.5-1.18.5l-.166-.01a1.72 1.72 0 0 1-1.024-.49l-.76-.77a.34.34 0 0 0-.37 0l-.071.033c-.113.061-.189.15-.189.267v1.09A1.69 1.69 0 0 1 12.94 22h-1.89a1.68 1.68 0 0 1-1.68-1.62v-1.09a.34.34 0 0 0-.22-.29l-.079-.038A.38.38 0 0 0 8.74 19l-.77.74a1.67 1.67 0 0 1-2.37 0l-1.34-1.36a1.66 1.66 0 0 1-.5-1.19l.01-.166A1.72 1.72 0 0 1 4.26 16l.81-.74a.34.34 0 0 0 0-.37l-.033-.071c-.061-.113-.15-.189-.267-.189H3.68A1.69 1.69 0 0 1 2 12.94v-1.89c0-.928.752-1.68 1.68-1.68h1.03A.34.34 0 0 0 5 9.15l.038-.079A.38.38 0 0 0 5 8.74l-.779-.779A1.67 1.67 0 0 1 4.26 5.6l1.37-1.34c.31-.319.735-.5 1.18-.5l.166.01A1.72 1.72 0 0 1 8 4.26l.74.81a.34.34 0 0 0 .37 0l.071-.033c.112-.061.189-.15.189-.267V3.68A1.69 1.69 0 0 1 11.06 2zm-1 6.5a3.5 3.5 0 1 0 0 7l.192-.005A3.5 3.5 0 0 0 15.5 12l-.005-.192A3.5 3.5 0 0 0 12 8.5zm1.06 2.44a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12z"
                    />
                </svg>
            )
        }
        case "SCHOOL_FILL": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M0 10.4v10.2c0 .331.269.6.6.6h3v-12H1.2c-.663 0-1.2.537-1.2 1.2zm13.5-1.8h-.9V7.1c0-.166-.134-.3-.3-.3h-.6c-.166 0-.3.134-.3.3v2.4c0 .166.134.3.3.3h1.8c.166 0 .3-.134.3-.3v-.6c0-.166-.134-.3-.3-.3zm5.166-2.398l-6-4c-.404-.27-.928-.27-1.332 0l-6 4c-.333.222-.534.597-.534.998v14h4.8v-5.4c0-.332.268-.6.6-.6h3.6c.332 0 .6.269.6.6v5.4h4.8v-14c0-.401-.2-.776-.534-.998zM12 11.6c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3zm10.8-2.4h-2.4v12h3c.332 0 .6-.268.6-.6V10.4c0-.663-.537-1.2-1.2-1.2z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "INITIALS": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M0 16.918v.731c2.05 1.444 3.99 3.383 5.765 5.948.042.553.127 1.148.255 1.701.255 1.319.979 1.574 2.128 1.234.638-.128.979-.51.979-1.149.085-.935.085-1.913 0-2.807 0-.781-.032-1.584-.064-2.392C9.031 19.366 9 18.543 9 17.729c0-1.573.042-3.104.128-4.72 0-.681 0-1.319.255-2.17.12.076.231.13.329.178.177.087.312.153.394.29.094.105.188.206.281.307.287.311.569.616.826.97 1.106 1.7 2.128 3.487 2.979 5.358.255.638.383 1.233.383 1.871.042.936.127 1.956.255 2.934.128.553.426.851 1.021.766 1.32-.043 1.745-.553 1.83-1.531.089-.56.137-1.142.186-1.744.021-.265.044-.534.07-.808.067-1.094.122-2.2.178-3.317.05-1.011.101-2.032.162-3.062 0-1.36.128-2.68.51-4.04.128-.468.384-.85.64-1.234.254-.467.723-.552 1.106-.212.297.17.553.383.765.638.596.68 1.107 1.318 1.575 2.041 1.32 2.084 2.085 4.38 2.596 6.762l.17.808c-1.617 1.063-2.51 2.722-2.809 4.296-.383 2.126.341 3.955 1.66 4.252.809.17 1.447.043 1.915-.382.128-.128.213-.255.298-.383 0-.05.015-.085.027-.114.008-.02.016-.039.016-.056.52-.96.363-2.298.307-2.771l-.01-.079v-.085c0-.34-.042-.68-.085-1.02-.17-1.361-.553-3.445-.553-3.445 1.277-.68 2.936-1.02 5.064-.723.177.023.355.044.532.065v-.562l-.447-.056c-2.17-.255-3.915.043-5.234.723-.043-.149-.074-.308-.106-.468-.032-.16-.064-.319-.107-.468-.042-.042-.042-.085-.042-.127-.34-1.531-.681-3.02-1.32-4.466-.383-.893-.85-1.786-1.361-2.637-.34-.552-.724-1.063-1.107-1.53-1.149-1.234-2.042-1.447-3.745-.596-.638.255-1.106.85-1.49 1.361-1.233 1.744-1.872 3.657-2.127 5.699-.067.425-.122.873-.178 1.327-.05.409-.102.821-.162 1.225-.198.032-.268-.113-.33-.24-.017-.037-.034-.072-.053-.1l-2.256-4.211c-.34-.51-.723-1.063-1.106-1.531-1.107-1.233-2.511-.893-3.362.127-.766 1.021-1.404 2.084-1.617 3.445-.34 2.68-.468 5.359-.213 8.08C3.944 20.117 2.074 18.31 0 16.919zm23.468 5.276c.255-1.361 1.021-2.765 2.34-3.743 0 0 .383 2.382.554 3.53.127 1.36.127 2.764-.213 3.402-.043.085-.085.128-.128.17-.298.298-.766.34-1.362.213-.978-.255-1.532-1.786-1.191-3.572z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "GRADE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="24"
                    fill="none"
                    viewBox="0 0 18 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M10.5 0v6.375c0 .619.506 1.125 1.125 1.125H18v15.375c0 .623-.502 1.125-1.125 1.125H1.125C.502 24 0 23.498 0 22.875V1.125C0 .502.502 0 1.125 0H10.5zM3.375 3C3.168 3 3 3.168 3 3.375v.75c0 .207.168.375.375.375h3.75c.207 0 .375-.168.375-.375v-.75C7.5 3.168 7.332 3 7.125 3h-3.75zM3 6.375C3 6.168 3.168 6 3.375 6h3.75c.207 0 .375.168.375.375v.75c0 .207-.168.375-.375.375h-3.75C3.168 7.5 3 7.332 3 7.125v-.75zM3.667 11c-.369 0-.667.168-.667.375v.75c0 .207.298.375.667.375h6.666c.369 0 .667-.168.667-.375v-.75c0-.207-.298-.375-.667-.375H3.667zM3 14.375c0-.207.15-.375.333-.375h3.334c.184 0 .333.168.333.375v.75c0 .207-.15.375-.333.375H3.333c-.184 0-.333-.168-.333-.375v-.75zM12.333 11c-.184 0-.333.168-.333.375v.75c0 .207.15.375.333.375h3.334c.184 0 .333-.168.333-.375v-.75c0-.207-.15-.375-.333-.375h-3.334zm-.472 3h1.288L16 22h-1.5l-.696-1.994h-2.619L10.5 22H9l2.861-8zm1.679 4.913l-1.035-3.144-1.077 3.144h2.112zM13.083.328l4.589 4.594c.21.21.328.497.328.792V6h-6V0h.286c.3 0 .586.117.797.328z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "CAMERA": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M23.253 8.315c.054.093.147.16.267.16 3.2 0 5.813 2.61 5.813 5.807v7.911C29.333 25.39 26.72 28 23.52 28H8.48c-3.213 0-5.813-2.61-5.813-5.807v-7.911c0-3.197 2.6-5.807 5.813-5.807.107 0 .213-.053.253-.16l.08-.16.141-.297c.341-.718.719-1.513.953-1.98C10.52 4.679 11.56 4.013 12.853 4h6.28c1.294.013 2.347.68 2.96 1.878.21.42.53 1.095.839 1.747l.188.397.133.293zm-.973 5.115c0 .665.533 1.198 1.2 1.198.667 0 1.213-.533 1.213-1.198 0-.666-.546-1.212-1.213-1.212s-1.2.546-1.2 1.212zm-8.587 2.064c.627-.626 1.44-.959 2.307-.959s1.68.333 2.293.946c.614.612.947 1.425.947 2.29-.013 1.785-1.453 3.237-3.24 3.237-.867 0-1.68-.333-2.293-.946-.614-.613-.947-1.425-.947-2.29v-.014c-.013-.839.32-1.651.933-2.264zm6 5.98c-.946.945-2.253 1.532-3.693 1.532-1.4 0-2.707-.547-3.707-1.532-.986-.999-1.533-2.304-1.533-3.703-.013-1.385.533-2.69 1.52-3.689 1-.999 2.32-1.545 3.72-1.545 1.4 0 2.72.546 3.707 1.532.986.999 1.533 2.317 1.533 3.702-.013 1.452-.6 2.757-1.547 3.703z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "UPLOAD_THIN": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 28 28">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M2.333 11.773c.645 0 1.167.523 1.167 1.167V21c0 1.934 1.567 3.5 3.5 3.5h14c1.933 0 3.5-1.566 3.5-3.5v-8.06c0-.644.522-1.167 1.167-1.167.644 0 1.166.523 1.166 1.167V21c0 3.222-2.611 5.834-5.833 5.834H7c-3.222 0-5.833-2.612-5.833-5.833v-8.06c0-.645.522-1.168 1.166-1.168z"
                        clipRule="evenodd"
                    />
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M7.855 8.231c-.446-.464-.43-1.203.034-1.65L14 .716l6.111 5.867c.465.446.48 1.185.034 1.65-.447.464-1.185.48-1.65.033L15.167 5.07V17.18c0 .644-.523 1.167-1.167 1.167s-1.167-.523-1.167-1.167V5.07L9.505 8.265c-.465.446-1.203.431-1.65-.034z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "PERSON_DONE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M10 11c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm11.66-6.75c-.414-.364-1.045-.324-1.41.09l-1.87 2.15-.63-.71c-.367-.414-1-.452-1.415-.085-.414.367-.452 1-.085 1.415l1.39 1.56c.191.212.464.332.75.33.284-.003.553-.127.74-.34l2.61-3c.367-.412.33-1.042-.08-1.41zM17 20c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1 0-3.866 3.134-7 7-7s7 3.134 7 7z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "MESSAGE_CIRCLE": {
            return (
                <svg className={className} width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M19.07 4.929C15.177 1.01 8.846.99 4.928 4.883c-2.913 2.893-3.76 7.274-2.138 11.046.096.198.127.422.09.64L2 20.799c-.069.329.033.671.27.91.194.192.457.297.73.29h.2l4.28-.86c.217-.027.438.004.64.09 5.073 2.182 10.955-.161 13.138-5.234 1.623-3.772.775-8.153-2.138-11.046l-.05-.02zM8 12.999c-.552 0-1-.448-1-1 0-.553.448-1 1-1s1 .447 1 1c0 .552-.448 1-1 1zm4 0c-.552 0-1-.448-1-1 0-.553.448-1 1-1s1 .447 1 1c0 .552-.448 1-1 1zm4 0c-.552 0-1-.448-1-1 0-.553.448-1 1-1s1 .447 1 1c0 .552-.448 1-1 1z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        }
        case "MESSAGE_CIRCLE_LINE": {
            return (
                <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.07 4.93a10 10 0 0 0-16.28 11c.096.2.127.423.09.64L2 20.8a1 1 0 0 0 .27.91A1 1 0 0 0 3 22h.2l4.28-.86c.217-.026.438.005.64.09 5.073 2.183 10.955-.16 13.138-5.234A10 10 0 0 0 19.12 4.95l-.05-.02zm.83 8.36a8 8 0 0 1-11 6.08 3.26 3.26 0 0 0-1.25-.26 3.424 3.424 0 0 0-.56.05l-2.82.57.57-2.82a3.09 3.09 0 0 0-.21-1.81 8 8 0 0 1 6.08-11 8 8 0 0 1 9.19 9.19zM8.707 11.293a1 1 0 1 1-1.414 1.415 1 1 0 0 1 1.414-1.415zm4 1.415a1 1 0 1 0-1.414-1.415 1 1 0 0 0 1.414 1.415zm4 0a1 1 0 1 0-1.414-1.415 1 1 0 0 0 1.414 1.415z"
                        fill={fillColor}
                    />
                </svg>
            )
        }
        case "PLAY_VIDEO": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="100"
                    height="100"
                    fill="none"
                    viewBox="0 0 100 100">
                    <g filter="url(#filter0_b)">
                        <rect width="100" height="100" fill="#FAFAFA" fillOpacity=".2" rx="28" />
                    </g>
                    <g filter="url(#filter1_b)">
                        <rect width="80" height="80" x="10" y="10" fill="#000000" fillOpacity=".4" rx="22" />
                    </g>
                    <path
                        fill="#FFFFFF"
                        d="M65.875 47.315c2.833 1.638 2.833 5.732 0 7.37l-25.5 14.739C37.542 71.06 34 69.014 34 65.739V36.26c0-3.275 3.542-5.322 6.375-3.685l25.5 14.74z"
                    />
                    <defs>
                        <filter
                            id="filter0_b"
                            width="108"
                            height="108"
                            x="-4"
                            y="-4"
                            colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImage" stdDeviation="2" />
                            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur" />
                            <feBlend in="SourceGraphic" in2="effect1_backgroundBlur" result="shape" />
                        </filter>
                        <filter
                            id="filter1_b"
                            width="88"
                            height="88"
                            x="6"
                            y="6"
                            colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImage" stdDeviation="2" />
                            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur" />
                            <feBlend in="SourceGraphic" in2="effect1_backgroundBlur" result="shape" />
                        </filter>
                    </defs>
                </svg>
            )
        }
        case "NEWS": {
            return (
                <svg className={className} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.083 22H5.125A3.128 3.128 0 0 1 2 18.875V4.292A2.294 2.294 0 0 1 4.292 2h10.416A2.294 2.294 0 0 1 17 4.292V4.5h2.708A2.294 2.294 0 0 1 22 6.792v12.083a3.13 3.13 0 0 1-2.75 3.102.604.604 0 0 1-.167.023zM17 5.75v13.125c0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.84 1.875-1.875V6.792c0-.574-.468-1.042-1.042-1.042H17zM4.292 3.25c-.575 0-1.042.467-1.042 1.042v14.583c0 1.034.84 1.875 1.875 1.875h11.252a3.108 3.108 0 0 1-.627-1.875V4.292c0-.575-.467-1.042-1.042-1.042H4.292z"
                        fill={fillColor}
                    />
                    <path
                        d="M8.875 9.5h-3.75a.625.625 0 0 1-.625-.625v-3.75c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625v3.75c0 .345-.28.625-.625.625zM5.75 8.25h2.5v-2.5h-2.5v2.5zM13.875 6.583h-2.083a.625.625 0 0 1 0-1.25h2.083a.625.625 0 0 1 0 1.25zM13.875 9.083h-2.083a.625.625 0 0 1 0-1.25h2.083a.625.625 0 0 1 0 1.25zM13.875 12.417h-8.75a.625.625 0 0 1 0-1.25h8.75a.625.625 0 0 1 0 1.25zM13.875 15.542h-8.75a.625.625 0 0 1 0-1.25h8.75a.625.625 0 0 1 0 1.25zM13.875 18.667h-8.75a.625.625 0 0 1 0-1.25h8.75a.625.625 0 0 1 0 1.25z"
                        fill={fillColor}
                    />
                </svg>
            )
        }
        case "CLIENTS": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <mask id="4bhm89szja" fill="#fff">
                        <path
                            fillRule="evenodd"
                            d="M9 11c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm8 2c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm5 6c0 .552-.448 1-1 1h-5c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1 .002-1.849.736-3.621 2.04-4.93 2.729-2.74 7.161-2.748 9.9-.02.875-.677 1.95-1.045 3.056-1.046C19.757 14.002 21.998 16.24 22 19z"
                            clipRule="evenodd"
                        />
                    </mask>
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M9 11c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm8 2c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm5 6c0 .552-.448 1-1 1h-5c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1 .002-1.849.736-3.621 2.04-4.93 2.729-2.74 7.161-2.748 9.9-.02.875-.677 1.95-1.045 3.056-1.046C19.757 14.002 21.998 16.24 22 19z"
                        clipRule="evenodd"
                    />
                    <path
                        fill={fillColor}
                        d="M9 11v2-2zM5 7h2-2zm17 12h2v-.002L22 19zm-6 1v-2h-2v2h2zM2 20l-2-.003V20h2zm2.04-4.93l1.418 1.41-1.417-1.41zm9.9-.02l-1.411 1.417 1.245 1.24 1.39-1.075-1.224-1.582zm3.056-1.046l-.002-2 .002 2zM11 7c0 1.105-.895 2-2 2v4c3.314 0 6-2.686 6-6h-4zM9 5c1.105 0 2 .895 2 2h4c0-3.314-2.686-6-6-6v4zM7 7c0-1.105.895-2 2-2V1C5.686 1 3 3.686 3 7h4zm2 2c-1.105 0-2-.895-2-2H3c0 3.314 2.686 6 6 6V9zm9 1c0 .552-.448 1-1 1v4c2.761 0 5-2.239 5-5h-4zm-1-1c.552 0 1 .448 1 1h4c0-2.761-2.239-5-5-5v4zm-1 1c0-.552.448-1 1-1V5c-2.761 0-5 2.239-5 5h4zm1 1c-.552 0-1-.448-1-1h-4c0 2.761 2.239 5 5 5v-4zm4 11c1.657 0 3-1.343 3-3h-4c0-.552.448-1 1-1v4zm-5 0h5v-4h-5v4zm-1 1c1.657 0 3-1.343 3-3h-4c0-.552.448-1 1-1v4zM3 23h12v-4H3v4zm-3-3c0 1.657 1.343 3 3 3v-4c.552 0 1 .448 1 1H0zm2.624-6.342C.946 15.342.004 17.62 0 19.998l4 .005c.002-1.32.526-2.587 1.458-3.522l-2.834-2.823zm12.727-.025c-3.521-3.508-9.22-3.497-12.727.025l2.834 2.823c1.948-1.957 5.114-1.963 7.07-.014l2.823-2.834zm1.643-1.629c-1.549.002-3.053.517-4.278 1.464l2.448 3.164c.525-.407 1.17-.627 1.833-.628l-.003-4zM24 18.998c-.003-3.866-3.14-6.997-7.006-6.994l.003 4c1.657-.001 3.002 1.34 3.003 2.998l4-.004z"
                        mask="url(#4bhm89szja)"
                    />
                </svg>
            )
        }
        case "DOCUMENT": {
            return (
                <svg className={className} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity=".01" d="M0 0h24v24H0V0z" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.302 2a1.62 1.62 0 0 0-.145.672c0 .898.728 1.192 1.626 1.192h4.384c.899 0 1.627-.294 1.627-1.192 0-.24-.052-.467-.145-.672h2.619a3.253 3.253 0 0 1 3.253 3.253v14.494A3.253 3.253 0 0 1 18.268 23H5.682a3.253 3.253 0 0 1-3.252-3.253V5.253A3.253 3.253 0 0 1 5.682 2h2.62zm3.886 13.152a.813.813 0 0 0 0 1.626h5.055a.813.813 0 0 0 0-1.626h-5.055zm-.813-5.657c0-.449.364-.813.813-.813h5.055a.813.813 0 1 1 0 1.626h-5.055a.813.813 0 0 1-.813-.813zM5.683 8.364c0-.45.364-.813.813-.813h2.439c.45 0 .813.364.813.813v2.44a.813.813 0 0 1-.813.812h-2.44a.813.813 0 0 1-.812-.813v-2.44zm3.973 5.9c.334.301.36.815.06 1.149l-1.718 1.909a.813.813 0 0 1-1.209 0l-1.145-1.273a.813.813 0 0 1 1.209-1.088l.54.601 1.114-1.237a.813.813 0 0 1 1.149-.06z"
                        fill={fillColor}
                    />
                </svg>
            )
        }

        case "TYPE_FILL":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path fill="#1E90FF" d="M0 0h32v32H0V0z" opacity=".01" />
                    <rect width="26.667" height="26.667" x="2.666" y="2.667" fill="#1E90FF" rx="6" />
                </svg>
            )
        case "TYPE_LINE":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path opacity=".01" d="M0 0h24v24H0V0z" fill="#1E90FF" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 4H8a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4zM8 2a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6h8a6 6 0 0 0 6-6V8a6 6 0 0 0-6-6H8z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "ADMISSIONS_FILL":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    viewBox="0 0 32 32">
                    <path fill="#1E90FF" d="M0 0h32v32H0V0z" opacity=".01" />
                    <path
                        fill="#1E90FF"
                        fillRule="evenodd"
                        d="M3.777 8.234c0-1.19.79-2.237 1.934-2.564L17.49 2.305c1.703-.487 3.4.792 3.4 2.564V27.13c0 1.772-1.697 3.051-3.4 2.564L5.711 26.33c-1.144-.327-1.934-1.373-1.934-2.564V8.234zm25.444 16.21c0 1.289-1.044 2.334-2.333 2.334h-2.333v-2h2.333c.184 0 .333-.15.333-.334V7.555c0-.184-.149-.333-.333-.333h-2.333v-2h2.333c1.289 0 2.333 1.045 2.333 2.333v16.89zM16 17.222c.675 0 1.222-.547 1.222-1.222 0-.675-.547-1.222-1.222-1.222-.675 0-1.222.547-1.222 1.222 0 .675.547 1.222 1.222 1.222z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "RESCHEDULE":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.628 10h.056l2.606-.238c.286-.029.553-.155.756-.358l5.626-5.645a1.207 1.207 0 0 0-.044-1.7L21.915.34a1.247 1.247 0 0 0-1.662-.044l-5.625 5.646a1.256 1.256 0 0 0-.357.759l-.268 2.615a.629.629 0 0 0 .625.684zm6.419-8.782 1.706 1.713-1.25 1.223-1.675-1.681 1.219-1.255zM9.429 4.625H11v3.938H4.929v12.222c0 .136.108.246.24.246H18.83c.133 0 .241-.11.241-.246v-7.93A4 4 0 0 0 21 11.645v9.386C21 22.118 20.136 23 19.071 23H4.93C3.864 23 3 22.118 3 21.031V6.594c0-1.087.864-1.969 1.929-1.969h1.928V2.492c0-.27.217-.492.482-.492h1.607c.266 0 .483.221.483.492v2.133zm1.767 6.563h.455c.401.613.967 1.11 1.635 1.427v.705c0 .271-.217.492-.482.492h-1.608a.489.489 0 0 1-.482-.492v-1.64c0-.271.217-.492.482-.492zm3.375 2.132v-.343c.141.015.284.023.429.023h2.143v.32c0 .271-.217.492-.482.492h-1.607a.489.489 0 0 1-.483-.492zm-5.625.492H7.34a.489.489 0 0 1-.482-.492v-1.64c0-.271.217-.492.482-.492h1.607c.266 0 .483.221.483.492v1.64c0 .271-.217.492-.483.492zm4.34 3.446v-1.64a.489.489 0 0 0-.482-.493h-1.608a.489.489 0 0 0-.482.492v1.64c0 .271.217.493.482.493h1.608a.489.489 0 0 0 .482-.492zm-3.857 0v-1.64a.489.489 0 0 0-.483-.493H7.34a.489.489 0 0 0-.482.492v1.64c0 .271.217.493.482.493h1.607a.489.489 0 0 0 .483-.492zm7.714 0v-1.64a.489.489 0 0 0-.482-.493h-1.607a.489.489 0 0 0-.483.492v1.64c0 .271.217.493.483.493h1.607a.489.489 0 0 0 .482-.492z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "ICON_EXPEND":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M7 6C5.343 6 4 7.343 4 9v8c0 1.657 1.343 3 3 3h8c1.657 0 3-1.343 3-3v-4h2v4c0 2.761-2.239 5-5 5H7c-2.761 0-5-2.239-5-5V9c0-2.761 2.239-5 5-5h4v2H7z"
                        clipRule="evenodd"
                    />
                    <path
                        fill={fillColor}
                        fillRule="evenodd"
                        d="M13 1h9c.552 0 1 .448 1 1v9c0 .552-.448 1-1 1s-1-.448-1-1V4.414l-8.293 8.293-1.414-1.414L19.586 3H13c-.552 0-1-.448-1-1s.448-1 1-1z"
                        clipRule="evenodd"
                    />
                </svg>
            )
        case "SELECT_ALL":
            return (
                <svg
                    className={className}
                    width={size || 26}
                    height={size || 26}
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect x="5.199" y="5.2" width="20.8" height="20.8" rx="4" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.79 3.703A4 4 0 0 0 16.8 0H4a4 4 0 0 0-4 4v12.8a4 4 0 0 0 3.702 3.99 4.998 4.998 0 0 1-.236-1.523v-10.8a5 5 0 0 1 5-5h10.8c.531 0 1.043.082 1.523.236z"
                        fill={fillColor}
                    />
                    <path
                        d="m11.268 14.348 3.404 3.852 6.129-6.933"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case "DESELECT_ALL":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect x="4.801" y="4.8" width="19.2" height="19.2" rx="4" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.172 3.523A4 4 0 0 0 15.2 0H4a4 4 0 0 0-4 4v11.2a4 4 0 0 0 3.523 3.972A4.989 4.989 0 0 1 3.2 17.4V8.2a5 5 0 0 1 5-5h9.2c.624 0 1.221.114 1.772.323z"
                        fill={fillColor}
                    />
                    <path
                        d="m18.209 10.935-7.273 7.273M18.209 18.208l-7.273-7.273"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            )
        case "ISIR":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m14.3 2.33 5.44 6A1 1 0 0 1 20 9v10.5a2.53 2.53 0 0 1-2.56 2.5H6.56A2.53 2.53 0 0 1 4 19.5v-15A2.53 2.53 0 0 1 6.56 2h7a1 1 0 0 1 .74.33zM13.71 9h3.94l-4.54-5H13v4.15a.79.79 0 0 0 .71.85zM6.56 20H17.442a.53.53 0 0 0 .558-.5V11h-4.29A2.79 2.79 0 0 1 11 8.15V4H6.558A.53.53 0 0 0 6 4.5v15.002a.53.53 0 0 0 .56.498zm2.78-1.174c.232.116.494.174.786.174.3 0 .56-.067.78-.201.22-.135.387-.316.501-.543.118-.227.177-.48.177-.758 0-.292-.06-.53-.177-.716a1.279 1.279 0 0 0-.421-.424 4.6 4.6 0 0 0-.627-.306 2.72 2.72 0 0 1-.57-.285.43.43 0 0 1-.181-.369c0-.144.036-.253.108-.327a.368.368 0 0 1 .285-.118c.136 0 .248.046.335.139a.54.54 0 0 1 .143.368h1.053c-.019-.458-.163-.815-.432-1.07-.27-.26-.625-.39-1.065-.39-.433 0-.784.13-1.054.39-.27.255-.404.61-.404 1.064 0 .306.059.554.176.744.118.19.259.334.422.43.163.098.374.195.632.293.178.065.315.123.41.174.099.05.18.116.245.195a.44.44 0 0 1 .102.299.46.46 0 0 1-.125.34.478.478 0 0 1-.342.119.448.448 0 0 1-.341-.14c-.088-.097-.139-.236-.154-.417H8.566c.007.32.08.594.216.82.14.228.326.4.558.515zm-1.366.125V14.07H7v4.881h.974zm5.183-4.881v4.881h-.974V14.07h.974zm1.913 3.039.831 1.842H17l-.922-1.933a1.22 1.22 0 0 0 .66-.542c.152-.255.228-.545.228-.87 0-.287-.055-.546-.165-.778a1.25 1.25 0 0 0-.501-.557c-.22-.134-.488-.201-.803-.201h-1.635v4.881h.974V17.11h.234zm.37-.842h-.604v-1.21h.604c.178 0 .311.053.398.16.091.107.137.253.137.438 0 .195-.046.346-.137.452-.087.107-.22.16-.398.16z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "FILE_CHECK":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m19.74 8.33-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM17.65 9h-3.94a.79.79 0 0 1-.71-.85V4h.11l4.54 5zm-.21 11H6.56a.53.53 0 0 1-.56-.498V4.5a.53.53 0 0 1 .558-.5H11v4.15A2.79 2.79 0 0 0 13.71 11H18v8.5a.53.53 0 0 1-.558.5h-.002z"
                        fill={fillColor}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m13.802 13.247-2.52 3.123-1.088-1.318a.699.699 0 0 0-.936-.11.6.6 0 0 0-.117.878l1.62 1.943c.128.15.322.238.527.237.207 0 .401-.09.527-.244l3.048-3.747a.602.602 0 0 0-.127-.88.701.701 0 0 0-.94.118h.006z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "LOCK_CHECK":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17 8h-1V6.11a4 4 0 0 0-8 0V8H7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3zm-7-1.89A2.06 2.06 0 0 1 12 4a2.06 2.06 0 0 1 2 2.11V8h-4V6.11zm5.718 7.586a1 1 0 0 0-1.436-1.393l-3.164 3.261-1.4-1.442a1 1 0 1 0-1.436 1.393l2.118 2.181a1 1 0 0 0 1.435 0l3.883-4z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "WORKFLOW":
            return (
                <svg
                    className={className}
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.8 1.5H12.2a.967.967 0 0 0-.968.967v7.09c0 .534.433.966.967.966h11.602a.967.967 0 0 0 .967-.966v-7.09A.967.967 0 0 0 23.8 1.5zm0 11.988H12.2a.967.967 0 0 0-.968.967v7.09c0 .534.433.967.967.967h11.602a.967.967 0 0 0 .967-.967v-7.09a.967.967 0 0 0-.967-.967zM12.2 25.477h11.6c.535 0 .968.432.968.966v7.09a.967.967 0 0 1-.967.967H12.199a.967.967 0 0 1-.967-.967v-7.09c0-.534.433-.966.967-.966zm18.755-18.95h-3.867a.967.967 0 1 0 0 1.934h3.867c.889 0 1.611.723 1.611 1.611v3.868c0 .888-.722 1.61-1.61 1.61h-1.534l.928-.927a.967.967 0 1 0-1.367-1.367l-2.579 2.578a.967.967 0 0 0 0 1.367l2.579 2.578a.963.963 0 0 0 1.367 0 .967.967 0 0 0 0-1.367l-.928-.928h1.533A3.549 3.549 0 0 0 34.5 13.94v-3.867a3.549 3.549 0 0 0-3.545-3.545zM5.65 25.244a.966.966 0 0 1 1.368 0l2.578 2.578a.966.966 0 0 1 0 1.367l-2.578 2.578a.963.963 0 0 1-1.368 0 .966.966 0 0 1 0-1.367l.928-.927H5.045A3.549 3.549 0 0 1 1.5 25.928V22.06a3.549 3.549 0 0 1 3.545-3.545h3.867a.967.967 0 1 1 0 1.933H5.045c-.889 0-1.611.723-1.611 1.611v3.868c0 .888.722 1.611 1.61 1.611h1.534l-.928-.928a.966.966 0 0 1 0-1.367z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "PROFILE_FILL_CIRCLE":
            return (
                <svg
                    className={className}
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="24" r="24" fill="#FF349B" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M24 22.667A5.333 5.333 0 1 0 24 12a5.333 5.333 0 0 0 0 10.667zm0-8A2.667 2.667 0 1 1 24 20a2.667 2.667 0 0 1 0-5.333zm-9.334 20a9.333 9.333 0 1 1 18.667 0 1.333 1.333 0 0 1-2.667 0 6.667 6.667 0 0 0-13.333 0 1.333 1.333 0 0 1-2.667 0z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "DETAIL_FILL_CIRCLE":
            return (
                <svg
                    className={className}
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="24" r="24" fill="#FF349B" />
                    <g clipPath="url(#y20ek0psca)" fill={fillColor}>
                        <path d="M26.589 17.41H15.615v1.779H26.59V17.41zM31.964 30.784a3.887 3.887 0 0 0-.634-4.654 3.853 3.853 0 0 0-2.744-1.136 3.856 3.856 0 0 0-2.745 1.136 3.854 3.854 0 0 0-1.136 2.745c0 1.037.404 2.011 1.136 2.746a3.861 3.861 0 0 0 2.743 1.133c.676 0 1.33-.172 1.912-.5l4.35 4.35 1.467-1.47-4.35-4.35zm-1.744-.276c-.87.869-2.395.869-3.264 0-.9-.902-.9-2.364 0-3.266a2.297 2.297 0 0 1 1.633-.675c.617 0 1.196.24 1.632.675.436.435.676 1.016.676 1.633 0 .618-.241 1.197-.677 1.633z" />
                        <path d="M29.777 33.733h-15.3a.439.439 0 0 1-.439-.437V14.184c0-.243.196-.439.439-.439h15.3c.243 0 .437.196.437.439v9.75c.634.138 1.224.409 1.747.795V14.184A2.186 2.186 0 0 0 29.777 12h-15.3c-1.204 0-2.184.98-2.184 2.184v19.112c0 1.203.98 2.183 2.184 2.183h15.3c.913 0 1.345-.216 1.67-1.014l-.791-.792c-.292.123-.754.06-.879.06z" />
                        <path d="M26.589 22.424H15.615v1.779H26.59v-1.78z" />
                    </g>
                    <defs>
                        <clipPath id="y20ek0psca">
                            <path fill={fillColor} transform="translate(12 12)" d="M0 0h24.604v24.604H0z" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "APPOINTMENT_FILL_CIRCLE":
            return (
                <svg
                    className={className}
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="24" r="24" fill="#FF349B" />
                    <path opacity=".01" d="M8 8h32v32H8V8z" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.333 9.333a1 1 0 0 1 1 1V12h9.333v-1.667a1 1 0 0 1 2 0V12h2.667a4 4 0 0 1 4 4v18.667a4 4 0 0 1-4 4H14.666a4 4 0 0 1-4-4V16a4 4 0 0 1 4-4h2.667v-1.667a1 1 0 0 1 1-1zM28.666 14v1.667a1 1 0 1 0 2 0V14h2.667a2 2 0 0 1 2 2v3.333H12.666V16a2 2 0 0 1 2-2h2.667v1.667a1 1 0 1 0 2 0V14h9.333zm-16 7.333v13.334a2 2 0 0 0 2 2h18.667a2 2 0 0 0 2-2V21.333H12.666zm10 7.667a1 1 0 0 0 1 1h7.333a1 1 0 0 0 0-2h-7.333a1 1 0 0 0-1 1zm-5.667 1a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2h-2z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "DOCUMENT_FILL_CIRCLE":
            return (
                <svg
                    className={className}
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="16" r="16" fill="#FF349B" />
                    <path opacity=".01" d="M6 6h20v20H6V6z" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m17.916 7.942 4.534 5a.833.833 0 0 1 .216.559v8.75a2.108 2.108 0 0 1-2.133 2.083h-9.067a2.108 2.108 0 0 1-2.133-2.084V9.75a2.108 2.108 0 0 1 2.133-2.083H17.3c.235 0 .459.1.616.275zm2.034 4.725-2.284-2.5v1.803a.658.658 0 0 0 .617.697h1.667zm.583 10h-9.067a.442.442 0 0 1-.466-.415V9.75a.442.442 0 0 1 .465-.416H16v2.625a2.325 2.325 0 0 0 2.258 2.375H21v7.916a.442.442 0 0 1-.466.417h-.001zm-7.033-5H16A.833.833 0 1 0 16 16h-2.5a.833.833 0 1 0 0 1.667zm0 1.667a.833.833 0 1 0 0 1.666h5a.833.833 0 0 0 0-1.666h-5z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "MESSAGE_FILL_CIRCLE":
            return (
                <svg
                    className={className}
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="24" r="24" fill="#FF349B" />
                    <path opacity=".01" d="M8 8h32v32H8V8z" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17.161 35.898v-5.14l-1.042-.63a9.566 9.566 0 0 1-4.624-8.197 9.573 9.573 0 0 1 9.572-9.573h5.867a9.573 9.573 0 0 1 9.573 9.573 9.573 9.573 0 0 1-9.573 9.572h-2.16l-7.613 4.395zm3.906-25.7c-6.48 0-11.733 5.253-11.733 11.733 0 4.26 2.27 7.99 5.667 10.045v5.355a1.333 1.333 0 0 0 2 1.155l8.351-4.822h1.582c6.48 0 11.733-5.253 11.733-11.733s-5.253-11.734-11.733-11.734h-5.867zm3.392 7.562a1.08 1.08 0 0 0 0 2.16h5.402a1.08 1.08 0 0 0 0-2.16h-5.402zm-7.563 1.08c0-.596.484-1.08 1.08-1.08h1.081a1.08 1.08 0 1 1 0 2.16h-1.08a1.08 1.08 0 0 1-1.08-1.08zm1.08 5.402a1.08 1.08 0 1 0 0 2.16h11.885a1.08 1.08 0 0 0 0-2.16H17.977z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "CHECK_DOUBLE":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512">
                    <path
                        fill={fillColor}
                        d="M182.6 246.6C170.1 259.1 149.9 259.1 137.4 246.6L57.37 166.6C44.88 154.1 44.88 133.9 57.37 121.4C69.87 108.9 90.13 108.9 102.6 121.4L159.1 178.7L297.4 41.37C309.9 28.88 330.1 28.88 342.6 41.37C355.1 53.87 355.1 74.13 342.6 86.63L182.6 246.6zM182.6 470.6C170.1 483.1 149.9 483.1 137.4 470.6L9.372 342.6C-3.124 330.1-3.124 309.9 9.372 297.4C21.87 284.9 42.13 284.9 54.63 297.4L159.1 402.7L393.4 169.4C405.9 156.9 426.1 156.9 438.6 169.4C451.1 181.9 451.1 202.1 438.6 214.6L182.6 470.6z"
                    />
                </svg>
            )

        case "REFUND":
            return (
                <svg
                    className={className}
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.418 7.333v-1.75c0-.322.285-.583.637-.583.351 0 .636.261.636.583v1.75h2.545c.352 0 .637.261.637.584 0 .322-.285.583-.636.583H12.69v2.917h.955c1.581 0 2.863 1.175 2.863 2.625s-1.282 2.625-2.863 2.625h-.955v1.75c0 .322-.285.583-.636.583-.352 0-.637-.261-.637-.583v-1.75H8.236c-.351 0-.636-.262-.636-.584 0-.322.285-.583.636-.583h3.182v-2.917h-.954c-1.582 0-2.864-1.175-2.864-2.625s1.282-2.625 2.864-2.625h.954zm0 1.167h-.954c-.879 0-1.591.653-1.591 1.458 0 .806.712 1.459 1.59 1.459h.955V8.5zm1.273 4.083V15.5h.955c.878 0 1.59-.653 1.59-1.458 0-.806-.712-1.459-1.59-1.459h-.955z"
                        fill="#1E90FF"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.35 12a9.25 9.25 0 1 1 18.5 0H19a.2.2 0 0 0-.16.32l2.6 3.467a.2.2 0 0 0 .32 0l2.6-3.467a.2.2 0 0 0-.16-.32h-1.85c0-5.937-4.813-10.75-10.75-10.75S.85 6.063.85 12 5.663 22.75 11.6 22.75a.75.75 0 0 0 0-1.5A9.25 9.25 0 0 1 2.35 12z"
                        fill="#1E90FF"
                    />
                </svg>
            )

        case "OP_PLUS":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m12.998 12.997 6.074.007a1.004 1.004 0 0 0 0-2.008l-6.074.007.007-6.074a1.004 1.004 0 0 0-2.008 0l.007 6.074-6.074-.007A1 1 0 0 0 3.926 12a1 1 0 0 0 .996 1.004h.008l6.074-.007-.007 6.074a1 1 0 0 0 1.004 1.004 1 1 0 0 0 1.004-.996v-.008l-.007-6.074z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "OP_MINUS":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z" fill="#1E90FF" />
                </svg>
            )
        case "OP_DEVIDE":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z" fill="#1E90FF" />
                    <rect x="10" y="5" width="4" height="4" rx="2" fill="#1E90FF" />
                    <rect x="10" y="15" width="4" height="4" rx="2" fill="#1E90FF" />
                </svg>
            )
        case "OP_EQUALS":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4 15a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zM4 9a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "OP_MULTIPLY":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m12 13.41 4.29 4.3a1.004 1.004 0 0 0 1.42-1.42L13.41 12l4.3-4.29a1.004 1.004 0 0 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 0 1 1 0 0 0-.006 1.415l.006.006 4.3 4.29-4.3 4.29a1 1 0 0 0-.006 1.414l.006.006a1 1 0 0 0 1.414.006l.006-.006 4.29-4.3z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "PEN_FILL":
            return (
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.729 3.076a.95.95 0 0 1 1.344 0l2.689 2.689a.95.95 0 0 1 0 1.344l-1.344 1.344-4.033-4.033 1.344-1.344zm-2.016 2.016L8.28 17.525l4.033 4.033L24.746 9.125l-4.033-4.033zM6.823 18.785a1.41 1.41 0 0 1 .68-.692l4.242 4.241c-.136.288-.37.534-.692.681l-3.666 1.681-2.246-2.245 1.681-3.666zM4.93 22.912l-.09.194c-.55 1.202.69 2.442 1.891 1.89l.195-.088-1.996-1.996z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "QUESTION_OPEN":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5zm0 1.5c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
                        fill="#1E90FF"
                    />
                    <path
                        d="M12.47 5c1.369 0 2.463.367 3.282 1.101C16.584 6.835 17 7.838 17 9.11c0 1.324-.43 2.32-1.289 2.988-.859.669-2 1.003-3.422 1.003l-.08 1.553h-1.994l-.1-3.087h.663c1.303 0 2.296-.17 2.98-.51.698-.342 1.047-.99 1.047-1.947 0-.695-.208-1.24-.624-1.632-.402-.394-.966-.59-1.691-.59-.725 0-1.295.19-1.712.57-.416.38-.624.91-.624 1.593H8c0-.787.181-1.488.544-2.104a3.69 3.69 0 0 1 1.55-1.436C10.778 5.171 11.57 5 12.47 5zM11.18 19a1.44 1.44 0 0 1-1.047-.413 1.372 1.372 0 0 1-.423-1.022c0-.407.141-.748.423-1.023a1.44 1.44 0 0 1 1.047-.413c.403 0 .745.138 1.027.413.282.275.423.616.423 1.023 0 .406-.141.747-.423 1.022a1.415 1.415 0 0 1-1.027.413z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "GLOBE":
            return (
                <svg
                    className={className}
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path opacity=".01" d="M0 0h28v28H0V0z" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.219 15.167a12.834 12.834 0 0 0 6.34 9.935c-1.646-3.688-2.611-6.853-2.841-9.935H1.219zm8.778 11.03c1.084.355 2.23.57 3.42.623V15.167H6.473c.265 3.23 1.42 6.667 3.524 11.03zm5.17.584a12.77 12.77 0 0 0 2.836-.584c2.104-4.363 3.26-7.8 3.524-11.03h-6.36V26.78zm5.275-1.68a12.834 12.834 0 0 0 6.339-9.934h-3.499c-.23 3.082-1.195 6.247-2.84 9.935zm6.378-11.684a12.83 12.83 0 0 0-6.285-10.464c1.793 3.806 2.743 7.099 2.799 10.464h3.486zm-8.806-11.61a12.772 12.772 0 0 0-2.847-.588v12.198h6.416c-.064-3.534-1.216-7.077-3.57-11.61zm-4.597-.627c-1.193.053-2.344.27-3.43.627-2.354 4.533-3.506 8.076-3.57 11.61h7V1.18zM7.465 2.953C5.672 6.76 4.722 10.052 4.666 13.417H1.18A12.83 12.83 0 0 1 7.465 2.953z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "CHECKIN_FILL":
            return (
                <svg
                    className={className}
                    width="30"
                    height="28"
                    viewBox="0 0 30 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path opacity=".01" d="M1.166 0h28v28h-28V0z" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M24.931 5.266c.78.277 1.319 1.161 1.319 2.168v13.131c0 1.007-.538 1.892-1.319 2.168l-8.03 2.845c-1.162.412-2.318-.67-2.318-2.168V4.59c0-1.498 1.156-2.58 2.318-2.168l8.03 2.845zm-7.917 9.803a1.07 1.07 0 1 1 0-2.139 1.07 1.07 0 0 1 0 2.139z"
                        fill={fillColor}
                    />
                    <path
                        d="M9.006 10.756a.875.875 0 0 1 1.238 0l3.535 3.535-3.535 3.536a.875.875 0 0 1-1.238-1.238l1.423-1.423H4.375a.875.875 0 1 1 0-1.75h6.054l-1.423-1.423a.875.875 0 0 1 0-1.237zM7 21.486c0 1.127.914 2.041 2.042 2.041h2.041v-1.75H9.042a.292.292 0 0 1-.292-.291v-1.653H7v1.653zM7 9.333h1.75V6.708c0-.161.13-.292.292-.292h2.041v-1.75H9.042A2.042 2.042 0 0 0 7 6.708v2.625z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "CHECKOUT_FILL":
            return (
                <svg
                    className={className}
                    width="30"
                    height="28"
                    viewBox="0 0 30 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path opacity=".01" d="M1.166 0h28v28h-28V0z" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.653 5.266c-.78.277-1.319 1.161-1.319 2.168v13.131c0 1.007.538 1.892 1.319 2.168l8.03 2.845c1.161.412 2.318-.67 2.318-2.168V4.59c0-1.498-1.157-2.58-2.318-2.168l-8.03 2.845zm7.917 9.803a1.07 1.07 0 1 0 0-2.139 1.07 1.07 0 0 0 0 2.139z"
                        fill={fillColor}
                    />
                    <path
                        d="M20.674 10.756a.875.875 0 0 1 1.237 0l3.535 3.535-3.535 3.536a.875.875 0 1 1-1.237-1.238l1.422-1.423h-6.054a.875.875 0 1 1 0-1.75h6.054l-1.422-1.423a.875.875 0 0 1 0-1.237zM19.25 21.486a2.042 2.042 0 0 1-2.041 2.041h-2.042v-1.75h2.042c.161 0 .292-.13.292-.291v-2.82h1.75v2.82zM19.25 10.5H17.5V6.708a.292.292 0 0 0-.291-.292h-2.042v-1.75h2.042c1.128 0 2.042.914 2.042 2.042V10.5z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "GPA":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 9a8 8 0 0 1 8-8h6a8 8 0 0 1 8 8v6a8 8 0 0 1-8 8H9a8 8 0 0 1-8-8V9z" fill="none" />
                    <path
                        d="M5.702 16c-.506 0-.985-.104-1.44-.311a3.865 3.865 0 0 1-1.186-.856c-.336-.37-.6-.8-.79-1.289A4.34 4.34 0 0 1 2 11.956a4.046 4.046 0 0 1 1.087-2.79 3.79 3.79 0 0 1 1.209-.855A3.627 3.627 0 0 1 5.8 8c.732 0 1.358.16 1.878.478.527.31.923.726 1.186 1.244l-1.131.845a2.103 2.103 0 0 0-.835-.9 2.229 2.229 0 0 0-1.153-.311c-.33 0-.63.07-.901.21-.271.141-.505.334-.703.578a2.762 2.762 0 0 0-.461.845A3.28 3.28 0 0 0 3.527 12c0 .378.055.726.165 1.044.117.319.278.597.483.834.212.237.458.426.736.566a2.228 2.228 0 0 0 2.054-.111c.366-.207.707-.51 1.021-.91v1.51C7.335 15.644 6.573 16 5.702 16zm2.175-2.989H6.306V11.89h2.823v4.055H7.877v-2.933zM9.81 15.944V8.056h3.307c.358 0 .688.074.988.222.3.148.56.348.78.6.227.252.403.533.527.844.125.311.187.63.187.956 0 .444-.102.866-.308 1.266-.205.4-.486.726-.845.978-.36.252-.784.378-1.274.378h-1.846v2.644H9.81zm1.516-3.988h1.758a.835.835 0 0 0 .494-.156c.147-.104.264-.252.352-.444.087-.2.131-.426.131-.678 0-.274-.051-.508-.153-.7a1.008 1.008 0 0 0-.385-.434.934.934 0 0 0-.505-.144h-1.692v2.556zM17.595 8.056h1.538L22 15.944h-1.56l-.725-1.966h-2.724l-.714 1.966h-1.56l2.878-7.888zm1.846 4.844-1.077-3.256-1.12 3.256h2.197z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "STUDENTS_IN_CLASS":
            return (
                <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" fill="#E9F4FF" />
                    <mask id="yc5bcbbova" fill="#fff">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.5 18.833a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333zm9.333 2.334a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm5.833 7c0 .644-.522 1.166-1.166 1.166h-5.834c0 .645-.522 1.167-1.166 1.167h-14a1.167 1.167 0 0 1-1.167-1.167 8.166 8.166 0 0 1 13.93-5.775 5.833 5.833 0 0 1 9.403 4.609z"
                        />
                    </mask>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.5 18.833a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333zm9.333 2.334a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm5.833 7c0 .644-.522 1.166-1.166 1.166h-5.834c0 .645-.522 1.167-1.166 1.167h-14a1.167 1.167 0 0 1-1.167-1.167 8.166 8.166 0 0 1 13.93-5.775 5.833 5.833 0 0 1 9.403 4.609z"
                        fill="#1E90FF"
                    />
                    <path
                        d="M16.5 18.833v2-2zm-4.667-4.666h2-2zm14 7v-2 2zm5.833 7h2v-.002l-2 .002zm-7 1.166v-2h-2v2h2zm-16.333 0-2-.002v.002h2zm2.38-5.752 1.418 1.411-1.417-1.411zm11.55-.023-1.411 1.417 1.245 1.24 1.39-1.075-1.224-1.582zm3.565-1.22-.002-2 .002 2zm-6.662-8.171a2.667 2.667 0 0 1-2.666 2.666v4a6.667 6.667 0 0 0 6.666-6.666h-4zM16.5 11.5a2.667 2.667 0 0 1 2.666 2.667h4A6.667 6.667 0 0 0 16.5 7.5v4zm-2.667 2.667A2.667 2.667 0 0 1 16.5 11.5v-4a6.667 6.667 0 0 0-6.667 6.667h4zm2.667 2.666a2.667 2.667 0 0 1-2.667-2.666h-4a6.667 6.667 0 0 0 6.667 6.666v-4zm10.833.834a1.5 1.5 0 0 1-1.5 1.5v4a5.5 5.5 0 0 0 5.5-5.5h-4zm-1.5-1.5a1.5 1.5 0 0 1 1.5 1.5h4a5.5 5.5 0 0 0-5.5-5.5v4zm-1.5 1.5a1.5 1.5 0 0 1 1.5-1.5v-4a5.5 5.5 0 0 0-5.5 5.5h4zm1.5 1.5a1.5 1.5 0 0 1-1.5-1.5h-4a5.5 5.5 0 0 0 5.5 5.5v-4zM30.5 31.333a3.167 3.167 0 0 0 3.166-3.166h-4c0-.46.373-.834.834-.834v4zm-5.834 0H30.5v-4h-5.834v4zM23.5 32.5a3.167 3.167 0 0 0 3.166-3.167h-4c0-.46.373-.833.834-.833v4zm-14 0h14v-4h-14v4zm-3.167-3.167A3.167 3.167 0 0 0 9.5 32.5v-4c.46 0 .833.373.833.833h-4zm2.964-7.164a10.167 10.167 0 0 0-2.964 7.162l4 .005a6.167 6.167 0 0 1 1.798-4.344L9.297 22.17zm14.377-.028c-3.978-3.962-10.415-3.95-14.377.028l2.834 2.823a6.167 6.167 0 0 1 8.72-.017l2.823-2.834zm2.152-1.803a7.833 7.833 0 0 0-4.787 1.639l2.448 3.163c.67-.519 1.495-.8 2.343-.802l-.004-4zm7.84 7.827a7.833 7.833 0 0 0-7.84-7.827l.004 4a3.833 3.833 0 0 1 3.836 3.83l4-.003z"
                        fill="#1E90FF"
                        mask="url(#yc5bcbbova)"
                    />
                </svg>
            )
        case "PARTICIPATION":
            return (
                <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="16" r="16" fill="#E9F4FF" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.286 20.177c-.338-.34-.162-.244-.979-.462-.37-.1-.697-.29-.991-.52l-1.77 4.337a.624.624 0 0 0 .602.859l2.055-.078 1.413 1.492a.624.624 0 0 0 1.03-.193l2.03-4.976a2.83 2.83 0 0 1-1.377.374c-.76 0-1.475-.296-2.013-.833zm11.138 3.355-1.769-4.337c-.295.23-.62.42-.991.52-.822.22-.642.124-.98.462a2.829 2.829 0 0 1-2.012.833c-.485 0-.954-.139-1.377-.374l2.03 4.976a.624.624 0 0 0 1.03.193l1.413-1.492 2.055.078a.624.624 0 0 0 .601-.859zm-4.67-4.238c.595-.606.663-.554 1.512-.785a1.584 1.584 0 0 0 1.11-1.13c.291-1.107.216-.973 1.011-1.783.397-.404.552-.992.407-1.543-.292-1.107-.292-.952 0-2.06a1.617 1.617 0 0 0-.407-1.543c-.795-.81-.72-.677-1.011-1.784a1.584 1.584 0 0 0-1.11-1.13c-1.087-.296-.956-.219-1.753-1.03a1.551 1.551 0 0 0-1.516-.413c-1.086.296-.935.297-2.023 0a1.55 1.55 0 0 0-1.516.414c-.796.81-.665.733-1.752 1.03a1.584 1.584 0 0 0-1.11 1.13c-.292 1.106-.216.973-1.012 1.783a1.616 1.616 0 0 0-.406 1.543c.29 1.106.291.951 0 2.06-.145.55.01 1.139.406 1.543.796.81.72.676 1.012 1.783.145.552.568.982 1.11 1.13.872.238.937.2 1.511.785a1.55 1.55 0 0 0 1.94.227 1.547 1.547 0 0 1 1.658 0c.62.392 1.423.299 1.938-.227zM12.306 12.9c0-2.067 1.647-3.743 3.678-3.743 2.032 0 3.678 1.676 3.678 3.743 0 2.068-1.646 3.743-3.678 3.743-2.03 0-3.678-1.675-3.678-3.743z"
                        fill="#1E90FF"
                    />
                </svg>
            )
        case "SAP_PASS":
            return (
                <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" fill="#D1EEDD" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20 10c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm4.79 6.707-4.65 6.222a1.011 1.011 0 0 1-1.608.01l-2.484-3.225a1.051 1.051 0 0 1 .178-1.457 1.006 1.006 0 0 1 1.43.182l1.66 2.157 3.846-5.185a1.011 1.011 0 0 1 1.435-.197c.45.35.536 1.004.193 1.462v.031z"
                        fill="#18A957"
                    />
                </svg>
            )
        case "SAP_FAIL":
            return (
                <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" fill="#FFE6EB" />
                    <circle cx="20" cy="20" r="10" fill="#DF1642" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.5 17.605a.782.782 0 0 0-1.105-1.105L20 18.895 17.605 16.5a.782.782 0 0 0-1.105 1.105L18.895 20 16.5 22.395a.782.782 0 0 0 1.105 1.105L20 21.105l2.395 2.395a.782.782 0 0 0 1.105-1.105L21.105 20l2.395-2.395z"
                        fill="#fff"
                    />
                </svg>
            )

        case "LINK":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.53 9.286c-1.787 0-3.236 1.439-3.236 3.214s1.449 3.214 3.235 3.214h4.745V17H5.53C3.028 17 1 14.985 1 12.5S3.028 8 5.53 8h4.744v1.286H5.53zM18.47 9.286c1.787 0 3.236 1.439 3.236 3.214s-1.449 3.214-3.235 3.214h-4.745V17h4.745C20.972 17 23 14.985 23 12.5S20.972 8 18.47 8h-4.744v1.286h4.745z"
                        fill={fillColor}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.314 13.135H7.686V11.85h8.628v1.285z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "EXPAND_NEW_WINDOW":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.036 3.34a.84.84 0 0 0-.841-.84H8.99a.84.84 0 0 0 0 1.682h2.161l-7.902 7.91a.84.84 0 0 0-.005 1.19l.005.005c.327.33.86.332 1.189.005l.005-.005 7.91-7.911v2.17a.84.84 0 0 0 1.683 0V3.34z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "VIEW_DETAILS":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.067 4.697H4.1v1.194h5.966V4.697zM12.434 11.818a2.03 2.03 0 0 0-.33-2.429 2.012 2.012 0 0 0-1.433-.593c-.542 0-1.051.21-1.433.593-.383.382-.593.89-.593 1.433a2.018 2.018 0 0 0 2.024 2.025c.353 0 .695-.09.999-.261l2.27 2.27.766-.767-2.27-2.27zm-.91-.144c-.454.454-1.25.454-1.705 0a1.207 1.207 0 0 1 .853-2.057c.322 0 .625.126.852.352.228.227.353.53.353.853 0 .322-.126.625-.354.852z"
                        fill={fillColor}
                    />
                    <path
                        d="M11.365 13.837H2.92a.25.25 0 0 1-.242-.255V2.418a.25.25 0 0 1 .242-.256h8.446c.134 0 .242.115.242.256v5.695c.35.081.676.24.964.465v-6.16c0-.703-.54-1.275-1.206-1.275H2.92c-.664 0-1.205.572-1.205 1.275v11.164c0 .702.54 1.275 1.205 1.275h8.446c.505 0 .743-.126.923-.592l-.438-.463c-.16.072-.415.035-.485.035z"
                        fill={fillColor}
                    />
                    <path d="M10.067 7.084H4.1v1.193h5.966V7.084z" fill={fillColor} />
                </svg>
            )

        case "VIEW_LIST":
            return (
                <svg className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.667 2.857c0-.657.535-1.19 1.195-1.19h14.277c.66 0 1.195.533 1.195 1.19 0 .658-.535 1.19-1.195 1.19H2.862c-.66 0-1.195-.532-1.195-1.19zM1.667 7.62c0-.658.535-1.191 1.195-1.191h14.277c.66 0 1.195.533 1.195 1.19 0 .658-.535 1.19-1.195 1.19H2.862c-.66 0-1.195-.532-1.195-1.19zM1.667 12.381c0-.657.535-1.19 1.195-1.19h14.277c.66 0 1.195.533 1.195 1.19 0 .658-.535 1.19-1.195 1.19H2.862c-.66 0-1.195-.532-1.195-1.19zM1.667 17.143c0-.657.535-1.19 1.195-1.19h14.277c.66 0 1.195.533 1.195 1.19 0 .658-.535 1.19-1.195 1.19H2.862c-.66 0-1.195-.532-1.195-1.19z"
                        fill="#1E90FF"
                    />
                </svg>
            )

        case "VIEW_LIST_COLUMNS":
            return (
                <svg className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.167 2.5H7.5c.92 0 1.667.746 1.667 1.667v11.666c0 .92-.747 1.667-1.667 1.667H4.167c-.92 0-1.667-.746-1.667-1.667V4.167c0-.92.746-1.667 1.667-1.667zm8.333 0h3.333c.92 0 1.667.746 1.667 1.667v11.666c0 .92-.746 1.667-1.667 1.667H12.5c-.92 0-1.667-.746-1.667-1.667V4.167c0-.92.746-1.667 1.667-1.667z"
                        fill="#1E90FF"
                    />
                </svg>
            )

        case "CONFIRM_INFO":
            return (
                <svg className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="104" height="104" rx="52" fill="#E9F4FF" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M53 35.333c-9.205 0-16.667 7.462-16.667 16.667 0 9.204 7.462 16.666 16.667 16.666 9.204 0 16.666-7.462 16.666-16.666 0-9.205-7.462-16.667-16.666-16.667zm0 25a1.667 1.667 0 1 1 1.666-1.667c0 .92-.746 1.667-1.666 1.667zm1.666-6.667a1.667 1.667 0 1 1-3.333 0v-8.333a1.667 1.667 0 1 1 3.333 0v8.333z"
                        fill="#1E90FF"
                    />
                </svg>
            )

        case "REFRESH":
            return (
                <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke={fillColor}>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                </svg>
            )

        case "SEND_VIA_EMAIL":
            return (
                <svg
                    className={className}
                    width="37"
                    height="36"
                    viewBox="0 0 37 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M29.248 6h-21a4.5 4.5 0 0 0-4.5 4.5v15a4.5 4.5 0 0 0 4.5 4.5h21a4.5 4.5 0 0 0 4.5-4.5v-15a4.5 4.5 0 0 0-4.5-4.5zm-1.005 3-9.495 7.125L9.253 9h18.99zm1.005 18h-21a1.5 1.5 0 0 1-1.5-1.5V10.875l11.1 8.325a1.5 1.5 0 0 0 1.8 0l11.1-8.325V25.5a1.5 1.5 0 0 1-1.5 1.5z"
                        fill={color}
                    />
                </svg>
            )

        case "WATCH_VIDEO":
            return (
                <svg
                    className={className}
                    width="37"
                    height="36"
                    viewBox="0 0 37 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#yym8fc64ga)">
                        <path
                            d="M4.348 11.52a7.92 7.92 0 0 1 7.92-7.92h12.96a7.92 7.92 0 0 1 7.92 7.92v12.96a7.92 7.92 0 0 1-7.92 7.92h-12.96a7.92 7.92 0 0 1-7.92-7.92V11.52z"
                            fill="#fff"
                        />
                    </g>
                    <path
                        d="M25.892 16.792c1.275.737 1.275 2.58 0 3.316l-11.475 6.633c-1.275.737-2.87-.184-2.87-1.658V11.818c0-1.474 1.595-2.395 2.87-1.658l11.475 6.632z"
                        fill="#1E90FF"
                    />
                    <defs>
                        <filter
                            id="yym8fc64ga"
                            x=".348"
                            y="-.4"
                            width="36.8"
                            height="36.8"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
                            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_13803_141671" />
                            <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_13803_141671" result="shape" />
                        </filter>
                    </defs>
                </svg>
            )
        case "STICKY_NOTE":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.7827 1.33317L3.21725 1.33317C2.58927 1.33317 2.11829 1.4959 1.80431 1.82135C1.4903 2.14681 1.33329 2.63291 1.33329 3.27966L1.33329 8.92645C1.33329 9.19594 1.34748 9.42189 1.37586 9.60431C1.40419 9.78674 1.45989 9.95361 1.54295 10.1049C1.626 10.2563 1.74857 10.4169 1.91066 10.5869L5.25915 14.0757C5.41311 14.2374 5.56302 14.3607 5.70887 14.4457C5.85472 14.5307 6.01374 14.5888 6.18593 14.6199C6.35811 14.651 6.55765 14.6665 6.78453 14.6665L12.7827 14.6665C13.4107 14.6665 13.8817 14.5027 14.1956 14.1752C14.5096 13.8477 14.6666 13.3605 14.6666 12.7138L14.6666 3.27966C14.6666 2.62875 14.5096 2.14161 14.1956 1.81823C13.8817 1.49486 13.4107 1.33317 12.7827 1.33317ZM12.7402 2.33444C13.0521 2.33444 13.2881 2.41735 13.4482 2.58318C13.6082 2.749 13.6882 2.98738 13.6882 3.29832L13.6882 12.6951C13.6882 13.0019 13.6082 13.2403 13.4482 13.4103C13.2881 13.5803 13.0501 13.6653 12.7341 13.6653L6.91823 13.6653L6.91823 10.0521C6.91823 9.66236 6.82302 9.37007 6.6326 9.17521C6.44218 8.98035 6.15656 8.88292 5.77572 8.88292L2.31174 8.88292L2.31174 3.29832C2.31174 2.98738 2.39175 2.749 2.55176 2.58318C2.71182 2.41735 2.94985 2.33444 3.26585 2.33444L12.7402 2.33444ZM5.66633 9.82198C5.78787 9.82198 5.87397 9.84892 5.92461 9.90282C5.97525 9.95672 6.00057 10.0459 6.00057 10.1702L6.00057 13.4725L2.50011 9.82198L5.66633 9.82198Z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "ID_BADGE":
            return (
                <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M24 2.667H8c-1.473 0-2.667 1.12-2.667 2.5v21.666c0 1.38 1.194 2.5 2.667 2.5h16c1.472 0 2.666-1.12 2.666-2.5V5.167c0-1.38-1.194-2.5-2.666-2.5zM13.6 4.333h4.8c.44 0 .8.375.8.834 0 .458-.36.833-.8.833h-4.8c-.44 0-.8-.375-.8-.833 0-.459.36-.834.8-.834zM16 11c1.765 0 3.2 1.495 3.2 3.333 0 1.839-1.435 3.334-3.2 3.334-1.765 0-3.2-1.495-3.2-3.334C12.8 12.495 14.235 11 16 11zm5.6 12.333c0 .552-.5 1-1.12 1h-8.96c-.62 0-1.12-.448-1.12-1v-1c0-1.656 1.505-3 3.36-3h.25a5 5 0 0 0 1.99.417c.705 0 1.38-.151 1.99-.417h.25c1.855 0 3.36 1.344 3.36 3v1z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "QR_LINE":
            return (
                <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M5.183 3.25h1.3c.488 0 .807 0 1.051.02.235.02.333.054.389.083a.917.917 0 0 1 .39.391c.03.056.063.153.083.388.02.245.02.564.02 1.051v1.3c0 .488 0 .807-.02 1.051-.02.235-.054.333-.083.389a.917.917 0 0 1-.39.39c-.056.03-.154.063-.389.083-.244.02-.563.02-1.05.02h-1.3c-.488 0-.807 0-1.052-.02-.235-.02-.332-.054-.388-.083a.917.917 0 0 1-.39-.39c-.03-.056-.064-.154-.083-.389-.02-.244-.021-.563-.021-1.05v-1.3c0-.488 0-.807.02-1.052.02-.235.054-.332.083-.388a.917.917 0 0 1 .391-.39c.056-.03.153-.064.388-.083.245-.02.564-.021 1.051-.021zm0 8.333h1.3c.488 0 .807 0 1.051.021.235.02.333.054.389.083a.917.917 0 0 1 .39.39c.03.056.063.154.083.389.02.244.02.564.02 1.05v1.3c0 .488 0 .807-.02 1.051-.02.236-.054.333-.083.389a.917.917 0 0 1-.39.39c-.056.03-.154.064-.389.083-.244.02-.563.021-1.05.021h-1.3c-.488 0-.807 0-1.052-.02-.235-.02-.332-.054-.388-.083a.917.917 0 0 1-.39-.391c-.03-.056-.064-.153-.083-.389-.02-.244-.021-.563-.021-1.05v-1.3c0-.487 0-.807.02-1.051.02-.235.054-.333.083-.389a.917.917 0 0 1 .391-.39c.056-.03.153-.063.388-.083.245-.02.564-.02 1.051-.02zm8.334-8.333h1.3c.487 0 .806 0 1.05.02.236.02.333.054.389.083a.917.917 0 0 1 .39.391c.03.056.064.153.083.388.02.245.021.564.021 1.051v1.3c0 .488 0 .807-.02 1.051-.02.235-.054.333-.083.389a.917.917 0 0 1-.391.39c-.056.03-.153.063-.389.083-.244.02-.563.02-1.05.02h-1.3c-.487 0-.807 0-1.051-.02-.235-.02-.333-.054-.389-.083a.917.917 0 0 1-.39-.39c-.03-.056-.063-.154-.083-.389-.02-.244-.02-.563-.02-1.05v-1.3c0-.488 0-.807.02-1.052.02-.235.054-.332.083-.388a.917.917 0 0 1 .39-.39c.056-.03.154-.064.389-.083.244-.02.564-.021 1.05-.021zm1.9 13.5c-.424 0-.525-.004-.596-.018a.917.917 0 0 1-.72-.72c-.014-.07-.018-.172-.018-.595 0-.424.004-.525.018-.596a.917.917 0 0 1 .72-.72c.07-.014.172-.018.596-.018.423 0 .525.004.595.018a.917.917 0 0 1 .72.72c.014.07.018.172.018.596 0 .423-.004.525-.018.595a.917.917 0 0 1-.72.72c-.07.014-.172.018-.595.018zm-3.334-4.167c-.204 0-.32 0-.405-.006a.698.698 0 0 1-.054-.005.084.084 0 0 1-.03-.03.734.734 0 0 1-.005-.054 6.812 6.812 0 0 1-.006-.405c0-.204 0-.32.006-.405a.736.736 0 0 1 .006-.054.084.084 0 0 1 .03-.03.736.736 0 0 1 .053-.005c.085-.005.2-.006.405-.006.205 0 .32 0 .405.006a.734.734 0 0 1 .054.006.084.084 0 0 1 .03.03l.005.053c.006.085.006.2.006.405 0 .205 0 .32-.006.405a.697.697 0 0 1-.005.054.084.084 0 0 1-.03.03.697.697 0 0 1-.054.005c-.085.006-.2.006-.405.006z"
                        stroke="#FAF8F8"
                        strokeWidth="1.5"
                    />
                </svg>
            )
        case "EYE_VIEW_PERSON":
            return (
                <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <g clipPath="url(#sp22jy2v3a)" fill={fillColor}>
                        <path opacity=".01" d="M0 0h32v35.692H0V0z" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.527 8c2.823 1.703 5.148 4.397 6.639 7.702.11.247.167.52.167.798 0 .277-.057.55-.167.798-1.226 2.716-3.016 5.021-5.184 6.702h14.24c.982 0 1.778-.768 1.778-1.714V9.714C32 8.768 31.204 8 30.222 8H14.527zm8.584 5.926a2.373 2.373 0 0 1 2.37-2.37 2.372 2.372 0 0 1 2.37 2.37 2.373 2.373 0 0 1-2.37 2.37 2.373 2.373 0 0 1-2.37-2.37zm-.948 7.111c-.46 0-.83-.319-.83-.711v-.711c0-1.178 1.115-2.133 2.49-2.133h.184a3.822 3.822 0 0 0 2.948 0h.186c1.374 0 2.489.955 2.489 2.133v.71c0 .393-.37.712-.83.712h-6.637z"
                        />
                        <path d="M.116 16.006C1.924 12.424 5.502 10 9.6 10s7.677 2.425 9.484 6.006a1.11 1.11 0 0 1 0 .988C17.276 20.576 13.698 23 9.6 23S1.923 20.575.116 16.994a1.109 1.109 0 0 1 0-.988zM9.6 21.375c.95 0 1.877-.286 2.667-.822a4.86 4.86 0 0 0 1.768-2.187c.363-.891.458-1.871.273-2.817a4.899 4.899 0 0 0-1.314-2.496 4.777 4.777 0 0 0-2.457-1.334 4.731 4.731 0 0 0-2.774.277 4.817 4.817 0 0 0-2.154 1.796 4.94 4.94 0 0 0-.444 4.574c.24.592.594 1.13 1.04 1.582.446.453.975.812 1.558 1.056.582.245 1.207.371 1.837.371zm0-8.125c.286.004.57.047.844.128a1.638 1.638 0 0 0 .156 2.106 1.578 1.578 0 0 0 2.073.16 3.29 3.29 0 0 1-.09 1.983 3.235 3.235 0 0 1-1.212 1.558 3.157 3.157 0 0 1-3.721-.12 3.244 3.244 0 0 1-1.113-1.632 3.29 3.29 0 0 1 .033-1.986c.216-.642.624-1.2 1.167-1.593A3.16 3.16 0 0 1 9.6 13.25z" />
                    </g>
                    <defs>
                        <clipPath id="sp22jy2v3a">
                            <path fill="#fff" d="M0 0h32v32H0z" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "COMPLETED":
            return (
                <svg
                    className={className}
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_14354_166598)">
                        <circle cx="24" cy="22" r="12" fill="#1E90FF" />
                    </g>
                    <circle opacity="0.4" cx="24" cy="22" r="8" stroke="white" strokeWidth="2" />
                    <circle cx="24" cy="22" r="4.5" fill="white" />
                    <defs>
                        <filter
                            id="filter0_d_14354_166598"
                            x="0"
                            y="0"
                            width="48"
                            height="48"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="2" />
                            <feGaussianBlur stdDeviation="6" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.188235 0 0 0 0 0.192157 0 0 0 0 0.2 0 0 0 0.1 0"
                            />
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14354_166598" />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_14354_166598"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            )
        case "ARROW_LEFT_LINE":
            return (
                <svg
                    className={className}
                    width={size || 24}
                    height={size || 24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.99997 12.4023C2.99997 12.6497 3.09763 12.8678 3.29296 13.0566L9.76757 19.5117C9.87177 19.6159 9.97757 19.6908 10.085 19.7363C10.1924 19.7819 10.3047 19.8047 10.4219 19.8047C10.6627 19.8047 10.8646 19.7249 11.0274 19.5654C11.1901 19.4059 11.2715 19.2057 11.2715 18.9648C11.2715 18.8477 11.252 18.7354 11.2129 18.6279C11.1738 18.5205 11.1152 18.4277 11.0371 18.3496L8.84957 16.123L4.97267 12.5879L4.77736 13.0762L7.92186 13.2715L20.2754 13.2715C20.5293 13.2715 20.736 13.1901 20.8955 13.0273C21.055 12.8646 21.1348 12.6563 21.1348 12.4023C21.1348 12.1484 21.055 11.9401 20.8955 11.7773C20.736 11.6146 20.5293 11.5332 20.2754 11.5332L7.92186 11.5332L4.77736 11.7285L4.97267 12.207L8.84956 8.68169L11.0371 6.45509C11.1152 6.37696 11.1738 6.28419 11.2129 6.17679C11.252 6.06932 11.2715 5.95702 11.2715 5.83989C11.2715 5.59896 11.1901 5.39875 11.0274 5.23929C10.8646 5.07975 10.6627 4.99999 10.4219 4.99999C10.1875 4.99999 9.97586 5.09115 9.78706 5.27349L3.29296 11.748C3.09763 11.9368 2.99996 12.1549 2.99997 12.4023Z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "ACTIVE_LESSON":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.938 10.658c1.416.819 1.416 2.866 0 3.684l-12.75 7.37C5.77 22.53 4 21.507 4 19.869V5.131c0-1.638 1.77-2.662 3.188-1.843l12.75 7.37z"
                        fill="#62B1FF"
                    />
                </svg>
            )

        case "RECORD_START":
            return (
                <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M18.333 10c0-1.138-.217-2.21-.653-3.215a8.517 8.517 0 0 0-1.806-2.66 8.518 8.518 0 0 0-2.66-1.805A7.993 7.993 0 0 0 10 1.667c-1.138 0-2.21.218-3.215.653a8.518 8.518 0 0 0-2.66 1.806A8.505 8.505 0 0 0 2.32 6.789a8.022 8.022 0 0 0-.653 3.22c0 1.138.218 2.21.653 3.214a8.552 8.552 0 0 0 4.465 4.457 7.994 7.994 0 0 0 3.215.653c1.138 0 2.21-.217 3.215-.653a8.518 8.518 0 0 0 2.66-1.806 8.516 8.516 0 0 0 1.805-2.66A7.992 7.992 0 0 0 18.333 10zm-1.389 0c0 .964-.18 1.866-.539 2.704a6.986 6.986 0 0 1-1.49 2.21 6.932 6.932 0 0 1-2.21 1.487 6.838 6.838 0 0 1-2.705.535 6.837 6.837 0 0 1-2.704-.535 7.011 7.011 0 0 1-2.214-1.483 6.837 6.837 0 0 1-2.026-4.91c0-.964.178-1.865.535-2.704a7 7 0 0 1 3.705-3.71c.839-.359 1.74-.538 2.704-.538.964 0 1.866.178 2.704.535a6.93 6.93 0 0 1 2.21 1.487 6.972 6.972 0 0 1 1.491 2.214c.36.841.54 1.744.54 2.708zm-3.758-.008c0-.588-.143-1.125-.429-1.61a3.211 3.211 0 0 0-1.16-1.156 3.13 3.13 0 0 0-1.613-.429c-.589 0-1.125.143-1.61.43a3.254 3.254 0 0 0-1.16 1.155 3.086 3.086 0 0 0-.433 1.61c0 .594.144 1.133.433 1.617.289.485.675.872 1.16 1.16a3.087 3.087 0 0 0 1.61.434c.588 0 1.126-.145 1.613-.433a3.243 3.243 0 0 0 1.16-1.16 3.124 3.124 0 0 0 .43-1.618z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "RECORD_STOP":
            return (
                <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17.68 6.785A7.992 7.992 0 0 1 18.332 10c0 1.138-.218 2.21-.653 3.215a8.516 8.516 0 0 1-1.806 2.66 8.518 8.518 0 0 1-2.66 1.805 7.994 7.994 0 0 1-3.214.653 7.994 7.994 0 0 1-3.215-.653 8.552 8.552 0 0 1-4.465-4.457 7.994 7.994 0 0 1-.653-3.215c0-1.138.217-2.211.653-3.219a8.505 8.505 0 0 1 1.806-2.663A8.517 8.517 0 0 1 6.785 2.32 7.993 7.993 0 0 1 10 1.667c1.138 0 2.21.218 3.215.653a8.518 8.518 0 0 1 2.659 1.806 8.517 8.517 0 0 1 1.806 2.66zm-4.842 6.054c.147-.15.22-.355.22-.617V7.778c0-.262-.073-.467-.22-.617-.147-.15-.352-.225-.613-.225H7.75c-.256 0-.457.075-.604.225-.147.15-.22.355-.22.617v4.444c0 .262.073.467.22.617.147.15.348.225.604.225h4.475c.261 0 .466-.075.613-.225z"
                        fill="#DF1642"
                    />
                </svg>
            )
        case "AWARD_FILL":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m12.666 13.834-1.54-6a3.96 3.96 0 0 0 .874-2.5 4 4 0 0 0-8 0 3.96 3.96 0 0 0 .893 2.513l-1.56 5.987a.667.667 0 0 0 .987.74l3.553-2.087 3.787 2.094c.102.061.22.091.34.086a.667.667 0 0 0 .666-.833zM8 2.667a2.667 2.667 0 1 1-2.667 2.667A2.667 2.667 0 0 1 8 2.667z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "ATTENDANCE_OUT":
            return (
                <svg
                    className={className}
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10.499" cy="10" r="8.333" fill={fillColor} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.417 8.005a.651.651 0 0 0-.921-.921L10.5 9.079 8.504 7.084a.651.651 0 0 0-.92.92L9.578 10l-1.996 1.996a.651.651 0 0 0 .921.921l1.996-1.996 1.996 1.996a.651.651 0 0 0 .92-.921L11.422 10l1.996-1.995z"
                        fill="#fff"
                    />
                </svg>
            )
        case "ATTENDANCE_IN":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.79 6.707-4.65 6.222a1.011 1.011 0 0 1-1.609.01l-2.483-3.225a1.051 1.051 0 0 1 .178-1.457 1.006 1.006 0 0 1 1.43.182l1.66 2.157 3.846-5.185a1.011 1.011 0 0 1 1.435-.197c.45.35.536 1.004.193 1.462v.031z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "NOTES_ATTENDANCE":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.07 4.93a10 10 0 0 0-16.28 11c.096.2.127.423.09.64L2 20.8a1 1 0 0 0 .27.91A1 1 0 0 0 3 22h.2l4.28-.86c.217-.026.438.005.64.09 5.073 2.183 10.955-.16 13.138-5.234A10 10 0 0 0 19.12 4.95l-.05-.02zm.83 8.36a8 8 0 0 1-11 6.08 3.26 3.26 0 0 0-1.25-.26 3.424 3.424 0 0 0-.56.05l-2.82.57.57-2.82a3.09 3.09 0 0 0-.21-1.81 8 8 0 0 1 6.08-11 8 8 0 0 1 9.19 9.19zM8.707 11.293a1 1 0 1 1-1.414 1.415 1 1 0 0 1 1.414-1.415zm4 1.415a1 1 0 1 0-1.414-1.415 1 1 0 0 0 1.414 1.415zm4 0a1 1 0 1 0-1.414-1.415 1 1 0 0 0 1.414 1.415z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "PAUSE":
            return (
                <svg className={className} width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                        d="M5.5 3.5A1.5 1.5 0 0 1 7 2h2a1.5 1.5 0 0 1 1.5 1.5v17A1.5 1.5 0 0 1 9 22H7a1.5 1.5 0 0 1-1.5-1.5v-17zM14.5 3.5A1.5 1.5 0 0 1 16 2h2a1.5 1.5 0 0 1 1.5 1.5v17A1.5 1.5 0 0 1 18 22h-2a1.5 1.5 0 0 1-1.5-1.5v-17z"
                        fill="#666"
                    />
                </svg>
            )
        case "RESUME":
            return (
                <svg className={className} width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                        d="M20.438 10.658c1.416.819 1.416 2.866 0 3.684l-12.75 7.37C6.27 22.53 4.5 21.507 4.5 19.869V5.131c0-1.638 1.77-2.662 3.188-1.843l12.75 7.37z"
                        fill="#18A957"
                    />
                </svg>
            )
        case "CHAT_LINE":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.223 14.08c0 .467.492.746.861.49l3.194-2.22h.112c2.913 0 5.277-2.465 5.277-5.509 0-3.043-2.364-5.508-5.277-5.508H6.612c-2.914 0-5.278 2.465-5.278 5.508 0 2.514 1.625 4.669 3.889 5.31v1.93zm1.114-2.487a.562.562 0 0 0-.449-.56c-1.93-.358-3.354-2.1-3.354-4.148 0-2.328 1.823-4.218 4.075-4.218h2.717c2.251 0 4.075 1.89 4.075 4.218 0 2.327-1.824 4.217-4.075 4.217h-.272a.526.526 0 0 0-.3.094l-2.417 1.67v-1.273z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "PLUS_PERSON":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.333 4.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0zM8 4.667a1.333 1.333 0 1 0-2.667 0 1.333 1.333 0 0 0 2.667 0zM14 4h-.667v-.667a.667.667 0 1 0-1.333 0V4h-.667a.667.667 0 0 0 0 1.333H12V6a.667.667 0 0 0 1.333 0v-.667H14A.667.667 0 1 0 14 4zM2 13.333a4.667 4.667 0 0 1 9.333 0 .667.667 0 1 1-1.333 0 3.333 3.333 0 0 0-6.667 0 .667.667 0 1 1-1.333 0z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "IN_CLASS":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.667 7.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333zm7.773-4.5a.667.667 0 0 0-.94.06l-1.247 1.434-.42-.474a.668.668 0 1 0-1 .887l.927 1.04a.667.667 0 0 0 .993-.007l1.74-2a.667.667 0 0 0-.053-.94zm-3.107 10.5a.667.667 0 0 1-.666.667h-8A.667.667 0 0 1 2 13.333a4.667 4.667 0 0 1 9.333 0z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "OUT_CLASS":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.333 4.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0zm2 8.666a.667.667 0 0 1-.666.667h-8A.667.667 0 0 1 2 13.333a4.667 4.667 0 0 1 9.333 0zM14.08 5.138l-1.885-1.885a.667.667 0 1 0-.943.943l1.885 1.885a.667.667 0 1 0 .943-.943z"
                        fill={fillColor}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.08 4.196 12.195 6.08a.667.667 0 1 1-.943-.943l1.886-1.885a.667.667 0 1 1 .942.943z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "SMS":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.22 14.08c0 .466.493.745.862.489l3.195-2.22h.11c2.914 0 5.278-2.465 5.278-5.508s-2.364-5.508-5.277-5.508H6.61c-2.913 0-5.278 2.465-5.278 5.508 0 2.513 1.625 4.668 3.889 5.31v1.929zm1.115-2.488a.562.562 0 0 0-.448-.56c-1.931-.358-3.355-2.1-3.355-4.148 0-2.328 1.823-4.218 4.075-4.218h2.717c2.251 0 4.075 1.89 4.075 4.218 0 2.328-1.824 4.218-4.075 4.218h-.272a.526.526 0 0 0-.3.094l-2.417 1.67v-1.274z"
                        fill={fillColor}
                    />
                    <path
                        d="M5.062 8.666a1.2 1.2 0 0 1-.535-.116.922.922 0 0 1-.38-.343A1.076 1.076 0 0 1 4 7.66h.706c.01.12.045.214.104.278.06.062.137.093.233.093a.33.33 0 0 0 .233-.079.303.303 0 0 0 .085-.227.29.29 0 0 0-.07-.2.52.52 0 0 0-.167-.129 2.259 2.259 0 0 0-.279-.116 2.773 2.773 0 0 1-.43-.195.849.849 0 0 1-.287-.287.916.916 0 0 1-.12-.496c0-.303.092-.54.275-.71.184-.172.423-.259.717-.259.3 0 .542.087.725.26.184.17.282.408.295.714h-.717a.356.356 0 0 0-.097-.246.303.303 0 0 0-.229-.093.253.253 0 0 0-.194.079c-.049.05-.073.122-.073.218 0 .105.04.187.124.246.082.058.212.122.387.19.176.07.318.139.427.204.111.065.207.159.287.282.08.124.12.283.12.478 0 .185-.04.354-.12.505a.885.885 0 0 1-.341.362c-.15.09-.327.134-.532.134zM9.546 5.38v3.254h-.663V6.682l-.61 1.952H7.74l-.613-1.957v1.957h-.663V5.379h.783l.764 2.254.756-2.254h.78zM11.007 8.666a1.2 1.2 0 0 1-.535-.116.922.922 0 0 1-.38-.343 1.076 1.076 0 0 1-.147-.547h.706c.01.12.045.214.104.278.06.062.137.093.233.093a.33.33 0 0 0 .233-.079.303.303 0 0 0 .085-.227.29.29 0 0 0-.07-.2.52.52 0 0 0-.167-.129 2.256 2.256 0 0 0-.279-.116 2.779 2.779 0 0 1-.43-.195.849.849 0 0 1-.287-.287.916.916 0 0 1-.12-.496c0-.303.091-.54.275-.71.184-.172.423-.259.717-.259.3 0 .542.087.725.26.184.17.282.408.295.714h-.717a.356.356 0 0 0-.097-.246.303.303 0 0 0-.229-.093.253.253 0 0 0-.194.079c-.049.05-.073.122-.073.218 0 .105.04.187.124.246.082.058.212.122.387.19.176.07.318.139.427.204.111.065.207.159.287.282.08.124.12.283.12.478 0 .185-.04.354-.12.505a.885.885 0 0 1-.341.362c-.15.09-.327.134-.532.134z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "REGISTERED":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm9.66-2.75a1 1 0 0 0-1.41.09l-1.87 2.15-.63-.71a1.002 1.002 0 0 0-1.5 1.33l1.39 1.56a1 1 0 0 0 .75.33 1 1 0 0 0 .74-.34l2.61-3a1 1 0 0 0-.08-1.41zM3 20a7 7 0 1 1 14 0 1 1 0 1 1-2 0 5 5 0 0 0-10 0 1 1 0 1 1-2 0z"
                        fill="#1E90FF"
                    />
                </svg>
            )

        case "TOTAL_DROP":
            return (
                <svg
                    className={className}
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.25 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm9-1h-4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-18 14a7 7 0 1 1 14 0 1 1 0 1 1-2 0 5 5 0 0 0-10 0 1 1 0 1 1-2 0z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "ARROW_CIRCLE_RIGHT":
            return (
                <svg
                    className={className}
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 29.333c7.364 0 13.334-5.97 13.334-13.333 0-7.364-5.97-13.334-13.333-13.334C8.637 2.666 2.667 8.636 2.667 16c0 7.363 5.97 13.333 13.334 13.333zm0-24c5.892 0 10.667 4.776 10.667 10.667 0 5.89-4.775 10.666-10.666 10.666S5.334 21.891 5.334 16 10.11 5.333 16.001 5.333zm2.214 12h-7.547a1.333 1.333 0 1 1 0-2.667h7.454l-1.734-1.706-.007-.008a1.333 1.333 0 0 1 .007-1.886l.008-.007a1.333 1.333 0 0 1 1.886.007l4 4c.12.123.215.268.28.427.068.16.104.332.106.507l-.026.12a1.177 1.177 0 0 1-.08.373.961.961 0 0 1-.147.253c-.035.061-.076.12-.12.174l-3.813 4a1.335 1.335 0 0 1-1.934-1.84l1.667-1.747z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "FOLLOW_UP":
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}>
                    <path
                        d="m14.604 10.582 1.797 2.325c.2.259.698.259.898 0l1.796-2.325c.2-.259-.05-.582-.449-.582h-1.218a8.355 8.355 0 0 0-1.883-5.286 8.292 8.292 0 0 0-4.796-2.887 8.268 8.268 0 0 0-5.53.824 8.32 8.32 0 0 0-3.755 4.16 8.366 8.366 0 0 0-.275 5.608 8.33 8.33 0 0 0 3.331 4.51 8.271 8.271 0 0 0 10.478-1.036l-.819-.822a7.117 7.117 0 0 1-9.016.892 7.168 7.168 0 0 1-2.866-3.881 7.199 7.199 0 0 1 .236-4.826 7.16 7.16 0 0 1 3.231-3.58 7.114 7.114 0 0 1 4.76-.708A7.135 7.135 0 0 1 14.65 5.45a7.19 7.19 0 0 1 1.62 4.55h-1.217c-.4 0-.649.322-.449.58z"
                        fill={fillColor}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.168 5c.23 0 .417.187.417.417v5.416a.417.417 0 0 1-.667.334l-3.333-2.5a.417.417 0 0 1 .5-.667l2.666 2V5.417c0-.23.187-.417.417-.417z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "REPLY":
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.838 10.859a.588.588 0 0 0 0 .829l4.911 4.826c.343.337.902.08.902-.414v-2.554C12.793 12.471 16.79 8.036 17.5 2.5c-2.056 3.356-5.626 5.812-9.849 6.57V6.447c0-.495-.559-.752-.902-.415L1.838 10.86z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "TRENDING_UP":
            return (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.0018 7V7C21.0113 6.93032 21.0113 6.85968 21.0018 6.79C20.9931 6.73129 20.9763 6.67407 20.9518 6.62V6.62C20.9254 6.57113 20.8953 6.52433 20.8618 6.48C20.8237 6.41675 20.7766 6.35947 20.7218 6.31L20.6018 6.24C20.5441 6.19696 20.4799 6.16321 20.4118 6.14H20.2118V6.14C20.1508 6.081 20.0797 6.03356 20.0018 6H15.0018V6C14.4495 6 14.0018 6.44771 14.0018 7C14.0018 7.55228 14.4495 8 15.0018 8H17.8318L13.8318 12.71L9.51179 10.14C9.08907 9.88858 8.5463 9.98187 8.23179 10.36L3.23179 16.36H3.23179C2.87823 16.7843 2.93558 17.4149 3.35986 17.7684C3.3605 17.7689 3.36114 17.7695 3.36179 17.77C3.5417 17.9191 3.76813 18.0005 4.00179 18C4.29922 18.0005 4.58143 17.8685 4.77179 17.64L9.22179 12.3L13.4918 14.86C13.9099 15.108 14.4458 15.0194 14.7618 14.65L19.0018 9.7V12C19.0018 12.5523 19.4495 13 20.0018 13C20.5541 13 21.0018 12.5523 21.0018 12V7V7Z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "IMAGE":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3ZM6 5H18C18.5523 5 19 5.44772 19 6V14.36L15.8 11.63C14.7775 10.7887 13.3025 10.7887 12.28 11.63L5 17.7V6C5 5.44772 5.44772 5 6 5ZM9.06066 9.56066C9.64645 8.97487 9.64645 8.02513 9.06066 7.43934C8.47487 6.85355 7.52513 6.85355 6.93934 7.43934C6.35355 8.02513 6.35355 8.97487 6.93934 9.56066C7.52513 10.1464 8.47487 10.1464 9.06066 9.56066Z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "CROSS_CIRCLE_BORDER":
            return (
                <svg
                    className={className}
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="28" cy="28" r="28" fill="#fff" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M28 10.5c-9.667 0-17.5 7.833-17.5 17.5S18.333 45.5 28 45.5 45.5 37.667 45.5 28 37.667 10.5 28 10.5zm8.581 22.094a.848.848 0 0 1 0 1.2l-2.794 2.787a.848.848 0 0 1-1.2 0L28 31.95l-4.593 4.63a.848.848 0 0 1-1.2 0l-2.787-2.795a.847.847 0 0 1 0-1.2L24.049 28l-4.63-4.594a.847.847 0 0 1 0-1.2l2.795-2.794a.848.848 0 0 1 1.2 0L28 24.048l4.594-4.629a.847.847 0 0 1 1.2 0l2.794 2.795a.847.847 0 0 1 0 1.2L31.952 28l4.629 4.594z"
                        fill={fillColor}
                    />
                </svg>
            )

        case "EDIT_SIGNATURE":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.328 17.753c-.369.474-.437 1.113.002 1.555.2.202.2.53 0 .732a.51.51 0 0 1-.724 0c-.928-.936-.654-2.194-.084-2.926.289-.37.702-.68 1.177-.762.514-.087 1.022.107 1.387.599.307.413.372.869.342 1.294-.027.379-.135.775-.23 1.125l-.02.072c-.114.424-.209.807-.223 1.169a55.373 55.373 0 0 0 .326-.686c.232-.49.491-1.026.741-1.419.122-.192.266-.39.43-.528.148-.127.474-.332.844-.145.352.177.505.49.569.764.056.242.056.51.056.707v.025c0 .232.003.383.03.496.006.03.013.05.018.06a.667.667 0 0 0 .067-.006c.103-.014.24-.049.41-.104.232-.076.47-.17.712-.266.125-.05.25-.099.377-.147.173-.065.352-.129.509-.167.078-.02.168-.037.258-.042a.725.725 0 0 1 .368.07.598.598 0 0 1 .326.471.786.786 0 0 1-.064.389c-.075.18-.215.383-.39.604a.51.51 0 0 1-.908-.255l-.061.024c-.259.102-.551.218-.811.303-.193.063-.397.119-.588.145-.172.024-.424.037-.653-.078-.352-.178-.504-.49-.568-.764-.057-.243-.057-.51-.057-.708v-.025c0-.108 0-.2-.004-.277a.863.863 0 0 0-.007.013c-.21.329-.442.805-.68 1.306l-.082.175c-.202.428-.407.862-.585 1.164-.091.156-.218.354-.375.477a.632.632 0 0 1-.5.136.623.623 0 0 1-.445-.35c-.509-1.026-.232-2.048-.03-2.797l.002-.007.008-.03c.105-.389.188-.694.208-.969.018-.262-.025-.444-.14-.599-.147-.198-.28-.219-.396-.199-.154.027-.36.148-.542.38zM19.224 2.63a.639.639 0 0 1 .873-.233l2.215 1.278c.305.177.41.567.234.873l-.64 1.107-3.32-1.918.639-1.106zm-.958 1.66-5.91 10.239 3.32 1.917 5.911-10.238-3.321-1.917zM11.628 15.6a.948.948 0 0 1 .322-.567l3.493 2.016a.949.949 0 0 1-.332.563l-2.088 1.73-1.849-1.068.454-2.673zm-.51 3.01-.025.142c-.149.876.872 1.466 1.557.899l.11-.092-1.643-.949z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "ATTENDANCE_QR_CODE":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.78 4.5H6.22c-.595 0-.949.001-1.211.023-.16.013-.227.03-.246.036a.5.5 0 0 0-.204.204 1.252 1.252 0 0 0-.036.246c-.022.262-.023.616-.023 1.211v1.56c0 .595.001.949.023 1.211.013.16.03.227.036.246a.5.5 0 0 0 .204.204c.019.005.086.023.246.036.262.022.616.023 1.211.023h1.56c.595 0 .949-.001 1.211-.023.16-.013.227-.03.246-.036a.5.5 0 0 0 .204-.204c.005-.019.023-.086.036-.246.022-.262.023-.616.023-1.211V6.22c0-.595-.001-.949-.023-1.211a1.252 1.252 0 0 0-.036-.246.5.5 0 0 0-.204-.204 1.252 1.252 0 0 0-.246-.036C8.73 4.501 8.375 4.5 7.78 4.5zm9.434 11.66a2.002 2.002 0 0 0-1.176 1.45c-.038.193-.038.425-.038.89s0 .697.038.89a2 2 0 0 0 1.572 1.572c.193.038.425.038.89.038s.697 0 .89-.038a2 2 0 0 0 1.572-1.572c.038-.193.038-.425.038-.89s0-.697-.038-.89a2 2 0 0 0-1.572-1.572C19.197 16 18.965 16 18.5 16s-.697 0-.89.038c-.138.028-.27.07-.396.123zm-1.232-1.02c.018-.153.018-.352.018-.64 0-.466 0-.699-.076-.883a1 1 0 0 0-.541-.54C15.199 13 14.966 13 14.5 13s-.699 0-.883.076a1 1 0 0 0-.54.541c-.077.184-.077.417-.077.883s0 .699.076.883a1 1 0 0 0 .541.54c.184.077.417.077.883.077.288 0 .487 0 .64-.018a.892.892 0 0 0 .243-.058 1 1 0 0 0 .54-.541.892.892 0 0 0 .059-.243zM7.78 14.5H6.22c-.595 0-.949.001-1.211.023-.16.013-.227.03-.246.037a.5.5 0 0 0-.204.204 1.25 1.25 0 0 0-.036.245c-.022.262-.023.616-.023 1.211v1.56c0 .595.001.949.023 1.211.013.16.03.227.036.245a.5.5 0 0 0 .204.204c.019.006.086.024.246.037.262.022.616.023 1.211.023h1.56c.595 0 .949-.001 1.211-.023.16-.013.227-.03.246-.037a.5.5 0 0 0 .204-.204 1.25 1.25 0 0 0 .036-.245c.022-.262.023-.616.023-1.211v-1.56c0-.595-.001-.949-.023-1.211a1.25 1.25 0 0 0-.036-.245.5.5 0 0 0-.204-.204 1.254 1.254 0 0 0-.246-.037c-.262-.022-.616-.023-1.211-.023zm10-10h-1.56c-.595 0-.949.001-1.211.023a1.25 1.25 0 0 0-.245.036.5.5 0 0 0-.204.204 1.254 1.254 0 0 0-.037.246c-.022.262-.023.616-.023 1.211v1.56c0 .595.001.949.023 1.211.013.16.03.227.037.246a.5.5 0 0 0 .204.204c.018.005.085.023.245.036.262.022.616.023 1.211.023h1.56c.595 0 .949-.001 1.211-.023.16-.013.227-.03.245-.036a.5.5 0 0 0 .204-.204c.006-.019.024-.086.037-.246.022-.262.023-.616.023-1.211V6.22c0-.595-.001-.949-.023-1.211a1.254 1.254 0 0 0-.037-.246.5.5 0 0 0-.204-.204 1.25 1.25 0 0 0-.245-.036c-.262-.022-.616-.023-1.211-.023zm.224 14.996c.11.004.253.004.496.004.242 0 .387 0 .496-.004.068-.002.098-.005.105-.006a.5.5 0 0 0 .389-.389c0-.007.004-.037.006-.105.004-.11.004-.253.004-.496 0-.242 0-.387-.004-.496a1.336 1.336 0 0 0-.006-.105.5.5 0 0 0-.389-.389c-.007 0-.037-.004-.105-.006a16.523 16.523 0 0 0-.496-.004c-.242 0-.387 0-.496.004a1.331 1.331 0 0 0-.105.006.5.5 0 0 0-.389.389c0 .007-.004.037-.006.105-.004.11-.004.253-.004.496 0 .242 0 .387.004.496.002.068.005.098.006.105a.5.5 0 0 0 .389.389c.007 0 .037.004.105.006zm-3.969-4.988h-.002zm.473.457v.002zm.457-.473h.002zm-.473-.457v-.002zM3 6.22c0-1.139 0-1.708.225-2.142a2 2 0 0 1 .853-.853C4.512 3 5.081 3 6.22 3h1.56c1.139 0 1.708 0 2.142.225a2 2 0 0 1 .853.853C11 4.512 11 5.081 11 6.22v1.56c0 1.139 0 1.708-.225 2.142a2 2 0 0 1-.853.853C9.488 11 8.919 11 7.78 11H6.22c-1.139 0-1.708 0-2.142-.225a2 2 0 0 1-.853-.853C3 9.488 3 8.919 3 7.78V6.22zm0 10c0-1.139 0-1.708.225-2.142a2 2 0 0 1 .853-.853C4.512 13 5.081 13 6.22 13h1.56c1.139 0 1.708 0 2.142.225a2 2 0 0 1 .853.853c.225.434.225 1.003.225 2.142v1.56c0 1.139 0 1.708-.225 2.142a2 2 0 0 1-.853.853C9.488 21 8.919 21 7.78 21H6.22c-1.139 0-1.708 0-2.142-.225a2 2 0 0 1-.853-.853C3 19.488 3 18.919 3 17.78v-1.56zM13.225 4.078C13 4.512 13 5.081 13 6.22v1.56c0 1.139 0 1.708.225 2.142a2 2 0 0 0 .853.853c.434.225 1.003.225 2.142.225h1.56c1.139 0 1.708 0 2.142-.225a2 2 0 0 0 .853-.853C21 9.488 21 8.919 21 7.78V6.22c0-1.139 0-1.708-.225-2.142a2 2 0 0 0-.853-.853C19.488 3 18.919 3 17.78 3h-1.56c-1.139 0-1.708 0-2.142.225a2 2 0 0 0-.853.853z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "SIGN_MAKEUP_ATTENDANCE":
            return (
                <svg width="105" height="104" viewBox="0 0 105 104" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x=".5" width="104" height="104" rx="52" fill="#E9F4FF" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M37.382 61.59c-.616.79-.728 1.855.003 2.593a.867.867 0 0 1 0 1.22.849.849 0 0 1-1.208 0c-1.546-1.561-1.089-3.657-.139-4.877.481-.618 1.17-1.134 1.962-1.27.856-.146 1.703.179 2.311.998.513.69.62 1.448.57 2.157-.045.632-.224 1.291-.383 1.876l-.032.118c-.192.708-.349 1.346-.373 1.948a89.81 89.81 0 0 0 .544-1.142c.386-.816.818-1.71 1.234-2.365.204-.32.444-.648.716-.88.248-.212.79-.554 1.408-.242.587.296.84.815.948 1.273.094.405.094.85.093 1.18v.041c0 .386.005.638.049.826.012.05.023.082.032.101.026 0 .062-.003.111-.01.171-.024.4-.082.684-.175.385-.125.782-.283 1.186-.442.208-.082.417-.165.628-.245.289-.11.587-.215.848-.28.13-.032.28-.06.431-.069.134-.007.372-.005.612.116a.997.997 0 0 1 .544.787c.03.27-.047.504-.107.647-.125.3-.358.638-.65 1.006a.849.849 0 0 1-1.2.135.861.861 0 0 1-.313-.559l-.102.04c-.43.17-.918.363-1.351.504a5.808 5.808 0 0 1-.98.243c-.286.04-.707.062-1.088-.13-.587-.296-.84-.816-.948-1.274-.094-.404-.094-.85-.093-1.18v-.04c0-.182-.002-.333-.007-.462l-.013.02c-.349.548-.736 1.342-1.132 2.177l-.137.292c-.337.713-.679 1.437-.975 1.94-.152.26-.364.59-.626.794-.13.102-.43.299-.833.227-.432-.076-.651-.398-.742-.581-.848-1.711-.387-3.415-.049-4.664l.003-.01.014-.051c.175-.648.313-1.157.345-1.615.032-.437-.04-.74-.232-.998-.246-.33-.467-.365-.66-.332-.258.044-.602.247-.903.634zM65.542 36.383c.294-.51.946-.684 1.455-.39l3.69 2.131c.51.294.684.945.39 1.455l-1.065 1.845-5.535-3.196 1.065-1.845zm-1.598 2.767-9.85 17.063 5.534 3.196 9.852-17.063-5.536-3.196zM52.881 58c.066-.391.265-.716.536-.947l5.822 3.361a1.58 1.58 0 0 1-.552.938l-3.48 2.883-3.082-1.78L52.88 58zm-.851 5.016-.04.236c-.248 1.46 1.453 2.443 2.594 1.498l.185-.153-2.74-1.581z"
                        fill={fillColor}
                    />
                </svg>
            )
        case "SUPPORT_HUB": {
            return (
                <svg className={className} width="31" height="25" viewBox="0 0 31 25" fill="none">
                    <path
                        d="M10.0759 17.1875C15.6415 17.1875 20.1512 13.3398 20.1512 8.59375C20.1512 3.84766 15.6415 0 10.0759 0C4.51021 0 0.000530139 3.84766 0.000530139 8.59375C0.000530139 10.4785 0.712585 12.2217 1.91872 13.6426C1.74918 14.1016 1.4973 14.5068 1.23088 14.8486C0.998376 15.1514 0.761025 15.3857 0.586644 15.5469C0.499453 15.625 0.426795 15.6885 0.378355 15.7275C0.354136 15.7471 0.33476 15.7617 0.325072 15.7666L0.315385 15.7764C0.0489693 15.9766 -0.0672847 16.3281 0.0392815 16.6455C0.145848 16.9629 0.441326 17.1875 0.775556 17.1875C1.83153 17.1875 2.89719 16.9141 3.78363 16.5771C4.22927 16.4062 4.64584 16.2158 5.00429 16.0205C6.49622 16.7627 8.2255 17.1875 10.0759 17.1875ZM21.7013 8.59375C21.7013 14.0771 16.9009 18.208 11.2142 18.7012C12.3913 22.334 16.2955 25 20.9262 25C22.7766 25 24.5059 24.5752 25.9978 23.833C26.3611 24.0283 26.7728 24.2188 27.2185 24.3896C28.1049 24.7266 29.1706 25 30.2266 25C30.5608 25 30.8611 24.7803 30.9628 24.458C31.0646 24.1357 30.9531 23.7842 30.6819 23.584L30.6722 23.5742C30.6625 23.5645 30.6431 23.5547 30.6189 23.5352C30.5705 23.4961 30.4978 23.4375 30.4106 23.3545C30.2362 23.1934 29.9989 22.959 29.7664 22.6562C29.5 22.3145 29.2481 21.9043 29.0785 21.4502C30.2847 20.0342 30.9967 18.291 30.9967 16.4014C30.9967 11.8701 26.8843 8.1543 21.6674 7.83203C21.6867 8.08105 21.6964 8.33496 21.6964 8.58887L21.7013 8.59375ZM8.72926 3.77441H11.0786C12.4881 3.77441 13.6265 4.92676 13.6265 6.34277C13.6265 7.26074 13.1372 8.11523 12.3477 8.56934L11.0447 9.32617C11.035 9.8584 10.6039 10.2832 10.0759 10.2832C9.54304 10.2832 9.10709 9.84375 9.10709 9.30664V8.76465C9.10709 8.41309 9.29116 8.09082 9.59148 7.91992L11.3837 6.87988C11.5726 6.76758 11.6889 6.56738 11.6889 6.34766C11.6889 6.00586 11.4128 5.73242 11.0786 5.73242H8.72926C8.59363 5.73242 8.47254 5.82031 8.4241 5.94727L8.40472 5.99609C8.2255 6.50391 7.67329 6.77246 7.16952 6.5918C6.66576 6.41113 6.39934 5.85449 6.57857 5.34668L6.59794 5.29785C6.91764 4.38965 7.77017 3.7793 8.72926 3.7793V3.77441ZM10.0759 11.5869C10.252 11.576 10.4286 11.6016 10.5946 11.6621C10.7606 11.7226 10.9125 11.8166 11.0411 11.9385C11.1697 12.0604 11.2721 12.2076 11.3421 12.3709C11.4122 12.5342 11.4483 12.7103 11.4483 12.8882C11.4483 13.0661 11.4122 13.2421 11.3421 13.4055C11.2721 13.5688 11.1697 13.7159 11.0411 13.8378C10.9125 13.9597 10.7606 14.0538 10.5946 14.1143C10.4286 14.1748 10.252 14.2003 10.0759 14.1895C9.8997 14.2003 9.72318 14.1748 9.55718 14.1143C9.39118 14.0538 9.23922 13.9597 9.11065 13.8378C8.98208 13.7159 8.87963 13.5688 8.80959 13.4055C8.73956 13.2421 8.70343 13.0661 8.70343 12.8882C8.70343 12.7103 8.73956 12.5342 8.80959 12.3709C8.87963 12.2076 8.98208 12.0604 9.11065 11.9385C9.23922 11.8166 9.39118 11.7226 9.55718 11.6621C9.72318 11.6016 9.8997 11.576 10.0759 11.5869ZM27.4219 15.9229L23.5468 19.8291C23.169 20.21 22.5538 20.21 22.176 19.8291L20.2384 17.876C19.8606 17.4951 19.8606 16.875 20.2384 16.4941C20.6162 16.1133 21.2314 16.1133 21.6092 16.4941L22.8638 17.7588L26.0559 14.541C26.4338 14.1602 27.0489 14.1602 27.4268 14.541C27.8046 14.9219 27.8046 15.542 27.4268 15.9229H27.4219Z"
                        fill={fillColor}
                    />
                </svg>
            )
        }
        case "VIEW_BLOCKS": {
            return (
                <svg
                    className={className}
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.667 6.667A2.667 2.667 0 0 1 5.333 4H12a2.667 2.667 0 0 1 2.667 2.667V12A2.667 2.667 0 0 1 12 14.667H5.333A2.667 2.667 0 0 1 2.667 12V6.667zM17.333 6.667A2.667 2.667 0 0 1 20 4h6.667a2.667 2.667 0 0 1 2.666 2.667V12a2.667 2.667 0 0 1-2.666 2.667H20A2.667 2.667 0 0 1 17.333 12V6.667zM2.667 20a2.667 2.667 0 0 1 2.666-2.667H12A2.667 2.667 0 0 1 14.667 20v5.333A2.667 2.667 0 0 1 12 28H5.333a2.667 2.667 0 0 1-2.666-2.667V20zM17.333 20A2.667 2.667 0 0 1 20 17.333h6.667A2.667 2.667 0 0 1 29.333 20v5.333A2.667 2.667 0 0 1 26.667 28H20a2.667 2.667 0 0 1-2.667-2.667V20z"
                        fill={fillColor}
                    />
                </svg>
            )
        }
        case "CHECKLIST": {
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.94 6C9.42085 6 9 6.42085 9 6.94V7.06C9 7.57915 9.42085 8 9.94 8H21.06C21.5791 8 22 7.57915 22 7.06V6.94C22 6.42085 21.5791 6 21.06 6H9.94ZM3 14C3.55228 14 4 13.5523 4 13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13C2 13.5523 2.44772 14 3 14ZM3 20C3.55228 20 4 19.5523 4 19C4 18.4477 3.55228 18 3 18C2.44772 18 2 18.4477 2 19C2 19.5523 2.44772 20 3 20ZM6.94 18C6.42085 18 6 18.4209 6 18.94V19.06C6 19.5791 6.42085 20 6.94 20H21.06C21.5791 20 22 19.5791 22 19.06V18.94C22 18.4209 21.5791 18 21.06 18H6.94ZM6 12.94C6 12.4209 6.42085 12 6.94 12H21.06C21.5791 12 22 12.4209 22 12.94V13.06C22 13.5791 21.5791 14 21.06 14H6.94C6.42085 14 6 13.5791 6 13.06V12.94Z"
                        fill={fillColor}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.60262 2.29684L3.66174 6.04398L2.39358 4.46269C2.12933 4.13571 1.63992 4.07699 1.30047 4.33154C0.961024 4.58608 0.900066 5.0575 1.16432 5.38448L3.05489 7.71521C3.20335 7.89619 3.43006 8.00123 3.66952 7.99999H3.66952C3.91031 7.99943 4.13727 7.89151 4.28415 7.70771L7.83966 3.21114C8.10177 2.88002 8.03559 2.40692 7.69184 2.15445C7.34809 1.90197 6.85695 1.96572 6.59484 2.29684V2.29684L6.60262 2.29684Z"
                        fill={fillColor}
                    />
                </svg>
            )
        }
        case "DEVICE_PHONE": {
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
                    />
                </svg>
            )
        }

        case "FILE_UP": {
            return (
                <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M12.71,11.29a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-2,2a1,1,0,0,0,1.42,1.42l.29-.3V17a1,1,0,0,0,2,0V14.41l.29.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42ZM20,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19l-.1,0A1.1,1.1,0,0,0,13.06,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V9S20,9,20,8.94ZM14,5.41,16.59,8H15a1,1,0,0,1-1-1ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V7a3,3,0,0,0,3,3h3Z"
                        fill={fillColor}
                    />
                </svg>
            )
        }

        case "DECIMAL_INCREASE":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                    <path
                        fill={fillColor}
                        d="m18.35 21.65 -1.05 -1.05 1.825 -1.85H12v-1.5h7.125l-1.825 -1.85 1.05 -1.05L22 18l-3.65 3.65ZM2 13v-2.5h2.5v2.5H2Zm7.5 0c-0.96665 0 -1.79165 -0.34165 -2.475 -1.025C6.34165 11.29165 6 10.46665 6 9.5v-4c0 -0.966665 0.34165 -1.791665 1.025 -2.475C7.70835 2.341665 8.53335 2 9.5 2s1.79165 0.341665 2.475 1.025C12.65835 3.708335 13 4.533335 13 5.5v4c0 0.96665 -0.34165 1.79165 -1.025 2.475C11.29165 12.65835 10.46665 13 9.5 13Zm9 0c-0.96665 0 -1.79165 -0.34165 -2.475 -1.025C15.34165 11.29165 15 10.46665 15 9.5v-4c0 -0.966665 0.34165 -1.791665 1.025 -2.475C16.70835 2.341665 17.53335 2 18.5 2s1.79165 0.341665 2.475 1.025C21.65835 3.708335 22 4.533335 22 5.5v4c0 0.96665 -0.34165 1.79165 -1.025 2.475C20.29165 12.65835 19.46665 13 18.5 13Zm-9.006 -1.5c0.554 0 1.02685 -0.1944 1.4185 -0.58325C11.30415 10.52775 11.5 10.0555 11.5 9.5v-4c0 -0.5555 -0.19385 -1.02775 -0.5815 -1.41675C10.53065 3.694415 10.05985 3.5 9.506 3.5c-0.554 0 -1.02685 0.194415 -1.4185 0.58325C7.69585 4.47225 7.5 4.9445 7.5 5.5v4c0 0.5555 0.19385 1.02775 0.5815 1.41675 0.38785 0.38885 0.85865 0.58325 1.4125 0.58325Zm9 0c0.554 0 1.02685 -0.1944 1.4185 -0.58325C20.30415 10.52775 20.5 10.0555 20.5 9.5v-4c0 -0.5555 -0.19385 -1.02775 -0.5815 -1.41675C19.53065 3.694415 19.05985 3.5 18.506 3.5c-0.554 0 -1.02685 0.194415 -1.4185 0.58325C16.69585 4.47225 16.5 4.9445 16.5 5.5v4c0 0.5555 0.19385 1.02775 0.5815 1.41675 0.38785 0.38885 0.85865 0.58325 1.4125 0.58325Z"
                        stroke-width="0.5"></path>
                </svg>
            )
        case "DECIMAL_DECREASE":
            return (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                    <path
                        fill={fillColor}
                        d="M15.65 21.65 12 18l3.65 -3.65 1.05 1.05 -1.825 1.85H22v1.5H14.875l1.825 1.85 -1.05 1.05ZM2 13v-2.5h2.5v2.5H2Zm7.5 0c-0.96665 0 -1.79165 -0.34165 -2.475 -1.025C6.34165 11.29165 6 10.46665 6 9.5v-4c0 -0.966665 0.34165 -1.791665 1.025 -2.475C7.70835 2.341665 8.53335 2 9.5 2s1.79165 0.341665 2.475 1.025C12.65835 3.708335 13 4.533335 13 5.5v4c0 0.96665 -0.34165 1.79165 -1.025 2.475C11.29165 12.65835 10.46665 13 9.5 13Zm-0.006 -1.5c0.554 0 1.02685 -0.1944 1.4185 -0.58325C11.30415 10.52775 11.5 10.0555 11.5 9.5v-4c0 -0.5555 -0.19385 -1.02775 -0.5815 -1.41675C10.53065 3.694415 10.05985 3.5 9.506 3.5c-0.554 0 -1.02685 0.194415 -1.4185 0.58325C7.69585 4.47225 7.5 4.9445 7.5 5.5v4c0 0.5555 0.19385 1.02775 0.5815 1.41675 0.38785 0.38885 0.85865 0.58325 1.4125 0.58325Z"
                        stroke-width="0.5"></path>
                </svg>
            )
        case "QUICKBOOKS":
            return (
                <svg
                    className={className}
                    enable-background="new 0 0 2500 2500"
                    viewBox="0 0 2500 2500"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="1250" cy="1250" fill="#2ca01c" r="1250" />
                    <path
                        d="m301.3 1249.6c.1 282.6 228 512.4 510.6 514.9h72.3v-188.9h-72.3c-175.2 47.8-355.9-55.5-403.6-230.7-.4-1.4-.7-2.8-1.1-4.2-49.1-177.5 53.7-361.4 230.6-412.5h36.1c45.3-9.9 92.2-9.9 137.5 0h175.6v1002.9c-.9 106.1 84.4 192.9 190.5 193.9v-1395.4h-364.5c-284.6 1.5-514 233.4-512.5 518v.1zm1387.5-519.8h-72.3v198.9h72.3c174.8-47.7 355.1 55.3 402.8 230 .4 1.3.7 2.7 1.1 4 48.8 176.9-53.7 360.1-229.9 411.1h-36.1c-45.3 9.9-92.2 9.9-137.5 0h-175.6v-1002.8c.9-106.1-84.4-192.9-190.5-193.9v1397.4h364.5c287.1-4.5 516.2-240.8 511.8-527.9-4.4-280.8-230.9-507.4-511.8-511.8z"
                        fill="#fff"
                    />
                </svg>
            )
        case "KNOWLEDGE":
            return (
                <svg
                    className={className}
                    width="19"
                    height="21"
                    viewBox="0 0 19 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_3271_1935)">
                        <path
                            d="M4.07143 0C1.82366 0 0 1.76367 0 3.9375V17.0625C0 19.2363 1.82366 21 4.07143 21H16.2857H17.6429C18.3935 21 19 20.4135 19 19.6875C19 18.9615 18.3935 18.375 17.6429 18.375V15.75C18.3935 15.75 19 15.1635 19 14.4375V1.3125C19 0.586523 18.3935 0 17.6429 0H16.2857H4.07143ZM4.07143 15.75H14.9286V18.375H4.07143C3.32076 18.375 2.71429 17.7885 2.71429 17.0625C2.71429 16.3365 3.32076 15.75 4.07143 15.75ZM5.42857 5.90625C5.42857 5.54531 5.73393 5.25 6.10714 5.25H14.25C14.6232 5.25 14.9286 5.54531 14.9286 5.90625C14.9286 6.26719 14.6232 6.5625 14.25 6.5625H6.10714C5.73393 6.5625 5.42857 6.26719 5.42857 5.90625ZM6.10714 7.875H14.25C14.6232 7.875 14.9286 8.17031 14.9286 8.53125C14.9286 8.89219 14.6232 9.1875 14.25 9.1875H6.10714C5.73393 9.1875 5.42857 8.89219 5.42857 8.53125C5.42857 8.17031 5.73393 7.875 6.10714 7.875Z"
                            fill={fillColor}
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_3271_1935">
                            <rect width="19" height="21" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "APPROVE":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width={size || 24}
                    height={size || 24}
                    fill="none"
                    viewBox="0 0 32 32">
                    <path
                        stroke={fillColor || "grey"}
                        stroke-width="3"
                        d="M31 16c0 8.284-6.716 15-15 15S1 24.284 1 16 7.716 1 16 1s15 6.716 15 15z"
                    />
                    <path
                        stroke={fillColor || "grey"}
                        stroke-width="2"
                        d="m21.143 11.125.061-.081a.565.565 0 0 1 .712-.022l.607-.795-.607.795c.248.19.296.544.107.792l-7.106 9.33-.001.001a.56.56 0 0 1-.438.215h-.003a.55.55 0 0 1-.438-.21l-3.776-4.833a.556.556 0 1 1 .878-.686l.001.001 2.534 3.28.8 1.035.789-1.044z"
                    />
                </svg>
            )
        case "DIALPAD":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={fillColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={className}>
                    <circle cx="12" cy="5" r="1" />
                    <circle cx="19" cy="5" r="1" />
                    <circle cx="5" cy="5" r="1" />
                    <circle cx="12" cy="12" r="1" />
                    <circle cx="19" cy="12" r="1" />
                    <circle cx="5" cy="12" r="1" />
                    <circle cx="12" cy="19" r="1" />
                    <circle cx="19" cy="19" r="1" />
                    <circle cx="5" cy="19" r="1" />
                </svg>
            )

        case "SOUND_OFF":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className={className}>
                    <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <line x1="22" x2="16" y1="9" y2="15" />
                    <line x1="16" x2="22" y1="9" y2="15" />
                </svg>
            )
        case "SOUND_ON":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className={className}>
                    <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                </svg>
            )
        case "PERSON_CROSS":
            return (
                <svg
                    className={className}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 16 16">
                    <path
                        fill={color || "#000000"}
                        fill-rule="evenodd"
                        d="M9.333 4.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m2 8.666a.667.667 0 0 1-.666.667h-8A.667.667 0 0 1 2 13.333a4.667 4.667 0 0 1 9.333 0m2.747-8.195-1.885-1.885a.667.667 0 1 0-.943.943l1.885 1.885a.667.667 0 1 0 .943-.943"
                        clip-rule="evenodd"
                    />
                    <path
                        fill={color || "#000000"}
                        fill-rule="evenodd"
                        d="M14.08 4.196 12.195 6.08a.667.667 0 1 1-.943-.943l1.886-1.885a.667.667 0 1 1 .942.943z"
                        clip-rule="evenodd"
                    />
                </svg>
            )
        case "SYNC_ERROR":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 48 48"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="Layer_2" data-name="Layer 2">
                        <g id="invisible_box" data-name="invisible box">
                            <rect width="48" height="48" fill="none" />
                        </g>
                        <g id="icons_Q2" data-name="icons Q2">
                            <path d="M44,5.1V14a2,2,0,0,1-2,2H33a2,2,0,0,1-2-2.3A2.1,2.1,0,0,1,33.1,12h4.3A18,18,0,0,0,6.1,22.2a2,2,0,0,1-2,1.8h0a2,2,0,0,1-2-2.2A22,22,0,0,1,40,8.9V5a2,2,0,0,1,2.3-2A2.1,2.1,0,0,1,44,5.1Z" />
                            <path d="M4,42.9V34a2,2,0,0,1,2-2h9a2,2,0,0,1,2,2.3A2.1,2.1,0,0,1,14.9,36H10.6A18,18,0,0,0,41.9,25.8a2,2,0,0,1,2-1.8h0a2,2,0,0,1,2,2.2A22,22,0,0,1,8,39.1V43a2,2,0,0,1-2.3,2A2.1,2.1,0,0,1,4,42.9Z" />
                            <path d="M24,28a2,2,0,0,0,2-2V16a2,2,0,0,0-4,0V26A2,2,0,0,0,24,28Z" />
                            <circle cx="24" cy="32" r="2" />
                        </g>
                    </g>
                </svg>
            )
        default:
            return null
    }
}
